//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface ISivaClusterDetailsService {
  /**
   * Get siva cluster details, create if not exists
   * @param getWithTargetNumbers (optional)
   * @return Siva cluster details
   */
  getDetails(year: number, getWithTargetNumbers?: boolean | undefined): Promise<SivaClusterDetailsDto>;

  /**
   * Submit goals
   * @return Submitted goals
   */
  submit(sivaClusterDetailsId: string): Promise<SivaClusterDetailsDto>;

  /**
   * Calculate total goal accomplishment
   * @return Calculated total goal accomplishment
   */
  calculateTotalGoalAccomplishment(year: number): Promise<number>;

  reportingDone(year: number, reportingDone?: boolean | undefined): Promise<void>;
}

export class SivaClusterDetailsService implements ISivaClusterDetailsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get siva cluster details, create if not exists
   * @param getWithTargetNumbers (optional)
   * @return Siva cluster details
   */
  getDetails(year: number, getWithTargetNumbers?: boolean | undefined): Promise<SivaClusterDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaClusterDetails/{year}?';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (getWithTargetNumbers === null)
      throw new Error("The parameter 'getWithTargetNumbers' cannot be null.");
    else if (getWithTargetNumbers !== undefined)
      url_ += 'getWithTargetNumbers=' + encodeURIComponent('' + getWithTargetNumbers) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDetails(_response);
    });
  }

  protected processGetDetails(response: Response): Promise<SivaClusterDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaClusterDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaClusterDetailsDto>(null as any);
  }

  /**
   * Submit goals
   * @return Submitted goals
   */
  submit(sivaClusterDetailsId: string): Promise<SivaClusterDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaClusterDetails/{sivaClusterDetailsId}/submit';
    if (sivaClusterDetailsId === undefined || sivaClusterDetailsId === null)
      throw new Error("The parameter 'sivaClusterDetailsId' must be defined.");
    url_ = url_.replace('{sivaClusterDetailsId}', encodeURIComponent('' + sivaClusterDetailsId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSubmit(_response);
    });
  }

  protected processSubmit(response: Response): Promise<SivaClusterDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaClusterDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaClusterDetailsDto>(null as any);
  }

  /**
   * Calculate total goal accomplishment
   * @return Calculated total goal accomplishment
   */
  calculateTotalGoalAccomplishment(year: number): Promise<number> {
    let url_ = this.baseUrl + '/api/v2/SivaClusterDetails/{year}/total-goal-accomplishment';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCalculateTotalGoalAccomplishment(_response);
    });
  }

  protected processCalculateTotalGoalAccomplishment(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  reportingDone(year: number, reportingDone?: boolean | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/SivaClusterDetails/{year}/reporting-done?';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (reportingDone === null) throw new Error("The parameter 'reportingDone' cannot be null.");
    else if (reportingDone !== undefined)
      url_ += 'reportingDone=' + encodeURIComponent('' + reportingDone) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processReportingDone(_response);
    });
  }

  protected processReportingDone(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 520) {
      return response.text().then((_responseText) => {
        return throwException('A server side error occurred.', status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface ISivaService {
  getBudgetList(): Promise<SivaBudgetAttachmentDto[]>;

  budgetUpload(
    type?: SivaBudgetAttachmentType | undefined,
    year?: number | undefined,
    file?: FileParameter | null | undefined,
  ): Promise<SivaBudgetAttachmentDto>;

  budgetDownload(attachmentId: string): Promise<FileResponse>;

  budgetDelete(attachmentId: string): Promise<void>;

  getSivaContracts(sivaPhases?: SivaPhase[] | undefined): Promise<SivaContractOverviewDto[]>;

  createSivaContract(record: SivaContractCreateDto): Promise<SivaContractOverviewDto>;

  updateSivaContract(record: SivaContractUpdateDto): Promise<void>;

  getSivaContractDetails(numericId: number): Promise<SivaContractsDetailDto>;

  deleteSivaContract(numericId: number): Promise<void>;

  findSivaContractDetails(
    clusterMemberId?: string | null | undefined,
    organizationNumber?: string | null | undefined,
    oneWayInOpportunityId?: string | null | undefined,
  ): Promise<SivaContractsDetailDto>;

  getSivaContractsAllData(
    sivaProgramAdmin?: boolean | undefined,
    year?: number | null | undefined,
  ): Promise<FileResponse>;

  getSivaContractsKtuData(sivaProgramAdmin?: boolean | undefined): Promise<FileResponse>;

  batchUpdatePhase(
    numericIds: number[],
    phase?: SivaPhase | undefined,
    fromDate?: Date | undefined,
  ): Promise<OperationResultOfSivaContractBatchUpdatePhaseDto[]>;

  revertSivaContract(numericId: number): Promise<void>;

  getEarliestKtuStartupFormDate(sivaContractFromDate?: Date | undefined): Promise<Date>;

  getOpenReportingYears(): Promise<number[]>;

  setOpenReportingYears(dto: SetOpenReportingYearsDto): Promise<boolean>;
}

export class SivaService implements ISivaService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getBudgetList(): Promise<SivaBudgetAttachmentDto[]> {
    let url_ = this.baseUrl + '/api/v2/Siva/budget';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBudgetList(_response);
    });
  }

  protected processGetBudgetList(response: Response): Promise<SivaBudgetAttachmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaBudgetAttachmentDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaBudgetAttachmentDto[]>(null as any);
  }

  budgetUpload(
    type?: SivaBudgetAttachmentType | undefined,
    year?: number | undefined,
    file?: FileParameter | null | undefined,
  ): Promise<SivaBudgetAttachmentDto> {
    let url_ = this.baseUrl + '/api/v2/Siva/budget/upload?';
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBudgetUpload(_response);
    });
  }

  protected processBudgetUpload(response: Response): Promise<SivaBudgetAttachmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaBudgetAttachmentDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 422) {
      return response.text().then((_responseText) => {
        let result422: any = null;
        result422 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result422);
      });
    } else if (status === 502) {
      return response.text().then((_responseText) => {
        let result502: any = null;
        result502 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result502);
      });
    } else if (status === 503) {
      return response.text().then((_responseText) => {
        let result503: any = null;
        result503 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result503);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaBudgetAttachmentDto>(null as any);
  }

  budgetDownload(attachmentId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Siva/budget/download/{attachmentId}';
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBudgetDownload(_response);
    });
  }

  protected processBudgetDownload(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  budgetDelete(attachmentId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Siva/budget/delete/{attachmentId}';
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBudgetDelete(_response);
    });
  }

  protected processBudgetDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getSivaContracts(sivaPhases?: SivaPhase[] | undefined): Promise<SivaContractOverviewDto[]> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts?';
    if (sivaPhases === null) throw new Error("The parameter 'sivaPhases' cannot be null.");
    else if (sivaPhases !== undefined)
      sivaPhases &&
        sivaPhases.forEach((item) => {
          url_ += 'sivaPhases=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaContracts(_response);
    });
  }

  protected processGetSivaContracts(response: Response): Promise<SivaContractOverviewDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaContractOverviewDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaContractOverviewDto[]>(null as any);
  }

  createSivaContract(record: SivaContractCreateDto): Promise<SivaContractOverviewDto> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateSivaContract(_response);
    });
  }

  protected processCreateSivaContract(response: Response): Promise<SivaContractOverviewDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaContractOverviewDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaContractOverviewDto>(null as any);
  }

  updateSivaContract(record: SivaContractUpdateDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateSivaContract(_response);
    });
  }

  protected processUpdateSivaContract(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getSivaContractDetails(numericId: number): Promise<SivaContractsDetailDto> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts/{numericId}';
    if (numericId === undefined || numericId === null)
      throw new Error("The parameter 'numericId' must be defined.");
    url_ = url_.replace('{numericId}', encodeURIComponent('' + numericId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaContractDetails(_response);
    });
  }

  protected processGetSivaContractDetails(response: Response): Promise<SivaContractsDetailDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaContractsDetailDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaContractsDetailDto>(null as any);
  }

  deleteSivaContract(numericId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts/{numericId}';
    if (numericId === undefined || numericId === null)
      throw new Error("The parameter 'numericId' must be defined.");
    url_ = url_.replace('{numericId}', encodeURIComponent('' + numericId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteSivaContract(_response);
    });
  }

  protected processDeleteSivaContract(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  findSivaContractDetails(
    clusterMemberId?: string | null | undefined,
    organizationNumber?: string | null | undefined,
    oneWayInOpportunityId?: string | null | undefined,
  ): Promise<SivaContractsDetailDto> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts/find?';
    if (clusterMemberId !== undefined && clusterMemberId !== null)
      url_ += 'clusterMemberId=' + encodeURIComponent('' + clusterMemberId) + '&';
    if (organizationNumber !== undefined && organizationNumber !== null)
      url_ += 'organizationNumber=' + encodeURIComponent('' + organizationNumber) + '&';
    if (oneWayInOpportunityId !== undefined && oneWayInOpportunityId !== null)
      url_ += 'oneWayInOpportunityId=' + encodeURIComponent('' + oneWayInOpportunityId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processFindSivaContractDetails(_response);
    });
  }

  protected processFindSivaContractDetails(response: Response): Promise<SivaContractsDetailDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaContractsDetailDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaContractsDetailDto>(null as any);
  }

  getSivaContractsAllData(
    sivaProgramAdmin?: boolean | undefined,
    year?: number | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts/alldata?';
    if (sivaProgramAdmin === null) throw new Error("The parameter 'sivaProgramAdmin' cannot be null.");
    else if (sivaProgramAdmin !== undefined)
      url_ += 'sivaProgramAdmin=' + encodeURIComponent('' + sivaProgramAdmin) + '&';
    if (year !== undefined && year !== null) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaContractsAllData(_response);
    });
  }

  protected processGetSivaContractsAllData(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getSivaContractsKtuData(sivaProgramAdmin?: boolean | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Siva/contracts/ktudata?';
    if (sivaProgramAdmin === null) throw new Error("The parameter 'sivaProgramAdmin' cannot be null.");
    else if (sivaProgramAdmin !== undefined)
      url_ += 'sivaProgramAdmin=' + encodeURIComponent('' + sivaProgramAdmin) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaContractsKtuData(_response);
    });
  }

  protected processGetSivaContractsKtuData(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  batchUpdatePhase(
    numericIds: number[],
    phase?: SivaPhase | undefined,
    fromDate?: Date | undefined,
  ): Promise<OperationResultOfSivaContractBatchUpdatePhaseDto[]> {
    let url_ = this.baseUrl + '/api/v2/Siva/batch-update-phase?';
    if (phase === null) throw new Error("The parameter 'phase' cannot be null.");
    else if (phase !== undefined) url_ += 'phase=' + encodeURIComponent('' + phase) + '&';
    if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ += 'fromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(numericIds);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBatchUpdatePhase(_response);
    });
  }

  protected processBatchUpdatePhase(
    response: Response,
  ): Promise<OperationResultOfSivaContractBatchUpdatePhaseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as OperationResultOfSivaContractBatchUpdatePhaseDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfSivaContractBatchUpdatePhaseDto[]>(null as any);
  }

  revertSivaContract(numericId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Siva/revert/{numericId}';
    if (numericId === undefined || numericId === null)
      throw new Error("The parameter 'numericId' must be defined.");
    url_ = url_.replace('{numericId}', encodeURIComponent('' + numericId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRevertSivaContract(_response);
    });
  }

  protected processRevertSivaContract(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getEarliestKtuStartupFormDate(sivaContractFromDate?: Date | undefined): Promise<Date> {
    let url_ = this.baseUrl + '/api/v2/Siva/earliestKtuStartupFormDate?';
    if (sivaContractFromDate === null)
      throw new Error("The parameter 'sivaContractFromDate' cannot be null.");
    else if (sivaContractFromDate !== undefined)
      url_ +=
        'sivaContractFromDate=' +
        encodeURIComponent(sivaContractFromDate ? '' + sivaContractFromDate.toISOString() : '') +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEarliestKtuStartupFormDate(_response);
    });
  }

  protected processGetEarliestKtuStartupFormDate(response: Response): Promise<Date> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Date);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Date>(null as any);
  }

  getOpenReportingYears(): Promise<number[]> {
    let url_ = this.baseUrl + '/api/v2/Siva/openReportingYears';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOpenReportingYears(_response);
    });
  }

  protected processGetOpenReportingYears(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(null as any);
  }

  setOpenReportingYears(dto: SetOpenReportingYearsDto): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/Siva/openReportingYears';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetOpenReportingYears(_response);
    });
  }

  protected processSetOpenReportingYears(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }
}

export interface ISivaPhaseService {
  getPhases(): Promise<SivaPhaseDto[]>;

  getAvailablePhasesForContract(numericId: number): Promise<SivaPhase[]>;

  getAvailablePhasesForCompany(organizationNumber: string): Promise<SivaPhase[]>;
}

export class SivaPhaseService implements ISivaPhaseService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getPhases(): Promise<SivaPhaseDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaPhase/list';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPhases(_response);
    });
  }

  protected processGetPhases(response: Response): Promise<SivaPhaseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SivaPhaseDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaPhaseDto[]>(null as any);
  }

  getAvailablePhasesForContract(numericId: number): Promise<SivaPhase[]> {
    let url_ = this.baseUrl + '/api/v2/SivaPhase/siva-contracts/{numericId}/available-phases';
    if (numericId === undefined || numericId === null)
      throw new Error("The parameter 'numericId' must be defined.");
    url_ = url_.replace('{numericId}', encodeURIComponent('' + numericId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAvailablePhasesForContract(_response);
    });
  }

  protected processGetAvailablePhasesForContract(response: Response): Promise<SivaPhase[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SivaPhase[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaPhase[]>(null as any);
  }

  getAvailablePhasesForCompany(organizationNumber: string): Promise<SivaPhase[]> {
    let url_ = this.baseUrl + '/api/v2/SivaPhase/companies/{organizationNumber}/available-phases';
    if (organizationNumber === undefined || organizationNumber === null)
      throw new Error("The parameter 'organizationNumber' must be defined.");
    url_ = url_.replace('{organizationNumber}', encodeURIComponent('' + organizationNumber));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAvailablePhasesForCompany(_response);
    });
  }

  protected processGetAvailablePhasesForCompany(response: Response): Promise<SivaPhase[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SivaPhase[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaPhase[]>(null as any);
  }
}

export interface IClusterContactsService {
  /**
   * Get Single Contact
   */
  getContact(contactId: string): Promise<ClusterContactDto>;

  updateContact(contactId: string, record: ClusterContactUpdateDto): Promise<ClusterContactDto>;

  /**
   * Get all Contacts in a Cluster
   * @param clusterMemberId (optional)
   * @param jobTitle (optional)
   * @param status (optional)
   * @param emailAddress (optional)
   * @param isClusterMemberMainContact (optional)
   */
  getClusterContacts(
    clusterMemberId?: string | null | undefined,
    jobTitle?: string | null | undefined,
    status?: ClusterContactStatus | null | undefined,
    emailAddress?: string | null | undefined,
    isClusterMemberMainContact?: boolean | undefined,
  ): Promise<ClusterContactDto[]>;

  getClusterContactsV21(
    top?: number | null | undefined,
    skip?: number | null | undefined,
    expand?: string | undefined,
    filter?: string | undefined,
    orderBy?: string | undefined,
    inlineCount?: string | undefined,
  ): Promise<ODataResponseOfClusterContactDto>;

  /**
   * Get board members in a cluster
   */
  getClusterBoardMembers(): Promise<ClusterContactDto[]>;

  /**
   * Create Contact
   */
  create(record: ClusterContactCreateDto[]): Promise<OperationResultOfClusterContactDto[]>;

  /**
   * Delete Contact
   */
  delete(clusterContactIds: string[]): Promise<OperationResultOfGuid[]>;

  /**
   * Create Multiple Contact
   */
  createList(records: ClusterContactCreateDto[]): Promise<OperationResultOfClusterContactDto[]>;

  /**
   * Create Multiple Contact
   */
  createListToClusterMember(
    clusterMemberId: string,
    records: ClusterContactCreateDto[],
  ): Promise<OperationResultOfClusterContactDto[]>;

  /**
   * Check if email is not is use in this cluster
   */
  checkEmailAvailability(email: string): Promise<boolean>;

  /**
   * Get Contacts linked to ClusterMember
   */
  getClusterMemberContacts(clusterMemberId: string): Promise<ClusterContactDto[]>;

  approveLeadsToMembers(clusterContactIds: string[]): Promise<void>;
}

export class ClusterContactsService implements IClusterContactsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get Single Contact
   */
  getContact(contactId: string): Promise<ClusterContactDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/{contactId}';
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetContact(_response);
    });
  }

  protected processGetContact(response: Response): Promise<ClusterContactDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto>(null as any);
  }

  updateContact(contactId: string, record: ClusterContactUpdateDto): Promise<ClusterContactDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/{contactId}';
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateContact(_response);
    });
  }

  protected processUpdateContact(response: Response): Promise<ClusterContactDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto>(null as any);
  }

  /**
   * Get all Contacts in a Cluster
   * @param clusterMemberId (optional)
   * @param jobTitle (optional)
   * @param status (optional)
   * @param emailAddress (optional)
   * @param isClusterMemberMainContact (optional)
   */
  getClusterContacts(
    clusterMemberId?: string | null | undefined,
    jobTitle?: string | null | undefined,
    status?: ClusterContactStatus | null | undefined,
    emailAddress?: string | null | undefined,
    isClusterMemberMainContact?: boolean | undefined,
  ): Promise<ClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/cluster?';
    if (clusterMemberId !== undefined && clusterMemberId !== null)
      url_ += 'ClusterMemberId=' + encodeURIComponent('' + clusterMemberId) + '&';
    if (jobTitle !== undefined && jobTitle !== null)
      url_ += 'JobTitle=' + encodeURIComponent('' + jobTitle) + '&';
    if (status !== undefined && status !== null) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (emailAddress !== undefined && emailAddress !== null)
      url_ += 'EmailAddress=' + encodeURIComponent('' + emailAddress) + '&';
    if (isClusterMemberMainContact === null)
      throw new Error("The parameter 'isClusterMemberMainContact' cannot be null.");
    else if (isClusterMemberMainContact !== undefined)
      url_ += 'IsClusterMemberMainContact=' + encodeURIComponent('' + isClusterMemberMainContact) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterContacts(_response);
    });
  }

  protected processGetClusterContacts(response: Response): Promise<ClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto[]>(null as any);
  }

  getClusterContactsV21(
    top?: number | null | undefined,
    skip?: number | null | undefined,
    expand?: string | undefined,
    filter?: string | undefined,
    orderBy?: string | undefined,
    inlineCount?: string | undefined,
  ): Promise<ODataResponseOfClusterContactDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/cluster/odata?';
    if (top !== undefined && top !== null) url_ += 'Top=' + encodeURIComponent('' + top) + '&';
    if (skip !== undefined && skip !== null) url_ += 'Skip=' + encodeURIComponent('' + skip) + '&';
    if (expand === null) throw new Error("The parameter 'expand' cannot be null.");
    else if (expand !== undefined) url_ += 'Expand=' + encodeURIComponent('' + expand) + '&';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (orderBy === null) throw new Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (inlineCount === null) throw new Error("The parameter 'inlineCount' cannot be null.");
    else if (inlineCount !== undefined) url_ += 'InlineCount=' + encodeURIComponent('' + inlineCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterContactsV21(_response);
    });
  }

  protected processGetClusterContactsV21(response: Response): Promise<ODataResponseOfClusterContactDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ODataResponseOfClusterContactDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ODataResponseOfClusterContactDto>(null as any);
  }

  /**
   * Get board members in a cluster
   */
  getClusterBoardMembers(): Promise<ClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/cluster/board-members';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterBoardMembers(_response);
    });
  }

  protected processGetClusterBoardMembers(response: Response): Promise<ClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto[]>(null as any);
  }

  /**
   * Create Contact
   */
  create(record: ClusterContactCreateDto[]): Promise<OperationResultOfClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<OperationResultOfClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfClusterContactDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfClusterContactDto[]>(null as any);
  }

  /**
   * Delete Contact
   */
  delete(clusterContactIds: string[]): Promise<OperationResultOfGuid[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterContactIds);

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<OperationResultOfGuid[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfGuid[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfGuid[]>(null as any);
  }

  /**
   * Create Multiple Contact
   */
  createList(records: ClusterContactCreateDto[]): Promise<OperationResultOfClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/list';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(records);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateList(_response);
    });
  }

  protected processCreateList(response: Response): Promise<OperationResultOfClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfClusterContactDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfClusterContactDto[]>(null as any);
  }

  /**
   * Create Multiple Contact
   */
  createListToClusterMember(
    clusterMemberId: string,
    records: ClusterContactCreateDto[],
  ): Promise<OperationResultOfClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/list/member/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(records);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateListToClusterMember(_response);
    });
  }

  protected processCreateListToClusterMember(
    response: Response,
  ): Promise<OperationResultOfClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfClusterContactDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfClusterContactDto[]>(null as any);
  }

  /**
   * Check if email is not is use in this cluster
   */
  checkEmailAvailability(email: string): Promise<boolean> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/cluster/check-email-availability/{email}';
    if (email === undefined || email === null) throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace('{email}', encodeURIComponent('' + email));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCheckEmailAvailability(_response);
    });
  }

  protected processCheckEmailAvailability(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * Get Contacts linked to ClusterMember
   */
  getClusterMemberContacts(clusterMemberId: string): Promise<ClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/cluster/cluster-member/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterMemberContacts(_response);
    });
  }

  protected processGetClusterMemberContacts(response: Response): Promise<ClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto[]>(null as any);
  }

  approveLeadsToMembers(clusterContactIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterContacts/approve-members';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterContactIds);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApproveLeadsToMembers(_response);
    });
  }

  protected processApproveLeadsToMembers(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IClusterMembersService {
  getAll(
    international?: boolean | null | undefined,
    isActive?: boolean | null | undefined,
    organizationNumber?: string | null | undefined,
  ): Promise<ClusterMemberDto[]>;

  /**
   * @deprecated
   */
  create(record: ClusterMemberCreateDto): Promise<ClusterMemberDto>;

  getSingle(clusterMemberId: string): Promise<ClusterMemberDto>;

  update(clusterMemberId: string, record: ClusterMemberUpdateDto): Promise<ClusterMemberDto>;

  delete(clusterMemberId: string): Promise<void>;

  getTypes(): Promise<ClusterMemberTypeDto[]>;

  getCategories(): Promise<ClusterMemberCategoryDto[]>;
}

export class ClusterMembersService implements IClusterMembersService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getAll(
    international?: boolean | null | undefined,
    isActive?: boolean | null | undefined,
    organizationNumber?: string | null | undefined,
  ): Promise<ClusterMemberDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/cluster?';
    if (international !== undefined && international !== null)
      url_ += 'international=' + encodeURIComponent('' + international) + '&';
    if (isActive !== undefined && isActive !== null)
      url_ += 'isActive=' + encodeURIComponent('' + isActive) + '&';
    if (organizationNumber !== undefined && organizationNumber !== null)
      url_ += 'organizationNumber=' + encodeURIComponent('' + organizationNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAll(_response);
    });
  }

  protected processGetAll(response: Response): Promise<ClusterMemberDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberDto[]>(null as any);
  }

  /**
   * @deprecated
   */
  create(record: ClusterMemberCreateDto): Promise<ClusterMemberDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<ClusterMemberDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberDto);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberDto>(null as any);
  }

  getSingle(clusterMemberId: string): Promise<ClusterMemberDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/{clusterMemberId}/member';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSingle(_response);
    });
  }

  protected processGetSingle(response: Response): Promise<ClusterMemberDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberDto>(null as any);
  }

  update(clusterMemberId: string, record: ClusterMemberUpdateDto): Promise<ClusterMemberDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<ClusterMemberDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberDto>(null as any);
  }

  delete(clusterMemberId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getTypes(): Promise<ClusterMemberTypeDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/types';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTypes(_response);
    });
  }

  protected processGetTypes(response: Response): Promise<ClusterMemberTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberTypeDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberTypeDto[]>(null as any);
  }

  getCategories(): Promise<ClusterMemberCategoryDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMembers/categories';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCategories(_response);
    });
  }

  protected processGetCategories(response: Response): Promise<ClusterMemberCategoryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberCategoryDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberCategoryDto[]>(null as any);
  }
}

export interface IClustersService {
  getAll(): Promise<ClusterDto[]>;

  getSingle(clusterId: string): Promise<ClusterDto>;

  update(clusterId: string, record: ClusterUpdateDto): Promise<ClusterDto>;

  delete(clusterId: string): Promise<void>;

  getCurrent(): Promise<ClusterDto>;

  getMyClusters(): Promise<ClusterDto[]>;

  getClusterMemberFees(clusterId: string): Promise<ClusterMemberFeeDto[]>;

  createClusterMemberFee(clusterId: string, record: ClusterMemberFeeCreateDto): Promise<ClusterMemberFeeDto>;

  updateClusterMemberFee(
    clusterMemberFeeId: string,
    record: ClusterMemberFeeUpdateDto,
  ): Promise<ClusterMemberFeeDto>;

  deleteClusterMemberFee(clusterMemberFeeId: string): Promise<string>;

  getClusterStatistics(clusterId: string, year?: number | null | undefined): Promise<ClusterStatisticsDto>;

  getExternalServiceProviderDetails(providerId: string): Promise<ClusterDto>;

  getBySearchCriteria(clusterSearchCriteria: ClusterSearchCriteria): Promise<ClusterListDto[]>;
}

export class ClustersService implements IClustersService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getAll(): Promise<ClusterDto[]> {
    let url_ = this.baseUrl + '/api/v2/Clusters';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAll(_response);
    });
  }

  protected processGetAll(response: Response): Promise<ClusterDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto[]>(null as any);
  }

  getSingle(clusterId: string): Promise<ClusterDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSingle(_response);
    });
  }

  protected processGetSingle(response: Response): Promise<ClusterDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto>(null as any);
  }

  update(clusterId: string, record: ClusterUpdateDto): Promise<ClusterDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<ClusterDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto>(null as any);
  }

  delete(clusterId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getCurrent(): Promise<ClusterDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/current';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCurrent(_response);
    });
  }

  protected processGetCurrent(response: Response): Promise<ClusterDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto>(null as any);
  }

  getMyClusters(): Promise<ClusterDto[]> {
    let url_ = this.baseUrl + '/api/v2/Clusters/mine';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetMyClusters(_response);
    });
  }

  protected processGetMyClusters(response: Response): Promise<ClusterDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto[]>(null as any);
  }

  getClusterMemberFees(clusterId: string): Promise<ClusterMemberFeeDto[]> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}/fees';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterMemberFees(_response);
    });
  }

  protected processGetClusterMemberFees(response: Response): Promise<ClusterMemberFeeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberFeeDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberFeeDto[]>(null as any);
  }

  createClusterMemberFee(clusterId: string, record: ClusterMemberFeeCreateDto): Promise<ClusterMemberFeeDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}/fees';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterMemberFee(_response);
    });
  }

  protected processCreateClusterMemberFee(response: Response): Promise<ClusterMemberFeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberFeeDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberFeeDto>(null as any);
  }

  updateClusterMemberFee(
    clusterMemberFeeId: string,
    record: ClusterMemberFeeUpdateDto,
  ): Promise<ClusterMemberFeeDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/fees/{clusterMemberFeeId}';
    if (clusterMemberFeeId === undefined || clusterMemberFeeId === null)
      throw new Error("The parameter 'clusterMemberFeeId' must be defined.");
    url_ = url_.replace('{clusterMemberFeeId}', encodeURIComponent('' + clusterMemberFeeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateClusterMemberFee(_response);
    });
  }

  protected processUpdateClusterMemberFee(response: Response): Promise<ClusterMemberFeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberFeeDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberFeeDto>(null as any);
  }

  deleteClusterMemberFee(clusterMemberFeeId: string): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Clusters/fees/{clusterMemberFeeId}';
    if (clusterMemberFeeId === undefined || clusterMemberFeeId === null)
      throw new Error("The parameter 'clusterMemberFeeId' must be defined.");
    url_ = url_.replace('{clusterMemberFeeId}', encodeURIComponent('' + clusterMemberFeeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterMemberFee(_response);
    });
  }

  protected processDeleteClusterMemberFee(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  getClusterStatistics(clusterId: string, year?: number | null | undefined): Promise<ClusterStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/{clusterId}/statistics?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (year !== undefined && year !== null) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterStatistics(_response);
    });
  }

  protected processGetClusterStatistics(response: Response): Promise<ClusterStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterStatisticsDto>(null as any);
  }

  getExternalServiceProviderDetails(providerId: string): Promise<ClusterDto> {
    let url_ = this.baseUrl + '/api/v2/Clusters/providers/{providerId}';
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetExternalServiceProviderDetails(_response);
    });
  }

  protected processGetExternalServiceProviderDetails(response: Response): Promise<ClusterDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto>(null as any);
  }

  getBySearchCriteria(clusterSearchCriteria: ClusterSearchCriteria): Promise<ClusterListDto[]> {
    let url_ = this.baseUrl + '/api/v2/Clusters/by-search-criteria';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterSearchCriteria);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBySearchCriteria(_response);
    });
  }

  protected processGetBySearchCriteria(response: Response): Promise<ClusterListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterListDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterListDto[]>(null as any);
  }
}

export interface IClusterUsersService {
  getCurrentClusterUser(): Promise<ClusterUserDto>;

  getContact(clusterUserId: string): Promise<ClusterUserDto>;

  update(clusterUserId: string, updateDto: ClusterUserUpdateDto): Promise<ClusterUserDto>;

  delete(clusterUserId: string): Promise<FileResponse>;

  getClusterUsers(): Promise<ClusterUserDto[]>;

  create(createDto: ClusterUserCreateDto): Promise<ClusterUserDto>;

  invite(clusterUsersInviteDto: ClusterUsersInviteDto): Promise<FileResponse>;

  accept(invitationCode: string): Promise<FileResponse>;
}

export class ClusterUsersService implements IClusterUsersService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getCurrentClusterUser(): Promise<ClusterUserDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/current';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCurrentClusterUser(_response);
    });
  }

  protected processGetCurrentClusterUser(response: Response): Promise<ClusterUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterUserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterUserDto>(null as any);
  }

  getContact(clusterUserId: string): Promise<ClusterUserDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/{clusterUserId}';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetContact(_response);
    });
  }

  protected processGetContact(response: Response): Promise<ClusterUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterUserDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterUserDto>(null as any);
  }

  update(clusterUserId: string, updateDto: ClusterUserUpdateDto): Promise<ClusterUserDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/{clusterUserId}';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<ClusterUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterUserDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterUserDto>(null as any);
  }

  delete(clusterUserId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/{clusterUserId}';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getClusterUsers(): Promise<ClusterUserDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterUsers(_response);
    });
  }

  protected processGetClusterUsers(response: Response): Promise<ClusterUserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterUserDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterUserDto[]>(null as any);
  }

  create(createDto: ClusterUserCreateDto): Promise<ClusterUserDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<ClusterUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterUserDto);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterUserDto>(null as any);
  }

  invite(clusterUsersInviteDto: ClusterUsersInviteDto): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/invite';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterUsersInviteDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processInvite(_response);
    });
  }

  protected processInvite(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  accept(invitationCode: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterUsers/accept/{invitationCode}';
    if (invitationCode === undefined || invitationCode === null)
      throw new Error("The parameter 'invitationCode' must be defined.");
    url_ = url_.replace('{invitationCode}', encodeURIComponent('' + invitationCode));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAccept(_response);
    });
  }

  protected processAccept(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export interface IExternalService {
  getNace(naceCode: string): Promise<NaceCode>;

  getNaces(): Promise<NaceCode[]>;

  getZipCode(zipCode: string): Promise<ZipDto>;

  getCompanyFromBrreg(orgNr: string): Promise<CustomerInfoDto>;

  getAccountingData(orgNr: string): Promise<AccountingData[]>;
}

export class ExternalService implements IExternalService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getNace(naceCode: string): Promise<NaceCode> {
    let url_ = this.baseUrl + '/api/v2/External/nace/{naceCode}';
    if (naceCode === undefined || naceCode === null)
      throw new Error("The parameter 'naceCode' must be defined.");
    url_ = url_.replace('{naceCode}', encodeURIComponent('' + naceCode));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetNace(_response);
    });
  }

  protected processGetNace(response: Response): Promise<NaceCode> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as NaceCode);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<NaceCode>(null as any);
  }

  getNaces(): Promise<NaceCode[]> {
    let url_ = this.baseUrl + '/api/v2/External/naces';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetNaces(_response);
    });
  }

  protected processGetNaces(response: Response): Promise<NaceCode[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as NaceCode[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<NaceCode[]>(null as any);
  }

  getZipCode(zipCode: string): Promise<ZipDto> {
    let url_ = this.baseUrl + '/api/v2/External/zip-code/{zipCode}';
    if (zipCode === undefined || zipCode === null)
      throw new Error("The parameter 'zipCode' must be defined.");
    url_ = url_.replace('{zipCode}', encodeURIComponent('' + zipCode));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetZipCode(_response);
    });
  }

  protected processGetZipCode(response: Response): Promise<ZipDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ZipDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ZipDto>(null as any);
  }

  getCompanyFromBrreg(orgNr: string): Promise<CustomerInfoDto> {
    let url_ = this.baseUrl + '/api/v2/External/bbreg/{orgNr}';
    if (orgNr === undefined || orgNr === null) throw new Error("The parameter 'orgNr' must be defined.");
    url_ = url_.replace('{orgNr}', encodeURIComponent('' + orgNr));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCompanyFromBrreg(_response);
    });
  }

  protected processGetCompanyFromBrreg(response: Response): Promise<CustomerInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomerInfoDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomerInfoDto>(null as any);
  }

  getAccountingData(orgNr: string): Promise<AccountingData[]> {
    let url_ = this.baseUrl + '/api/v2/External/accounting-data/{orgNr}';
    if (orgNr === undefined || orgNr === null) throw new Error("The parameter 'orgNr' must be defined.");
    url_ = url_.replace('{orgNr}', encodeURIComponent('' + orgNr));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAccountingData(_response);
    });
  }

  protected processGetAccountingData(response: Response): Promise<AccountingData[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as AccountingData[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AccountingData[]>(null as any);
  }
}

export interface IInterestAreaService {
  getInterestAreaList(clusterId: string): Promise<InterestAreaDto[]>;

  getInterestArea(interestAreaId: string): Promise<InterestAreaDto>;

  updateInterestArea(interestAreaId: string, interestArea: InterestAreaUpdateDto): Promise<InterestAreaDto>;

  deleteInterestArea(interestAreaId: string): Promise<void>;

  createInterestArea(interestArea: InterestAreaCreateDto): Promise<InterestAreaDto>;
}

export class InterestAreaService implements IInterestAreaService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getInterestAreaList(clusterId: string): Promise<InterestAreaDto[]> {
    let url_ = this.baseUrl + '/api/v2/InterestArea/list/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInterestAreaList(_response);
    });
  }

  protected processGetInterestAreaList(response: Response): Promise<InterestAreaDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as InterestAreaDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<InterestAreaDto[]>(null as any);
  }

  getInterestArea(interestAreaId: string): Promise<InterestAreaDto> {
    let url_ = this.baseUrl + '/api/v2/InterestArea/{interestAreaId}';
    if (interestAreaId === undefined || interestAreaId === null)
      throw new Error("The parameter 'interestAreaId' must be defined.");
    url_ = url_.replace('{interestAreaId}', encodeURIComponent('' + interestAreaId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInterestArea(_response);
    });
  }

  protected processGetInterestArea(response: Response): Promise<InterestAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as InterestAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<InterestAreaDto>(null as any);
  }

  updateInterestArea(interestAreaId: string, interestArea: InterestAreaUpdateDto): Promise<InterestAreaDto> {
    let url_ = this.baseUrl + '/api/v2/InterestArea/{interestAreaId}';
    if (interestAreaId === undefined || interestAreaId === null)
      throw new Error("The parameter 'interestAreaId' must be defined.");
    url_ = url_.replace('{interestAreaId}', encodeURIComponent('' + interestAreaId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(interestArea);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateInterestArea(_response);
    });
  }

  protected processUpdateInterestArea(response: Response): Promise<InterestAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as InterestAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<InterestAreaDto>(null as any);
  }

  deleteInterestArea(interestAreaId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/InterestArea/{interestAreaId}';
    if (interestAreaId === undefined || interestAreaId === null)
      throw new Error("The parameter 'interestAreaId' must be defined.");
    url_ = url_.replace('{interestAreaId}', encodeURIComponent('' + interestAreaId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteInterestArea(_response);
    });
  }

  protected processDeleteInterestArea(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  createInterestArea(interestArea: InterestAreaCreateDto): Promise<InterestAreaDto> {
    let url_ = this.baseUrl + '/api/v2/InterestArea';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(interestArea);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateInterestArea(_response);
    });
  }

  protected processCreateInterestArea(response: Response): Promise<InterestAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as InterestAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<InterestAreaDto>(null as any);
  }
}

export interface IProjectActivitiesService {
  getProjectActivities(projectId: string): Promise<ProjectActivityDto[]>;

  postProjectActivity(activity: ProjectActivityCreateDto): Promise<ProjectActivityDto>;

  deleteProjectActivity(projectActivityId: string): Promise<void>;
}

export class ProjectActivitiesService implements IProjectActivitiesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjectActivities(projectId: string): Promise<ProjectActivityDto[]> {
    let url_ = this.baseUrl + '/api/v2/ProjectActivities/list/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectActivities(_response);
    });
  }

  protected processGetProjectActivities(response: Response): Promise<ProjectActivityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectActivityDto[]>(null as any);
  }

  postProjectActivity(activity: ProjectActivityCreateDto): Promise<ProjectActivityDto> {
    let url_ = this.baseUrl + '/api/v2/ProjectActivities';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(activity);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostProjectActivity(_response);
    });
  }

  protected processPostProjectActivity(response: Response): Promise<ProjectActivityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectActivityDto>(null as any);
  }

  deleteProjectActivity(projectActivityId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ProjectActivities/{projectActivityId}';
    if (projectActivityId === undefined || projectActivityId === null)
      throw new Error("The parameter 'projectActivityId' must be defined.");
    url_ = url_.replace('{projectActivityId}', encodeURIComponent('' + projectActivityId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteProjectActivity(_response);
    });
  }

  protected processDeleteProjectActivity(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IReportAttachmentsService {
  /**
   * Create Report attachment
   * @param api_version (optional)
   * @param fieldName (optional)
   * @param file (optional)
   */
  createReportAttachment(
    reportId: string,
    api_version?: string | null | undefined,
    fieldName?: string | null | undefined,
    file?: FileParameter | null | undefined,
  ): Promise<Attachment>;

  /**
   * Get Report attachment
   * @param api_version (optional)
   */
  getReportAttachment(
    reportId: string,
    attachmentId: string,
    api_version?: string | null | undefined,
  ): Promise<FileResponse>;

  /**
   * Create Report attachment
   * @param api_version (optional)
   */
  deleteReportAttachment(
    reportId: string,
    attachmentId: string,
    api_version?: string | null | undefined,
  ): Promise<void>;
}

export class ReportAttachmentsService implements IReportAttachmentsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Create Report attachment
   * @param api_version (optional)
   * @param fieldName (optional)
   * @param file (optional)
   */
  createReportAttachment(
    reportId: string,
    api_version?: string | null | undefined,
    fieldName?: string | null | undefined,
    file?: FileParameter | null | undefined,
  ): Promise<Attachment> {
    let url_ = this.baseUrl + '/{reportId}/Attachments?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (api_version !== undefined && api_version !== null)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (fieldName !== null && fieldName !== undefined) content_.append('FieldName', fieldName.toString());
    if (file !== null && file !== undefined)
      content_.append('File', file.data, file.fileName ? file.fileName : 'File');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateReportAttachment(_response);
    });
  }

  protected processCreateReportAttachment(response: Response): Promise<Attachment> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Attachment);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Attachment>(null as any);
  }

  /**
   * Get Report attachment
   * @param api_version (optional)
   */
  getReportAttachment(
    reportId: string,
    attachmentId: string,
    api_version?: string | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/{reportId}/Attachments/{attachmentId}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    if (api_version !== undefined && api_version !== null)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetReportAttachment(_response);
    });
  }

  protected processGetReportAttachment(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Create Report attachment
   * @param api_version (optional)
   */
  deleteReportAttachment(
    reportId: string,
    attachmentId: string,
    api_version?: string | null | undefined,
  ): Promise<void> {
    let url_ = this.baseUrl + '/{reportId}/Attachments/{attachmentId}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    if (api_version !== undefined && api_version !== null)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteReportAttachment(_response);
    });
  }

  protected processDeleteReportAttachment(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IReportsService {
  /**
   * Patches Cluster Operation Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchOperationInterimReport(reportId: string, record: OperationInterimReportDto): Promise<void>;

  /**
   * Gets Cluster Operation Interim Report by id
   * @param reportId The report Id
   * @return OperationInterimReportDto
   */
  getOperationInterimReport(reportId: string): Promise<OperationInterimReportDto>;

  /**
   * Creates a new report if the report's Id is null. Updates an existing report if the report's Id is set.
   * @param report The report
   */
  upsertOperationInterimReport(report: OperationInterimReportDto): Promise<string>;

  /**
   * Gets Cluster Operation Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return OperationInterimListItemDto
   */
  getOperationInterimReportList(
    status?: FormStatus | null | undefined,
  ): Promise<OperationInterimListItemDto[]>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateOperationInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Gets Cluster Operation Interim Report General information
   * @return OperationInterimReportGeneralDto
   */
  getOperationInterimReportCreationInformationGeneral(): Promise<OperationInterimGeneralDto>;

  /**
   * Gets Cluster Operation Interim Report financial information
   * @return OperationInterimReportGeneralDto
   */
  getOperationInterimReportCreationInformationFinances(): Promise<OperationInterimFinancialDto>;

  /**
   * Gets Cluster Operation Interim Report list with attachments
   * @return A list of OperationInterimListItemDto
   */
  getArchivedOperationInterimReports(): Promise<OperationInterimListItemDto[]>;

  /**
   * Creates new report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertOperationFinalReport(report: OperationFinalReportDto): Promise<string>;

  /**
   * Gets Cluster Operation Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return OperationFinalListItemDto
   */
  getOperationFinalReportList(status?: FormStatus | null | undefined): Promise<OperationFinalListItemDto[]>;

  /**
   * Gets Cluster Operation Final Report by id
   * @param reportId The report Id
   * @return OperationFinalReportDto
   */
  getOperationFinalReport(reportId: string): Promise<OperationFinalReportDto>;

  /**
   * Patches Cluster Operation Final Report
   * @param reportId The report Id
   * @param report The report
   */
  patchOperationFinalReport(reportId: string, report: OperationFinalReportDto): Promise<void>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateOperationFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Gets Cluster Operation Final Report General information
   * @return OperationFinalReportGeneralDto
   */
  getOperationFinalReportCreationInformationGeneral(): Promise<OperationFinalGeneralDto>;

  /**
   * Gets Cluster Operation Final Report financial information
   * @return OperationFinalReportGeneralDto
   */
  getOperationFinalReportCreationInformationFinances(): Promise<OperationFinalFinancialDto>;

  /**
   * Gets Cluster Operation Final Report list with attachments
   * @return A list of OperationFinalListItemDto
   */
  getArchivedOperationFinalReports(): Promise<OperationFinalListItemDto[]>;

  /**
   * Gets Cluster Basis Interim Report General information
   * @return BasisInterimReportGeneralDto
   */
  getBasisInterimReportCreationInformationGeneral(): Promise<BasisInterimReportGeneralDto>;

  /**
   * Patches Cluster Basis Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchBasisInterimReport(reportId: string, record: BasisInterimReportDto): Promise<void>;

  /**
   * Gets Cluster Basis Interim Report by id
   * @param reportId The report Id
   * @return BasisInterimReportDto
   */
  getBasisInterimReport(reportId: string): Promise<BasisInterimReportDto>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateBasisInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Creates new Basis Interim Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertBasisInterimReport(report: BasisInterimReportDto): Promise<string>;

  /**
   * Gets Basis Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of BasisInterimListItemDto
   */
  getBasisInterimReportList(status?: FormStatus | null | undefined): Promise<BasisInterimListItemDto[]>;

  /**
   * Gets Cluster Basis Interim Report list with attachments
   * @return A list of BasisInterimListItemDto
   */
  getArchivedBasisInterimReports(): Promise<BasisInterimListItemDto[]>;

  /**
   * Gets Cluster Basis Final Report information
   * @return BasisFinalReportCreationDto
   */
  getBasisFinalReportCreationInformation(): Promise<BasisFinalReportCreationDto>;

  /**
   * Patches Cluster Basis Final Report
   * @param reportId The report Id
   * @param report The report
   */
  patchBasisFinalReport(reportId: string, report: BasisFinalReportDto): Promise<void>;

  /**
   * Gets Cluster Basis Final Report by id
   * @param reportId The report Id
   * @return BasisFinalReportDto
   */
  getBasisFinalReport(reportId: string): Promise<BasisFinalReportDto>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateBasisFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Creates new Basis Final Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertBasisFinalReport(report: BasisFinalReportDto): Promise<string>;

  /**
   * Gets Basis Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of BasisFinalListItemDto
   */
  getBasisFinalReportList(status?: FormStatus | null | undefined): Promise<BasisFinalListItemDto[]>;

  /**
   * Gets Cluster Basis Final Report list with attachments
   * @return A list of BasisFinalListItemDto
   */
  getArchivedBasisFinalReports(): Promise<BasisFinalListItemDto[]>;

  /**
   * Gets Cluster Development Project Interim Report General information
   * @param projectId The Development Project Id
   * @return DevProjectInterimGeneralDto
   */
  getDevProjectInterimReportCreationInformationGeneral(
    projectId: string,
  ): Promise<DevProjectInterimGeneralDto>;

  /**
   * Gets Cluster Development Project Interim Report Financial information
   * @param projectId The Development Project Id
   * @return DevProjectInterimFinancialDto
   */
  getDevProjectInterimReportCreationInformationFinancial(
    projectId: string,
  ): Promise<DevProjectInterimFinancialDto>;

  /**
   * Patches Cluster Development Project Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchDevelopmentProjectInterimReport(reportId: string, record: DevProjectInterimReportDto): Promise<void>;

  /**
   * Gets Development Project Interim Report by id
   * @param reportId The report Id
   * @return DevProjectInterimReportDto
   */
  getDevelopmentProjectInterimReport(reportId: string): Promise<DevProjectInterimReportDto>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateDevelopmentProjectInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Gets Development Project Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of DevProjectInterimListItemDto
   */
  getDevelopmentProjectInterimReportList(
    status?: FormStatus | null | undefined,
  ): Promise<DevProjectInterimListItemDto[]>;

  /**
   * Creates new report is record.Id null, Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertDevelopmentProjectInterimReport(report: DevProjectInterimReportDto): Promise<string>;

  /**
   * Gets Cluster Development Project Interim Report list with attachments
   * @return A list of DevProjectInterimListItemDto
   */
  getArchivedDevelopmentProjectInterimReports(): Promise<DevProjectInterimListItemDto[]>;

  /**
   * Gets Cluster Development Project Final Report General information
   * @param projectId The Development Project Id
   * @return DevProjectFinalGeneralDto
   */
  getDevProjectFinalReportCreationInformationGeneral(projectId: string): Promise<DevProjectFinalGeneralDto>;

  /**
   * Gets Cluster Development Project Final Report Financial information
   * @param projectId The Development Project Id
   * @return DevProjectFinalFinancialDto
   */
  getDevProjectFinalReportCreationInformationFinancial(
    projectId: string,
  ): Promise<DevProjectInterimFinancialDto>;

  /**
   * Patches Cluster Development Project Final Report
   * @param reportId The report Id
   * @param record The report
   */
  patchDevelopmentProjectFinalReport(reportId: string, record: DevProjectFinalReportDto): Promise<void>;

  /**
   * Gets Development Project Final Report by id
   * @param reportId The report Id
   * @return DevProjectFinalReportDto
   */
  getDevelopmentProjectFinalReport(reportId: string): Promise<DevProjectFinalReportDto>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateDevelopmentProjectFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Gets Development Project Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of DevProjectFinalListItemDto
   */
  getDevelopmentProjectFinalReportList(
    status?: FormStatus | null | undefined,
  ): Promise<DevProjectFinalListItemDto[]>;

  /**
   * Creates new report is record.Id null, Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertDevelopmentProjectFinalReport(report: DevProjectFinalReportDto): Promise<string>;

  /**
   * Gets Cluster Development Project Final Report list with attachments
   * @return A list of DevProjectFinalListItemDto
   */
  getArchivedDevelopmentProjectFinalReports(): Promise<DevProjectFinalListItemDto[]>;

  /**
   * Gets Cluster Annual Report information
   * @return AnnualReportCreationDto
   */
  getAnnualReportCreationInformation(): Promise<AnnualReportCreationDto>;

  /**
   * Patches Cluster Annual Report
   * @param reportId The report Id
   * @param report The report
   */
  patchAnnualReport(reportId: string, report: AnnualReportDto): Promise<void>;

  /**
   * Gets Cluster Annual Report by id
   * @param reportId The report Id
   * @return AnnualReportDto
   */
  getAnnualReport(reportId: string): Promise<AnnualReportDto>;

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateAnnualReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse>;

  /**
   * Creates new Annual Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertAnnualReport(report: AnnualReportDto): Promise<string>;

  /**
   * Gets Annual Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of AnnualListItemDto
   */
  getAnnualReportList(status?: FormStatus | null | undefined): Promise<AnnualListItemDto[]>;

  /**
   * Gets Cluster Annual Report list with attachments
   * @return A list of AnnualListItemDto
   */
  getArchivedAnnualReports(): Promise<AnnualListItemDto[]>;

  /**
   * Delete Report
   * @param reportId The report Id
   */
  deleteReport(reportId: string): Promise<void>;
}

export class ReportsService implements IReportsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Patches Cluster Operation Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchOperationInterimReport(reportId: string, record: OperationInterimReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchOperationInterimReport(_response);
    });
  }

  protected processPatchOperationInterimReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Cluster Operation Interim Report by id
   * @param reportId The report Id
   * @return OperationInterimReportDto
   */
  getOperationInterimReport(reportId: string): Promise<OperationInterimReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationInterimReport(_response);
    });
  }

  protected processGetOperationInterimReport(response: Response): Promise<OperationInterimReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationInterimReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationInterimReportDto>(null as any);
  }

  /**
   * Creates a new report if the report's Id is null. Updates an existing report if the report's Id is set.
   * @param report The report
   */
  upsertOperationInterimReport(report: OperationInterimReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertOperationInterimReport(_response);
    });
  }

  protected processUpsertOperationInterimReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Cluster Operation Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return OperationInterimListItemDto
   */
  getOperationInterimReportList(
    status?: FormStatus | null | undefined,
  ): Promise<OperationInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationInterimReportList(_response);
    });
  }

  protected processGetOperationInterimReportList(response: Response): Promise<OperationInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationInterimListItemDto[]>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateOperationInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateOperationInterimReportDocument(_response);
    });
  }

  protected processGenerateOperationInterimReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Gets Cluster Operation Interim Report General information
   * @return OperationInterimReportGeneralDto
   */
  getOperationInterimReportCreationInformationGeneral(): Promise<OperationInterimGeneralDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports/creation-information-general';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationInterimReportCreationInformationGeneral(_response);
    });
  }

  protected processGetOperationInterimReportCreationInformationGeneral(
    response: Response,
  ): Promise<OperationInterimGeneralDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationInterimGeneralDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationInterimGeneralDto>(null as any);
  }

  /**
   * Gets Cluster Operation Interim Report financial information
   * @return OperationInterimReportGeneralDto
   */
  getOperationInterimReportCreationInformationFinances(): Promise<OperationInterimFinancialDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationInterimReports/creation-information-financial';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationInterimReportCreationInformationFinances(_response);
    });
  }

  protected processGetOperationInterimReportCreationInformationFinances(
    response: Response,
  ): Promise<OperationInterimFinancialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationInterimFinancialDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationInterimFinancialDto>(null as any);
  }

  /**
   * Gets Cluster Operation Interim Report list with attachments
   * @return A list of OperationInterimListItemDto
   */
  getArchivedOperationInterimReports(): Promise<OperationInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/OperationInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedOperationInterimReports(_response);
    });
  }

  protected processGetArchivedOperationInterimReports(
    response: Response,
  ): Promise<OperationInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationInterimListItemDto[]>(null as any);
  }

  /**
   * Creates new report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertOperationFinalReport(report: OperationFinalReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertOperationFinalReport(_response);
    });
  }

  protected processUpsertOperationFinalReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Cluster Operation Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return OperationFinalListItemDto
   */
  getOperationFinalReportList(status?: FormStatus | null | undefined): Promise<OperationFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationFinalReportList(_response);
    });
  }

  protected processGetOperationFinalReportList(response: Response): Promise<OperationFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationFinalListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Operation Final Report by id
   * @param reportId The report Id
   * @return OperationFinalReportDto
   */
  getOperationFinalReport(reportId: string): Promise<OperationFinalReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationFinalReport(_response);
    });
  }

  protected processGetOperationFinalReport(response: Response): Promise<OperationFinalReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationFinalReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationFinalReportDto>(null as any);
  }

  /**
   * Patches Cluster Operation Final Report
   * @param reportId The report Id
   * @param report The report
   */
  patchOperationFinalReport(reportId: string, report: OperationFinalReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchOperationFinalReport(_response);
    });
  }

  protected processPatchOperationFinalReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateOperationFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateOperationFinalReportDocument(_response);
    });
  }

  protected processGenerateOperationFinalReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Gets Cluster Operation Final Report General information
   * @return OperationFinalReportGeneralDto
   */
  getOperationFinalReportCreationInformationGeneral(): Promise<OperationFinalGeneralDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports/creation-information-general';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationFinalReportCreationInformationGeneral(_response);
    });
  }

  protected processGetOperationFinalReportCreationInformationGeneral(
    response: Response,
  ): Promise<OperationFinalGeneralDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationFinalGeneralDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationFinalGeneralDto>(null as any);
  }

  /**
   * Gets Cluster Operation Final Report financial information
   * @return OperationFinalReportGeneralDto
   */
  getOperationFinalReportCreationInformationFinances(): Promise<OperationFinalFinancialDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/OperationFinalReports/creation-information-financial';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationFinalReportCreationInformationFinances(_response);
    });
  }

  protected processGetOperationFinalReportCreationInformationFinances(
    response: Response,
  ): Promise<OperationFinalFinancialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationFinalFinancialDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationFinalFinancialDto>(null as any);
  }

  /**
   * Gets Cluster Operation Final Report list with attachments
   * @return A list of OperationFinalListItemDto
   */
  getArchivedOperationFinalReports(): Promise<OperationFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/OperationFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedOperationFinalReports(_response);
    });
  }

  protected processGetArchivedOperationFinalReports(
    response: Response,
  ): Promise<OperationFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationFinalListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Basis Interim Report General information
   * @return BasisInterimReportGeneralDto
   */
  getBasisInterimReportCreationInformationGeneral(): Promise<BasisInterimReportGeneralDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports/creation-information-general';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisInterimReportCreationInformationGeneral(_response);
    });
  }

  protected processGetBasisInterimReportCreationInformationGeneral(
    response: Response,
  ): Promise<BasisInterimReportGeneralDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisInterimReportGeneralDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisInterimReportGeneralDto>(null as any);
  }

  /**
   * Patches Cluster Basis Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchBasisInterimReport(reportId: string, record: BasisInterimReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchBasisInterimReport(_response);
    });
  }

  protected processPatchBasisInterimReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Cluster Basis Interim Report by id
   * @param reportId The report Id
   * @return BasisInterimReportDto
   */
  getBasisInterimReport(reportId: string): Promise<BasisInterimReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisInterimReport(_response);
    });
  }

  protected processGetBasisInterimReport(response: Response): Promise<BasisInterimReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisInterimReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisInterimReportDto>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateBasisInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateBasisInterimReportDocument(_response);
    });
  }

  protected processGenerateBasisInterimReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Creates new Basis Interim Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertBasisInterimReport(report: BasisInterimReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertBasisInterimReport(_response);
    });
  }

  protected processUpsertBasisInterimReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Basis Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of BasisInterimListItemDto
   */
  getBasisInterimReportList(status?: FormStatus | null | undefined): Promise<BasisInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisInterimReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisInterimReportList(_response);
    });
  }

  protected processGetBasisInterimReportList(response: Response): Promise<BasisInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisInterimListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Basis Interim Report list with attachments
   * @return A list of BasisInterimListItemDto
   */
  getArchivedBasisInterimReports(): Promise<BasisInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/BasisInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedBasisInterimReports(_response);
    });
  }

  protected processGetArchivedBasisInterimReports(response: Response): Promise<BasisInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisInterimListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Basis Final Report information
   * @return BasisFinalReportCreationDto
   */
  getBasisFinalReportCreationInformation(): Promise<BasisFinalReportCreationDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports/creation-information';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisFinalReportCreationInformation(_response);
    });
  }

  protected processGetBasisFinalReportCreationInformation(
    response: Response,
  ): Promise<BasisFinalReportCreationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisFinalReportCreationDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisFinalReportCreationDto>(null as any);
  }

  /**
   * Patches Cluster Basis Final Report
   * @param reportId The report Id
   * @param report The report
   */
  patchBasisFinalReport(reportId: string, report: BasisFinalReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchBasisFinalReport(_response);
    });
  }

  protected processPatchBasisFinalReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Cluster Basis Final Report by id
   * @param reportId The report Id
   * @return BasisFinalReportDto
   */
  getBasisFinalReport(reportId: string): Promise<BasisFinalReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisFinalReport(_response);
    });
  }

  protected processGetBasisFinalReport(response: Response): Promise<BasisFinalReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisFinalReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisFinalReportDto>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateBasisFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateBasisFinalReportDocument(_response);
    });
  }

  protected processGenerateBasisFinalReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Creates new Basis Final Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertBasisFinalReport(report: BasisFinalReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertBasisFinalReport(_response);
    });
  }

  protected processUpsertBasisFinalReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Basis Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of BasisFinalListItemDto
   */
  getBasisFinalReportList(status?: FormStatus | null | undefined): Promise<BasisFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/BasisFinalReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasisFinalReportList(_response);
    });
  }

  protected processGetBasisFinalReportList(response: Response): Promise<BasisFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisFinalListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Basis Final Report list with attachments
   * @return A list of BasisFinalListItemDto
   */
  getArchivedBasisFinalReports(): Promise<BasisFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/BasisFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedBasisFinalReports(_response);
    });
  }

  protected processGetArchivedBasisFinalReports(response: Response): Promise<BasisFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BasisFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<BasisFinalListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Development Project Interim Report General information
   * @param projectId The Development Project Id
   * @return DevProjectInterimGeneralDto
   */
  getDevProjectInterimReportCreationInformationGeneral(
    projectId: string,
  ): Promise<DevProjectInterimGeneralDto> {
    let url_ =
      this.baseUrl +
      '/api/v2/Reports/DevelopmentProjectInterimReports/{projectId}/creation-information-general';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevProjectInterimReportCreationInformationGeneral(_response);
    });
  }

  protected processGetDevProjectInterimReportCreationInformationGeneral(
    response: Response,
  ): Promise<DevProjectInterimGeneralDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimGeneralDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimGeneralDto>(null as any);
  }

  /**
   * Gets Cluster Development Project Interim Report Financial information
   * @param projectId The Development Project Id
   * @return DevProjectInterimFinancialDto
   */
  getDevProjectInterimReportCreationInformationFinancial(
    projectId: string,
  ): Promise<DevProjectInterimFinancialDto> {
    let url_ =
      this.baseUrl +
      '/api/v2/Reports/DevelopmentProjectInterimReports/{projectId}/creation-information-financial';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevProjectInterimReportCreationInformationFinancial(_response);
    });
  }

  protected processGetDevProjectInterimReportCreationInformationFinancial(
    response: Response,
  ): Promise<DevProjectInterimFinancialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimFinancialDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimFinancialDto>(null as any);
  }

  /**
   * Patches Cluster Development Project Interim Report
   * @param reportId The report Id
   * @param record The report
   */
  patchDevelopmentProjectInterimReport(reportId: string, record: DevProjectInterimReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchDevelopmentProjectInterimReport(_response);
    });
  }

  protected processPatchDevelopmentProjectInterimReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Development Project Interim Report by id
   * @param reportId The report Id
   * @return DevProjectInterimReportDto
   */
  getDevelopmentProjectInterimReport(reportId: string): Promise<DevProjectInterimReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectInterimReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProjectInterimReport(_response);
    });
  }

  protected processGetDevelopmentProjectInterimReport(
    response: Response,
  ): Promise<DevProjectInterimReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimReportDto>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateDevelopmentProjectInterimReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectInterimReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateDevelopmentProjectInterimReportDocument(_response);
    });
  }

  protected processGenerateDevelopmentProjectInterimReportDocument(
    response: Response,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Gets Development Project Interim Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of DevProjectInterimListItemDto
   */
  getDevelopmentProjectInterimReportList(
    status?: FormStatus | null | undefined,
  ): Promise<DevProjectInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectInterimReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProjectInterimReportList(_response);
    });
  }

  protected processGetDevelopmentProjectInterimReportList(
    response: Response,
  ): Promise<DevProjectInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimListItemDto[]>(null as any);
  }

  /**
   * Creates new report is record.Id null, Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertDevelopmentProjectInterimReport(report: DevProjectInterimReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertDevelopmentProjectInterimReport(_response);
    });
  }

  protected processUpsertDevelopmentProjectInterimReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Cluster Development Project Interim Report list with attachments
   * @return A list of DevProjectInterimListItemDto
   */
  getArchivedDevelopmentProjectInterimReports(): Promise<DevProjectInterimListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/DevelopmentProjectInterimReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedDevelopmentProjectInterimReports(_response);
    });
  }

  protected processGetArchivedDevelopmentProjectInterimReports(
    response: Response,
  ): Promise<DevProjectInterimListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Development Project Final Report General information
   * @param projectId The Development Project Id
   * @return DevProjectFinalGeneralDto
   */
  getDevProjectFinalReportCreationInformationGeneral(projectId: string): Promise<DevProjectFinalGeneralDto> {
    let url_ =
      this.baseUrl +
      '/api/v2/Reports/DevelopmentProjectFinalReports/{projectId}/creation-information-general';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevProjectFinalReportCreationInformationGeneral(_response);
    });
  }

  protected processGetDevProjectFinalReportCreationInformationGeneral(
    response: Response,
  ): Promise<DevProjectFinalGeneralDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectFinalGeneralDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectFinalGeneralDto>(null as any);
  }

  /**
   * Gets Cluster Development Project Final Report Financial information
   * @param projectId The Development Project Id
   * @return DevProjectFinalFinancialDto
   */
  getDevProjectFinalReportCreationInformationFinancial(
    projectId: string,
  ): Promise<DevProjectInterimFinancialDto> {
    let url_ =
      this.baseUrl +
      '/api/v2/Reports/DevelopmentProjectFinalReports/{projectId}/creation-information-financial';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevProjectFinalReportCreationInformationFinancial(_response);
    });
  }

  protected processGetDevProjectFinalReportCreationInformationFinancial(
    response: Response,
  ): Promise<DevProjectInterimFinancialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectInterimFinancialDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectInterimFinancialDto>(null as any);
  }

  /**
   * Patches Cluster Development Project Final Report
   * @param reportId The report Id
   * @param record The report
   */
  patchDevelopmentProjectFinalReport(reportId: string, record: DevProjectFinalReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchDevelopmentProjectFinalReport(_response);
    });
  }

  protected processPatchDevelopmentProjectFinalReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Development Project Final Report by id
   * @param reportId The report Id
   * @return DevProjectFinalReportDto
   */
  getDevelopmentProjectFinalReport(reportId: string): Promise<DevProjectFinalReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectFinalReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProjectFinalReport(_response);
    });
  }

  protected processGetDevelopmentProjectFinalReport(response: Response): Promise<DevProjectFinalReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectFinalReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectFinalReportDto>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateDevelopmentProjectFinalReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectFinalReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateDevelopmentProjectFinalReportDocument(_response);
    });
  }

  protected processGenerateDevelopmentProjectFinalReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Gets Development Project Final Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of DevProjectFinalListItemDto
   */
  getDevelopmentProjectFinalReportList(
    status?: FormStatus | null | undefined,
  ): Promise<DevProjectFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectFinalReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProjectFinalReportList(_response);
    });
  }

  protected processGetDevelopmentProjectFinalReportList(
    response: Response,
  ): Promise<DevProjectFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectFinalListItemDto[]>(null as any);
  }

  /**
   * Creates new report is record.Id null, Puts existing report if record.Id is set.
   * @param report The report
   */
  upsertDevelopmentProjectFinalReport(report: DevProjectFinalReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/DevelopmentProjectFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertDevelopmentProjectFinalReport(_response);
    });
  }

  protected processUpsertDevelopmentProjectFinalReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Cluster Development Project Final Report list with attachments
   * @return A list of DevProjectFinalListItemDto
   */
  getArchivedDevelopmentProjectFinalReports(): Promise<DevProjectFinalListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/DevelopmentProjectFinalReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedDevelopmentProjectFinalReports(_response);
    });
  }

  protected processGetArchivedDevelopmentProjectFinalReports(
    response: Response,
  ): Promise<DevProjectFinalListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevProjectFinalListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevProjectFinalListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Annual Report information
   * @return AnnualReportCreationDto
   */
  getAnnualReportCreationInformation(): Promise<AnnualReportCreationDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports/creation-information';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnnualReportCreationInformation(_response);
    });
  }

  protected processGetAnnualReportCreationInformation(response: Response): Promise<AnnualReportCreationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as AnnualReportCreationDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AnnualReportCreationDto>(null as any);
  }

  /**
   * Patches Cluster Annual Report
   * @param reportId The report Id
   * @param report The report
   */
  patchAnnualReport(reportId: string, report: AnnualReportDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPatchAnnualReport(_response);
    });
  }

  protected processPatchAnnualReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets Cluster Annual Report by id
   * @param reportId The report Id
   * @return AnnualReportDto
   */
  getAnnualReport(reportId: string): Promise<AnnualReportDto> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnnualReport(_response);
    });
  }

  protected processGetAnnualReport(response: Response): Promise<AnnualReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AnnualReportDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AnnualReportDto>(null as any);
  }

  /**
   * Generates report with reportId as doctype file
   * @param reportId The identifier of the report.
   * @param doctype The file type.
   * @param locale (optional) Determines the language of the report.
   */
  generateAnnualReportDocument(
    reportId: string,
    doctype: DocumentTypes,
    locale?: SupportedLocales | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports/{reportId}/{doctype}?';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (doctype === undefined || doctype === null)
      throw new Error("The parameter 'doctype' must be defined.");
    url_ = url_.replace('{doctype}', encodeURIComponent('' + doctype));
    if (locale === null) throw new Error("The parameter 'locale' cannot be null.");
    else if (locale !== undefined) url_ += 'locale=' + encodeURIComponent('' + locale) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGenerateAnnualReportDocument(_response);
    });
  }

  protected processGenerateAnnualReportDocument(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          "When there's no report in Web Application for this cluster",
          status,
          _responseText,
          _headers,
          result404,
        );
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException(
          'When an error occurs in requests to Web Application',
          status,
          _responseText,
          _headers,
          result424,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Creates new Annual Report if record.Id null. Puts existing report if record.Id is set.
   * @param report The report dto
   */
  upsertAnnualReport(report: AnnualReportDto): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(report);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertAnnualReport(_response);
    });
  }

  protected processUpsertAnnualReport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result201;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets Annual Report list
   * @param status (optional) The report status. Either Draft or Submitted
   * @return A list of AnnualListItemDto
   */
  getAnnualReportList(status?: FormStatus | null | undefined): Promise<AnnualListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/AnnualReports?';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnnualReportList(_response);
    });
  }

  protected processGetAnnualReportList(response: Response): Promise<AnnualListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as AnnualListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AnnualListItemDto[]>(null as any);
  }

  /**
   * Gets Cluster Annual Report list with attachments
   * @return A list of AnnualListItemDto
   */
  getArchivedAnnualReports(): Promise<AnnualListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/Reports/Archived/AnnualReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetArchivedAnnualReports(_response);
    });
  }

  protected processGetArchivedAnnualReports(response: Response): Promise<AnnualListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as AnnualListItemDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AnnualListItemDto[]>(null as any);
  }

  /**
   * Delete Report
   * @param reportId The report Id
   */
  deleteReport(reportId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Reports/{reportId}';
    if (reportId === undefined || reportId === null)
      throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteReport(_response);
    });
  }

  protected processDeleteReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface ISessionService {
  login(
    domainHint?: string | null | undefined,
    redirectUri?: string | null | undefined,
  ): Promise<FileResponse>;

  /**
   * Gets current user
   * @return User
   */
  getCurrent(): Promise<UserContextDto>;

  signOut(): Promise<FileResponse>;

  singleLogOut(): Promise<FileResponse>;

  storeChosenCluster(clusterId: string): Promise<UserContextDto>;

  deleteChosenCluster(): Promise<void>;
}

export class SessionService implements ISessionService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  login(
    domainHint?: string | null | undefined,
    redirectUri?: string | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Session/login?';
    if (domainHint !== undefined && domainHint !== null)
      url_ += 'domainHint=' + encodeURIComponent('' + domainHint) + '&';
    if (redirectUri !== undefined && redirectUri !== null)
      url_ += 'redirectUri=' + encodeURIComponent('' + redirectUri) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processLogin(_response);
    });
  }

  protected processLogin(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Gets current user
   * @return User
   */
  getCurrent(): Promise<UserContextDto> {
    let url_ = this.baseUrl + '/api/v2/Session/current';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCurrent(_response);
    });
  }

  protected processGetCurrent(response: Response): Promise<UserContextDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserContextDto);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserContextDto>(null as any);
  }

  signOut(): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Session/sign-out';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSignOut(_response);
    });
  }

  protected processSignOut(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  singleLogOut(): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/Session/single-log-out';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSingleLogOut(_response);
    });
  }

  protected processSingleLogOut(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  storeChosenCluster(clusterId: string): Promise<UserContextDto> {
    let url_ = this.baseUrl + '/api/v2/Session/clusterId';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterId);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processStoreChosenCluster(_response);
    });
  }

  protected processStoreChosenCluster(response: Response): Promise<UserContextDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserContextDto);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserContextDto>(null as any);
  }

  deleteChosenCluster(): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Session/clusterId';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteChosenCluster(_response);
    });
  }

  protected processDeleteChosenCluster(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IApplicationsService {
  /**
   * Retrieves statistics about the application for the current year.
   * @return OperationApplicationStatisticsDto
   */
  getApplicationStatistics(clusterId: string): Promise<ApplicationStatisticsDto>;
}

export class ApplicationsService implements IApplicationsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Retrieves statistics about the application for the current year.
   * @return OperationApplicationStatisticsDto
   */
  getApplicationStatistics(clusterId: string): Promise<ApplicationStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/clusters/{clusterId}/applications/statistics';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetApplicationStatistics(_response);
    });
  }

  protected processGetApplicationStatistics(response: Response): Promise<ApplicationStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ApplicationStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ApplicationStatisticsDto>(null as any);
  }
}

export interface IClusterInvoicesService {
  /**
   * Gets all invoices for the current cluster
   * @return ClusterInvoiceDto[]
   */
  getAllClusterInvoices(): Promise<ClusterInvoiceDto[]>;

  /**
   * Upsert an array of invoices
   * @param dtoArray Array to upsert
   * @return Returns upserted dto on success
   */
  upsert(dtoArray: ClusterInvoiceCreateDto[]): Promise<ClusterInvoiceDto[]>;

  /**
   * Delete an array of invoices according to ID
   * @param invoiceIds Array of IDs to delete
   */
  delete(invoiceIds: string[]): Promise<void>;

  /**
   * Gets the invoices for a specific cluster member
   * @return ClusterInvoiceDto[]
   */
  getInvoiceByMember(clusterMemberId: string): Promise<ClusterInvoiceDto[]>;
}

export class ClusterInvoicesService implements IClusterInvoicesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gets all invoices for the current cluster
   * @return ClusterInvoiceDto[]
   */
  getAllClusterInvoices(): Promise<ClusterInvoiceDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterInvoices';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllClusterInvoices(_response);
    });
  }

  protected processGetAllClusterInvoices(response: Response): Promise<ClusterInvoiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterInvoiceDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterInvoiceDto[]>(null as any);
  }

  /**
   * Upsert an array of invoices
   * @param dtoArray Array to upsert
   * @return Returns upserted dto on success
   */
  upsert(dtoArray: ClusterInvoiceCreateDto[]): Promise<ClusterInvoiceDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterInvoices';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dtoArray);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsert(_response);
    });
  }

  protected processUpsert(response: Response): Promise<ClusterInvoiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterInvoiceDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterInvoiceDto[]>(null as any);
  }

  /**
   * Delete an array of invoices according to ID
   * @param invoiceIds Array of IDs to delete
   */
  delete(invoiceIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterInvoices';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(invoiceIds);

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the invoices for a specific cluster member
   * @return ClusterInvoiceDto[]
   */
  getInvoiceByMember(clusterMemberId: string): Promise<ClusterInvoiceDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterInvoices/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInvoiceByMember(_response);
    });
  }

  protected processGetInvoiceByMember(response: Response): Promise<ClusterInvoiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterInvoiceDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterInvoiceDto[]>(null as any);
  }
}

export interface IClusterLogoService {
  /**
   * Create Cluster logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterLogo(file?: FileParameter | null | undefined): Promise<void>;

  /**
   * Delete Cluster logo
   */
  deleteClusterLogo(): Promise<void>;

  /**
   * Get Cluster logo
   * @param size (optional) The desired image size.
   */
  getClusterLogo(clusterId: string, size?: ImageSize | null | undefined): Promise<FileResponse>;
}

export class ClusterLogoService implements IClusterLogoService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Create Cluster logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterLogo(file?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterLogo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterLogo(_response);
    });
  }

  protected processCreateClusterLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 422) {
      return response.text().then((_responseText) => {
        let result422: any = null;
        result422 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result422);
      });
    } else if (status === 502) {
      return response.text().then((_responseText) => {
        let result502: any = null;
        result502 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result502);
      });
    } else if (status === 503) {
      return response.text().then((_responseText) => {
        let result503: any = null;
        result503 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result503);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Delete Cluster logo
   */
  deleteClusterLogo(): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterLogo';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterLogo(_response);
    });
  }

  protected processDeleteClusterLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get Cluster logo
   * @param size (optional) The desired image size.
   */
  getClusterLogo(clusterId: string, size?: ImageSize | null | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterLogo/{clusterId}?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (size !== undefined && size !== null) url_ += 'size=' + encodeURIComponent('' + size) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterLogo(_response);
    });
  }

  protected processGetClusterLogo(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export interface IClusterMemberAttachmentsService {
  /**
   * Create ClusterMember attachment
   * @param file (optional)
   */
  createClusterMemberAttachment(
    clusterMemberId: string,
    file?: FileParameter | null | undefined,
  ): Promise<ClusterMemberAttachmentDto>;

  /**
   * Get ClusterMember attachment list
   */
  getClusterMemberAttachmentList(clusterMemberId: string): Promise<ClusterMemberAttachmentDto[]>;

  /**
   * Download ClusterMember attachment
   */
  downloadClusterMemberAttachment(attachmentId: string): Promise<FileResponse>;

  /**
   * Delete ClusterMember attachment
   */
  deleteClusterMemberAttachment(attachmentId: string): Promise<void>;
}

export class ClusterMemberAttachmentsService implements IClusterMemberAttachmentsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Create ClusterMember attachment
   * @param file (optional)
   */
  createClusterMemberAttachment(
    clusterMemberId: string,
    file?: FileParameter | null | undefined,
  ): Promise<ClusterMemberAttachmentDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberAttachments/{clusterMemberId}/Attachments';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterMemberAttachment(_response);
    });
  }

  protected processCreateClusterMemberAttachment(response: Response): Promise<ClusterMemberAttachmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberAttachmentDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 422) {
      return response.text().then((_responseText) => {
        let result422: any = null;
        result422 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result422);
      });
    } else if (status === 502) {
      return response.text().then((_responseText) => {
        let result502: any = null;
        result502 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result502);
      });
    } else if (status === 503) {
      return response.text().then((_responseText) => {
        let result503: any = null;
        result503 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result503);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberAttachmentDto>(null as any);
  }

  /**
   * Get ClusterMember attachment list
   */
  getClusterMemberAttachmentList(clusterMemberId: string): Promise<ClusterMemberAttachmentDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberAttachments/{clusterMemberId}/Attachments';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterMemberAttachmentList(_response);
    });
  }

  protected processGetClusterMemberAttachmentList(response: Response): Promise<ClusterMemberAttachmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberAttachmentDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberAttachmentDto[]>(null as any);
  }

  /**
   * Download ClusterMember attachment
   */
  downloadClusterMemberAttachment(attachmentId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberAttachments/{attachmentId}';
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDownloadClusterMemberAttachment(_response);
    });
  }

  protected processDownloadClusterMemberAttachment(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Delete ClusterMember attachment
   */
  deleteClusterMemberAttachment(attachmentId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberAttachments/{attachmentId}';
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterMemberAttachment(_response);
    });
  }

  protected processDeleteClusterMemberAttachment(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IClusterMemberEconomyService {
  /**
   * Gets cluster member economies for given clusterMemberId
   * @param clusterMemberId (optional)
   * @return List of ClusterMemberEconomyDto
   */
  getClusterMemberEconomies(clusterMemberId?: string | undefined): Promise<ClusterMemberEconomyDto[]>;

  /**
   * Creates cluster member Economy
   * @return ClusterMemberEconomyDto
   */
  createClusterMemberEconomy(
    clusterMemberEconomy: ClusterMemberEconomyCreateDto,
  ): Promise<ClusterMemberEconomyDto>;

  /**
   * Gets the spesific cluster member economy, given a cluster member economy id
   * @param clusterMemberEconomyId (optional)
   * @return ClusterMemberEconomyDto
   */
  getClusterMemberEconomy(clusterMemberEconomyId?: string | undefined): Promise<ClusterMemberEconomyDto[]>;

  /**
   * Update a cluster member economy
   * @return ClusterMemberEconomyDto
   */
  updateClusterMemberEconomy(
    clusterMemberEconomyId: string,
    clusterMemberEconomy: ClusterMemberEconomyUpdateDto,
  ): Promise<ClusterMemberEconomyDto[]>;

  /**
   * Deletes a cluster member economy
   * @return ClusterMemberEconomyDto
   */
  deleteClusterMemberEconomy(clusterMemberEconomyId: string): Promise<void>;
}

export class ClusterMemberEconomyService implements IClusterMemberEconomyService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gets cluster member economies for given clusterMemberId
   * @param clusterMemberId (optional)
   * @return List of ClusterMemberEconomyDto
   */
  getClusterMemberEconomies(clusterMemberId?: string | undefined): Promise<ClusterMemberEconomyDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberEconomy?';
    if (clusterMemberId === null) throw new Error("The parameter 'clusterMemberId' cannot be null.");
    else if (clusterMemberId !== undefined)
      url_ += 'clusterMemberId=' + encodeURIComponent('' + clusterMemberId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterMemberEconomies(_response);
    });
  }

  protected processGetClusterMemberEconomies(response: Response): Promise<ClusterMemberEconomyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberEconomyDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberEconomyDto[]>(null as any);
  }

  /**
   * Creates cluster member Economy
   * @return ClusterMemberEconomyDto
   */
  createClusterMemberEconomy(
    clusterMemberEconomy: ClusterMemberEconomyCreateDto,
  ): Promise<ClusterMemberEconomyDto> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberEconomy';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterMemberEconomy);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterMemberEconomy(_response);
    });
  }

  protected processCreateClusterMemberEconomy(response: Response): Promise<ClusterMemberEconomyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberEconomyDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberEconomyDto>(null as any);
  }

  /**
   * Gets the spesific cluster member economy, given a cluster member economy id
   * @param clusterMemberEconomyId (optional)
   * @return ClusterMemberEconomyDto
   */
  getClusterMemberEconomy(clusterMemberEconomyId?: string | undefined): Promise<ClusterMemberEconomyDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberEconomy/clusterMemberEconomyId?';
    if (clusterMemberEconomyId === null)
      throw new Error("The parameter 'clusterMemberEconomyId' cannot be null.");
    else if (clusterMemberEconomyId !== undefined)
      url_ += 'clusterMemberEconomyId=' + encodeURIComponent('' + clusterMemberEconomyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClusterMemberEconomy(_response);
    });
  }

  protected processGetClusterMemberEconomy(response: Response): Promise<ClusterMemberEconomyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberEconomyDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberEconomyDto[]>(null as any);
  }

  /**
   * Update a cluster member economy
   * @return ClusterMemberEconomyDto
   */
  updateClusterMemberEconomy(
    clusterMemberEconomyId: string,
    clusterMemberEconomy: ClusterMemberEconomyUpdateDto,
  ): Promise<ClusterMemberEconomyDto[]> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberEconomy/{clusterMemberEconomyId}';
    if (clusterMemberEconomyId === undefined || clusterMemberEconomyId === null)
      throw new Error("The parameter 'clusterMemberEconomyId' must be defined.");
    url_ = url_.replace('{clusterMemberEconomyId}', encodeURIComponent('' + clusterMemberEconomyId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterMemberEconomy);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateClusterMemberEconomy(_response);
    });
  }

  protected processUpdateClusterMemberEconomy(response: Response): Promise<ClusterMemberEconomyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterMemberEconomyDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterMemberEconomyDto[]>(null as any);
  }

  /**
   * Deletes a cluster member economy
   * @return ClusterMemberEconomyDto
   */
  deleteClusterMemberEconomy(clusterMemberEconomyId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberEconomy/{clusterMemberEconomyId}';
    if (clusterMemberEconomyId === undefined || clusterMemberEconomyId === null)
      throw new Error("The parameter 'clusterMemberEconomyId' must be defined.");
    url_ = url_.replace('{clusterMemberEconomyId}', encodeURIComponent('' + clusterMemberEconomyId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterMemberEconomy(_response);
    });
  }

  protected processDeleteClusterMemberEconomy(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IClusterMemberLogosService {
  /**
   * Create ClusterMember logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterMemberLogo(clusterMemberId: string, file?: FileParameter | null | undefined): Promise<void>;

  /**
   * Download ClusterMember logo
   * @param size (optional) The desired image size.
   */
  downloadClusterMemberLogo(
    clusterMemberId: string,
    size?: ImageSize | null | undefined,
  ): Promise<FileResponse>;

  /**
   * Delete ClusterMember logo
   */
  deleteClusterMemberLogo(clusterMemberId: string): Promise<void>;
}

export class ClusterMemberLogosService implements IClusterMemberLogosService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Create ClusterMember logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterMemberLogo(clusterMemberId: string, file?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberLogos/{clusterMemberId}/Logos';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterMemberLogo(_response);
    });
  }

  protected processCreateClusterMemberLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 422) {
      return response.text().then((_responseText) => {
        let result422: any = null;
        result422 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result422);
      });
    } else if (status === 502) {
      return response.text().then((_responseText) => {
        let result502: any = null;
        result502 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result502);
      });
    } else if (status === 503) {
      return response.text().then((_responseText) => {
        let result503: any = null;
        result503 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result503);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Download ClusterMember logo
   * @param size (optional) The desired image size.
   */
  downloadClusterMemberLogo(
    clusterMemberId: string,
    size?: ImageSize | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberLogos/{clusterMemberId}?';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    if (size !== undefined && size !== null) url_ += 'size=' + encodeURIComponent('' + size) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDownloadClusterMemberLogo(_response);
    });
  }

  protected processDownloadClusterMemberLogo(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Delete ClusterMember logo
   */
  deleteClusterMemberLogo(clusterMemberId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterMemberLogos/{clusterMemberId}';
    if (clusterMemberId === undefined || clusterMemberId === null)
      throw new Error("The parameter 'clusterMemberId' must be defined.");
    url_ = url_.replace('{clusterMemberId}', encodeURIComponent('' + clusterMemberId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterMemberLogo(_response);
    });
  }

  protected processDeleteClusterMemberLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IClusterUserLogosService {
  /**
   * Create ClusterUser logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterUserLogo(clusterUserId: string, file?: FileParameter | null | undefined): Promise<void>;

  /**
   * Download ClusterUser logo
   * @param size (optional) The desired image size.
   */
  downloadClusterUserLogo(
    clusterId: string,
    clusterUserId: string,
    size?: ImageSize | null | undefined,
  ): Promise<FileResponse>;

  /**
   * Delete ClusterUser logo
   */
  deleteClusterUserLogo(clusterUserId: string): Promise<void>;
}

export class ClusterUserLogosService implements IClusterUserLogosService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Create ClusterUser logo. Uploading when a logo already exists will overwrite the existing logo.
   * @param file (optional)
   */
  createClusterUserLogo(clusterUserId: string, file?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterUserLogos/{clusterUserId}/Logo';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClusterUserLogo(_response);
    });
  }

  protected processCreateClusterUserLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 422) {
      return response.text().then((_responseText) => {
        let result422: any = null;
        result422 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result422);
      });
    } else if (status === 502) {
      return response.text().then((_responseText) => {
        let result502: any = null;
        result502 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result502);
      });
    } else if (status === 503) {
      return response.text().then((_responseText) => {
        let result503: any = null;
        result503 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result503);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Download ClusterUser logo
   * @param size (optional) The desired image size.
   */
  downloadClusterUserLogo(
    clusterId: string,
    clusterUserId: string,
    size?: ImageSize | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/ClusterUserLogos/{clusterId}/{clusterUserId}?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    if (size !== undefined && size !== null) url_ += 'size=' + encodeURIComponent('' + size) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDownloadClusterUserLogo(_response);
    });
  }

  protected processDownloadClusterUserLogo(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Delete ClusterUser logo
   */
  deleteClusterUserLogo(clusterUserId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ClusterUserLogos/{clusterUserId}';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClusterUserLogo(_response);
    });
  }

  protected processDeleteClusterUserLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IConfigurationService {
  /**
   * Gets information about the current environment (dev, test or prod)
   * @return Environment information
   */
  getEnvironmentInformation(): Promise<EnvironmentInformation>;
}

export class ConfigurationService implements IConfigurationService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gets information about the current environment (dev, test or prod)
   * @return Environment information
   */
  getEnvironmentInformation(): Promise<EnvironmentInformation> {
    let url_ = this.baseUrl + '/api/v2/Configuration/environment-information';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEnvironmentInformation(_response);
    });
  }

  protected processGetEnvironmentInformation(response: Response): Promise<EnvironmentInformation> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentInformation);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EnvironmentInformation>(null as any);
  }
}

export interface ICoursesService {
  /**
   * Get list of courses
   */
  getCourseList(): Promise<EnrichedCourseDto[]>;

  /**
   * Get list of recommendations on a course
   */
  getCourseRecommendations(courseId: string): Promise<CourseRecommendationDto[]>;

  /**
   * Send course recommendation email
   * @param fields Email fields
   */
  courseRecommendation(
    courseId: string,
    fields: CourseRecommendationCreateDto[],
  ): Promise<CourseRecommendationDto>;
}

export class CoursesService implements ICoursesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get list of courses
   */
  getCourseList(): Promise<EnrichedCourseDto[]> {
    let url_ = this.baseUrl + '/api/v2/Courses/get-course-list';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCourseList(_response);
    });
  }

  protected processGetCourseList(response: Response): Promise<EnrichedCourseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EnrichedCourseDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result424);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EnrichedCourseDto[]>(null as any);
  }

  /**
   * Get list of recommendations on a course
   */
  getCourseRecommendations(courseId: string): Promise<CourseRecommendationDto[]> {
    let url_ = this.baseUrl + '/api/v2/Courses/{courseId}/course-recommendations';
    if (courseId === undefined || courseId === null)
      throw new Error("The parameter 'courseId' must be defined.");
    url_ = url_.replace('{courseId}', encodeURIComponent('' + courseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCourseRecommendations(_response);
    });
  }

  protected processGetCourseRecommendations(response: Response): Promise<CourseRecommendationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CourseRecommendationDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result424);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CourseRecommendationDto[]>(null as any);
  }

  /**
   * Send course recommendation email
   * @param fields Email fields
   */
  courseRecommendation(
    courseId: string,
    fields: CourseRecommendationCreateDto[],
  ): Promise<CourseRecommendationDto> {
    let url_ = this.baseUrl + '/api/v2/Courses/{courseId}/send-course-recommendation';
    if (courseId === undefined || courseId === null)
      throw new Error("The parameter 'courseId' must be defined.");
    url_ = url_.replace('{courseId}', encodeURIComponent('' + courseId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(fields);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCourseRecommendation(_response);
    });
  }

  protected processCourseRecommendation(response: Response): Promise<CourseRecommendationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CourseRecommendationDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 424) {
      return response.text().then((_responseText) => {
        let result424: any = null;
        result424 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result424);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CourseRecommendationDto>(null as any);
  }
}

export interface IDevelopmentProjectsService {
  getDevelopmentProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<DevelopmentProjectListItemDto[]>;

  getDevelopmentProject(projectId: string): Promise<DevelopmentProjectDto>;

  changeDevelopmentProjectType(projectId: string, projectTypeId: string): Promise<DevelopmentProjectDto>;

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void>;

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto>;

  finalizeDevelopmentProject(projectId: string, endReason: ProjectEndReasonCreateDto): Promise<void>;
}

export class DevelopmentProjectsService implements IDevelopmentProjectsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getDevelopmentProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<DevelopmentProjectListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{clusterId}/list?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (projectPhaseId !== undefined && projectPhaseId !== null)
      url_ += 'ProjectPhaseId=' + encodeURIComponent('' + projectPhaseId) + '&';
    if (mainGoalId !== undefined && mainGoalId !== null)
      url_ += 'MainGoalId=' + encodeURIComponent('' + mainGoalId) + '&';
    if (focusAreaId !== undefined && focusAreaId !== null)
      url_ += 'FocusAreaId=' + encodeURIComponent('' + focusAreaId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProjects(_response);
    });
  }

  protected processGetDevelopmentProjects(response: Response): Promise<DevelopmentProjectListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentProjectListItemDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevelopmentProjectListItemDto[]>(null as any);
  }

  getDevelopmentProject(projectId: string): Promise<DevelopmentProjectDto> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDevelopmentProject(_response);
    });
  }

  protected processGetDevelopmentProject(response: Response): Promise<DevelopmentProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevelopmentProjectDto>(null as any);
  }

  changeDevelopmentProjectType(projectId: string, projectTypeId: string): Promise<DevelopmentProjectDto> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{projectId}/project-type';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(projectTypeId);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeDevelopmentProjectType(_response);
    });
  }

  protected processChangeDevelopmentProjectType(response: Response): Promise<DevelopmentProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<DevelopmentProjectDto>(null as any);
  }

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{projectId}/project-members';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterMemberIds);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetProjectMembers(_response);
    });
  }

  protected processSetProjectMembers(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{projectId}/statistics';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectStatistics(_response);
    });
  }

  protected processGetProjectStatistics(response: Response): Promise<ProjectStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectStatisticsDto>(null as any);
  }

  finalizeDevelopmentProject(projectId: string, endReason: ProjectEndReasonCreateDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/DevelopmentProjects/{projectId}/finalize';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(endReason);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processFinalizeDevelopmentProject(_response);
    });
  }

  protected processFinalizeDevelopmentProject(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IEeaArticleService {
  /**
   * Gets list of applicable EEA Articles
   * @return List of EEA Articles
   */
  getEeaArticles(): Promise<EeaArticleDto[]>;
}

export class EeaArticleService implements IEeaArticleService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gets list of applicable EEA Articles
   * @return List of EEA Articles
   */
  getEeaArticles(): Promise<EeaArticleDto[]> {
    let url_ = this.baseUrl + '/api/v2/eea-articles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEeaArticles(_response);
    });
  }

  protected processGetEeaArticles(response: Response): Promise<EeaArticleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EeaArticleDto[]);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EeaArticleDto[]>(null as any);
  }
}

export interface IEventsVService {
  getEvents(
    clusterId: string,
    isPublic?: boolean | null | undefined,
    isContinuous?: boolean | null | undefined,
    projectId?: string | null | undefined,
    operationApplicationId?: string | null | undefined,
    category?: EventCategory | null | undefined,
  ): Promise<EventDtoV2[]>;

  getEvent(eventId: string): Promise<EventDtoV2>;

  putEvent(eventId: string, updateDto: EventUpdateDtoV2): Promise<EventDtoV2>;

  deleteEvent(eventId: string): Promise<void>;

  postEvent(createDto: EventCreateDtoV2): Promise<EventDtoV2>;

  getEventDetails(eventId: string): Promise<EventDetailsDto>;

  getEventParticipants(eventId: string): Promise<ClusterContactDto[]>;

  getPublicEvent(eventId: string): Promise<EventSimpleDto>;

  postPublicEmailRegistration(eventId: string, registration: PublicEventSimpleRegistrationDto): Promise<void>;

  postPublicFullRegistration(eventId: string, registration: PublicEventRegistrationDto): Promise<void>;
}

export class EventsVService implements IEventsVService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getEvents(
    clusterId: string,
    isPublic?: boolean | null | undefined,
    isContinuous?: boolean | null | undefined,
    projectId?: string | null | undefined,
    operationApplicationId?: string | null | undefined,
    category?: EventCategory | null | undefined,
  ): Promise<EventDtoV2[]> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{clusterId}/list?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (isPublic !== undefined && isPublic !== null)
      url_ += 'IsPublic=' + encodeURIComponent('' + isPublic) + '&';
    if (isContinuous !== undefined && isContinuous !== null)
      url_ += 'IsContinuous=' + encodeURIComponent('' + isContinuous) + '&';
    if (projectId !== undefined && projectId !== null)
      url_ += 'ProjectId=' + encodeURIComponent('' + projectId) + '&';
    if (operationApplicationId !== undefined && operationApplicationId !== null)
      url_ += 'OperationApplicationId=' + encodeURIComponent('' + operationApplicationId) + '&';
    if (category !== undefined && category !== null)
      url_ += 'Category=' + encodeURIComponent('' + category) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEvents(_response);
    });
  }

  protected processGetEvents(response: Response): Promise<EventDtoV2[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventDtoV2[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventDtoV2[]>(null as any);
  }

  getEvent(eventId: string): Promise<EventDtoV2> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{eventId}';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEvent(_response);
    });
  }

  protected processGetEvent(response: Response): Promise<EventDtoV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventDtoV2);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventDtoV2>(null as any);
  }

  putEvent(eventId: string, updateDto: EventUpdateDtoV2): Promise<EventDtoV2> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{eventId}';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPutEvent(_response);
    });
  }

  protected processPutEvent(response: Response): Promise<EventDtoV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventDtoV2);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventDtoV2>(null as any);
  }

  deleteEvent(eventId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{eventId}';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteEvent(_response);
    });
  }

  protected processDeleteEvent(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  postEvent(createDto: EventCreateDtoV2): Promise<EventDtoV2> {
    let url_ = this.baseUrl + '/api/v2/EventsV';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostEvent(_response);
    });
  }

  protected processPostEvent(response: Response): Promise<EventDtoV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventDtoV2);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventDtoV2>(null as any);
  }

  getEventDetails(eventId: string): Promise<EventDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{eventId}/statistics';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEventDetails(_response);
    });
  }

  protected processGetEventDetails(response: Response): Promise<EventDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventDetailsDto>(null as any);
  }

  getEventParticipants(eventId: string): Promise<ClusterContactDto[]> {
    let url_ = this.baseUrl + '/api/v2/EventsV/{eventId}/participants';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEventParticipants(_response);
    });
  }

  protected processGetEventParticipants(response: Response): Promise<ClusterContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterContactDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterContactDto[]>(null as any);
  }

  getPublicEvent(eventId: string): Promise<EventSimpleDto> {
    let url_ = this.baseUrl + '/api/v2/EventsV/public/{eventId}';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPublicEvent(_response);
    });
  }

  protected processGetPublicEvent(response: Response): Promise<EventSimpleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EventSimpleDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EventSimpleDto>(null as any);
  }

  postPublicEmailRegistration(
    eventId: string,
    registration: PublicEventSimpleRegistrationDto,
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EventsV/public/{eventId}';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(registration);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostPublicEmailRegistration(_response);
    });
  }

  protected processPostPublicEmailRegistration(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  postPublicFullRegistration(eventId: string, registration: PublicEventRegistrationDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/EventsV/public/{eventId}/full';
    if (eventId === undefined || eventId === null)
      throw new Error("The parameter 'eventId' must be defined.");
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(registration);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostPublicFullRegistration(_response);
    });
  }

  protected processPostPublicFullRegistration(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IExpenseTypesService {
  getExpenseTypeByProjectTypeList(projectTypeId: string): Promise<ExpenseTypeDto[]>;
}

export class ExpenseTypesService implements IExpenseTypesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getExpenseTypeByProjectTypeList(projectTypeId: string): Promise<ExpenseTypeDto[]> {
    let url_ = this.baseUrl + '/api/v2/project-type/{projectTypeId}/expense-types';
    if (projectTypeId === undefined || projectTypeId === null)
      throw new Error("The parameter 'projectTypeId' must be defined.");
    url_ = url_.replace('{projectTypeId}', encodeURIComponent('' + projectTypeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetExpenseTypeByProjectTypeList(_response);
    });
  }

  protected processGetExpenseTypeByProjectTypeList(response: Response): Promise<ExpenseTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ExpenseTypeDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ExpenseTypeDto[]>(null as any);
  }
}

export interface IFinancingSourcesService {
  getFinancingSourceList(): Promise<FinancingSourceDto[]>;
}

export class FinancingSourcesService implements IFinancingSourcesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getFinancingSourceList(): Promise<FinancingSourceDto[]> {
    let url_ = this.baseUrl + '/api/v2/FinancingSources/financing-sources';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFinancingSourceList(_response);
    });
  }

  protected processGetFinancingSourceList(response: Response): Promise<FinancingSourceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as FinancingSourceDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FinancingSourceDto[]>(null as any);
  }
}

export interface IFocusAreaService {
  getFocusAreaList(clusterId: string, active?: boolean | null | undefined): Promise<FocusAreaDto[]>;

  getFocusArea(focusAreaId: string): Promise<FocusAreaDto>;

  updateFocusArea(focusAreaId: string, focusArea: FocusAreaUpdateDto): Promise<FocusAreaDto>;

  deleteFocusArea(focusAreaId: string): Promise<string>;

  postFocusArea(focusArea: FocusAreaCreateDto): Promise<FocusAreaDto>;
}

export class FocusAreaService implements IFocusAreaService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getFocusAreaList(clusterId: string, active?: boolean | null | undefined): Promise<FocusAreaDto[]> {
    let url_ = this.baseUrl + '/api/v2/FocusArea/list/{clusterId}?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (active !== undefined && active !== null) url_ += 'active=' + encodeURIComponent('' + active) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFocusAreaList(_response);
    });
  }

  protected processGetFocusAreaList(response: Response): Promise<FocusAreaDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FocusAreaDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FocusAreaDto[]>(null as any);
  }

  getFocusArea(focusAreaId: string): Promise<FocusAreaDto> {
    let url_ = this.baseUrl + '/api/v2/FocusArea/{focusAreaId}';
    if (focusAreaId === undefined || focusAreaId === null)
      throw new Error("The parameter 'focusAreaId' must be defined.");
    url_ = url_.replace('{focusAreaId}', encodeURIComponent('' + focusAreaId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFocusArea(_response);
    });
  }

  protected processGetFocusArea(response: Response): Promise<FocusAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FocusAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FocusAreaDto>(null as any);
  }

  updateFocusArea(focusAreaId: string, focusArea: FocusAreaUpdateDto): Promise<FocusAreaDto> {
    let url_ = this.baseUrl + '/api/v2/FocusArea/{focusAreaId}';
    if (focusAreaId === undefined || focusAreaId === null)
      throw new Error("The parameter 'focusAreaId' must be defined.");
    url_ = url_.replace('{focusAreaId}', encodeURIComponent('' + focusAreaId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(focusArea);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFocusArea(_response);
    });
  }

  protected processUpdateFocusArea(response: Response): Promise<FocusAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FocusAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FocusAreaDto>(null as any);
  }

  deleteFocusArea(focusAreaId: string): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/FocusArea/{focusAreaId}';
    if (focusAreaId === undefined || focusAreaId === null)
      throw new Error("The parameter 'focusAreaId' must be defined.");
    url_ = url_.replace('{focusAreaId}', encodeURIComponent('' + focusAreaId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFocusArea(_response);
    });
  }

  protected processDeleteFocusArea(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  postFocusArea(focusArea: FocusAreaCreateDto): Promise<FocusAreaDto> {
    let url_ = this.baseUrl + '/api/v2/FocusArea';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(focusArea);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostFocusArea(_response);
    });
  }

  protected processPostFocusArea(response: Response): Promise<FocusAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FocusAreaDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FocusAreaDto>(null as any);
  }
}

export interface IMainGoalService {
  getMainGoalList(clusterId: string, active?: boolean | null | undefined): Promise<MainGoalDto[]>;

  getMainGoal(mainGoalId: string): Promise<MainGoalDto>;

  updateMainGoal(mainGoalId: string, mainGoal: MainGoalUpdateDto): Promise<MainGoalDto>;

  deleteMainGoal(mainGoalId: string): Promise<string>;

  postMainGoal(mainGoal: MainGoalCreateDto): Promise<MainGoalDto>;
}

export class MainGoalService implements IMainGoalService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getMainGoalList(clusterId: string, active?: boolean | null | undefined): Promise<MainGoalDto[]> {
    let url_ = this.baseUrl + '/api/v2/MainGoal/list/{clusterId}?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (active !== undefined && active !== null) url_ += 'active=' + encodeURIComponent('' + active) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetMainGoalList(_response);
    });
  }

  protected processGetMainGoalList(response: Response): Promise<MainGoalDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MainGoalDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<MainGoalDto[]>(null as any);
  }

  getMainGoal(mainGoalId: string): Promise<MainGoalDto> {
    let url_ = this.baseUrl + '/api/v2/MainGoal/{mainGoalId}';
    if (mainGoalId === undefined || mainGoalId === null)
      throw new Error("The parameter 'mainGoalId' must be defined.");
    url_ = url_.replace('{mainGoalId}', encodeURIComponent('' + mainGoalId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetMainGoal(_response);
    });
  }

  protected processGetMainGoal(response: Response): Promise<MainGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MainGoalDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<MainGoalDto>(null as any);
  }

  updateMainGoal(mainGoalId: string, mainGoal: MainGoalUpdateDto): Promise<MainGoalDto> {
    let url_ = this.baseUrl + '/api/v2/MainGoal/{mainGoalId}';
    if (mainGoalId === undefined || mainGoalId === null)
      throw new Error("The parameter 'mainGoalId' must be defined.");
    url_ = url_.replace('{mainGoalId}', encodeURIComponent('' + mainGoalId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mainGoal);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateMainGoal(_response);
    });
  }

  protected processUpdateMainGoal(response: Response): Promise<MainGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MainGoalDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<MainGoalDto>(null as any);
  }

  deleteMainGoal(mainGoalId: string): Promise<string> {
    let url_ = this.baseUrl + '/api/v2/MainGoal/{mainGoalId}';
    if (mainGoalId === undefined || mainGoalId === null)
      throw new Error("The parameter 'mainGoalId' must be defined.");
    url_ = url_.replace('{mainGoalId}', encodeURIComponent('' + mainGoalId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteMainGoal(_response);
    });
  }

  protected processDeleteMainGoal(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  postMainGoal(mainGoal: MainGoalCreateDto): Promise<MainGoalDto> {
    let url_ = this.baseUrl + '/api/v2/MainGoal';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mainGoal);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostMainGoal(_response);
    });
  }

  protected processPostMainGoal(response: Response): Promise<MainGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MainGoalDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<MainGoalDto>(null as any);
  }
}

export interface IMaintenanceService {
  /**
   * Get active service health message
   * @return Currently active service health message
   */
  getActiveServiceHealthMessage(): Promise<ServiceHealthMessageDto>;
}

export class MaintenanceService implements IMaintenanceService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get active service health message
   * @return Currently active service health message
   */
  getActiveServiceHealthMessage(): Promise<ServiceHealthMessageDto> {
    let url_ = this.baseUrl + '/api/v2/Maintenance';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetActiveServiceHealthMessage(_response);
    });
  }

  protected processGetActiveServiceHealthMessage(response: Response): Promise<ServiceHealthMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ServiceHealthMessageDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ServiceHealthMessageDto>(null as any);
  }
}

export interface IOnboardingPacketsService {
  /**
   * Get possible onboarding packets for current cluster and clusterUser
   */
  getOnboardingPackets(clusterUserId: string): Promise<OnboardingPacketDto[]>;

  /**
   * Mark onboarding as complete for user/cluster/packet combination
   */
  completeOnboarding(clusterUserId: string, onboardingPacketId: string): Promise<void>;
}

export class OnboardingPacketsService implements IOnboardingPacketsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get possible onboarding packets for current cluster and clusterUser
   */
  getOnboardingPackets(clusterUserId: string): Promise<OnboardingPacketDto[]> {
    let url_ = this.baseUrl + '/api/v2/OnboardingPackets/clusterusers/{clusterUserId}';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOnboardingPackets(_response);
    });
  }

  protected processGetOnboardingPackets(response: Response): Promise<OnboardingPacketDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OnboardingPacketDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OnboardingPacketDto[]>(null as any);
  }

  /**
   * Mark onboarding as complete for user/cluster/packet combination
   */
  completeOnboarding(clusterUserId: string, onboardingPacketId: string): Promise<void> {
    let url_ =
      this.baseUrl + '/api/v2/OnboardingPackets/{onboardingPacketId}/clusterusers/{clusterUserId}/complete';
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    if (onboardingPacketId === undefined || onboardingPacketId === null)
      throw new Error("The parameter 'onboardingPacketId' must be defined.");
    url_ = url_.replace('{onboardingPacketId}', encodeURIComponent('' + onboardingPacketId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCompleteOnboarding(_response);
    });
  }

  protected processCompleteOnboarding(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IOneWayInService {
  /**
   * Get all one way in forms
   * @param top (optional)
   * @param page (optional) Page
   * @param oldToNew (optional) Get oldest to newest
   * @param fromDate (optional) Get forms from a certain date
   * @param toDate (optional) Get forms until a certain date
   * @return One way in forms
   */
  getAllForms(
    top?: number | undefined,
    page?: number | null | undefined,
    oldToNew?: boolean | null | undefined,
    fromDate?: Date | null | undefined,
    toDate?: Date | null | undefined,
  ): Promise<OneWayInFormCollection>;

  /**
   * Get all one way in forms that have been referred from other clusters/actors
   * @return One way in forms
   */
  getAllReferredForms(): Promise<OneWayInOpportunitySimpleV2Dto[]>;

  /**
   * Get all one way in forms
   * @param page (optional) Page
   * @return One way in forms
   */
  getAllFormsByMunicipality(
    filter: OneWayInMyPageListFormsFilter,
    page?: number | null | undefined,
  ): Promise<OneWayInFormCollection>;

  /**
   * Get an inquiry directly from EnVeiInn
   * @param formId The ID of the form
   * @return The grouped inquiry form
   */
  getInquiry(formId: string): Promise<GruppertSkjema>;

  getOpportunity(formId?: string | undefined): Promise<OneWayInOpportunityDto>;

  /**
   * Get course and event enrollments
   * @param formId The ID of the form
   * @return Course and event enrollments
   */
  getEnrollments(formId: string): Promise<Feltgruppe>;

  /**
   * Get customer roles for companies related to the form
   * @param formId The ID of the form
   * @return The customer roles as a field group
   */
  getCustomerRoles(formId: string): Promise<Feltgruppe>;

  /**
   * Get previous grants and applications for a One Way In form
   * @param formId The ID of the form
   * @return Previous grants and applications as a field group
   */
  getApplications(formId: string): Promise<Feltgruppe>;

  /**
   * Get the One way in form details attachment
   * @param formId The ID of the form
   * @param attachmentId The ID of the attachment
   * @return Attachment file
   */
  getOpportunityFormAttachment(formId: string, attachmentId: string): Promise<FileResponse>;

  /**
   * Get the One way in stored opportunity simple list
   * @return Collection of one way in list items
   */
  getOneWayInOpportunityList(): Promise<OneWayInOpportunitySimpleV2Dto[]>;

  /**
   * Create a new Opportunity
   * @return Opportunity
   */
  createOneWayInOpportunity(createDto: OneWayInOpportunityCreateDto): Promise<OneWayInOpportunityDto>;

  /**
   * Update One Way In Opportunity Status
   * @return Opportunity
   */
  putWayInOpportunityStatus(updateDto: OneWayInOpportunityStatusCreateDto): Promise<OneWayInOpportunityDto>;

  /**
   * Get specific One Way In opportunity
   * @param id ID of the opportunity
   * @return Opportunity
   */
  getOneWayInOpportunity(id: string): Promise<OneWayInOpportunityDto>;

  /**
   * Add member to opportunity
   */
  addMember(organizationNumber: string, oneWayInId: string): Promise<void>;

  /**
   * Add member to opportunity
   * @param emailDto (optional)
   */
  addAdvisor(
    opportunityId: string,
    clusterUserId: string,
    emailDto?: AddAdvisorNotificationEmailDto | undefined,
  ): Promise<void>;

  archiveOneWayInOpportunity(
    batchArchiveOpportunityDto: BatchArchiveOpportunityDto,
  ): Promise<OneWayInOpportunityDto>;

  /**
   * Update One Way In Opportunity Status
   * @param recommendation DTO for the necessary recommendation creation
   * @return Opportunity
   */
  recommendServices(recommendation: OneWayInRecommendation): Promise<OneWayInOpportunityDto>;

  /**
   * Share a one way opportunity with others
   * @param id ID of the opportunity
   * @param createDto DTO with relevant sharing data
   * @return Opportunity
   */
  shareOpportunity(id: string, createDto: CreateSharedStatusDto): Promise<OneWayInOpportunityDto>;

  /**
   * Full history of a One Way In opportunity
   * @param oneWayInId OneWayInID of the opportunity
   * @return Opportunity
   */
  getOneWayInOpportunityFullHistory(oneWayInId: string): Promise<OneWayInOpportunityStatusDto[]>;

  /**
   * Get the actors that have access to a One Way In opportunity
   * @param oneWayInId OneWayInID of the opportunity, i.e. 040881ee-da90-4298-93d9-eab6320db390|dfb05674-00f2-4cd3-b7d6-0ab296c36682
   * @return Collection of actors with access
   */
  getActorsWithAccessToOpportunity(oneWayInId: string): Promise<ActorWithAccessToOpportunityDto[]>;

  /**
   * Get the IN email response to the inquiry applicationy
   * @param id OneWayInID of the opportunity
   * @return Opportunity
   */
  getInquiryINResponse(id: string): Promise<OpportunityEmail>;

  /**
   * Get the actors that have referred the inquiry to the current actor, and the services they recommended
   * @param id OneWayInID of the opportunity
   * @return Recommendations
   */
  getOpportunityReferrals(id: string): Promise<OpportunityReferral[]>;

  getAllSharedOpportunityFormLinks(): Promise<SharedOpportunityFormLinkDto[]>;

  sendEmailToCustomer(dto: SendEmailToCustomerDto, b2cId?: string | null | undefined): Promise<void>;

  getAllEmailThreadsForOpportunity(opportunityId: string): Promise<OpportunityEmailThreadListDto[]>;

  getEmailThreadDetails(threadId: number): Promise<OpportunityEmailThreadDto>;

  getPublicStatistics(): Promise<OneWayInPublicStatisticsDto>;
}

export class OneWayInService implements IOneWayInService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get all one way in forms
   * @param top (optional)
   * @param page (optional) Page
   * @param oldToNew (optional) Get oldest to newest
   * @param fromDate (optional) Get forms from a certain date
   * @param toDate (optional) Get forms until a certain date
   * @return One way in forms
   */
  getAllForms(
    top?: number | undefined,
    page?: number | null | undefined,
    oldToNew?: boolean | null | undefined,
    fromDate?: Date | null | undefined,
    toDate?: Date | null | undefined,
  ): Promise<OneWayInFormCollection> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/forms?';
    if (top === null) throw new Error("The parameter 'top' cannot be null.");
    else if (top !== undefined) url_ += 'top=' + encodeURIComponent('' + top) + '&';
    if (page !== undefined && page !== null) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (oldToNew !== undefined && oldToNew !== null)
      url_ += 'oldToNew=' + encodeURIComponent('' + oldToNew) + '&';
    if (fromDate !== undefined && fromDate !== null)
      url_ += 'fromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
    if (toDate !== undefined && toDate !== null)
      url_ += 'toDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllForms(_response);
    });
  }

  protected processGetAllForms(response: Response): Promise<OneWayInFormCollection> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFormCollection);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFormCollection>(null as any);
  }

  /**
   * Get all one way in forms that have been referred from other clusters/actors
   * @return One way in forms
   */
  getAllReferredForms(): Promise<OneWayInOpportunitySimpleV2Dto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/referredforms';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllReferredForms(_response);
    });
  }

  protected processGetAllReferredForms(response: Response): Promise<OneWayInOpportunitySimpleV2Dto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunitySimpleV2Dto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunitySimpleV2Dto[]>(null as any);
  }

  /**
   * Get all one way in forms
   * @param page (optional) Page
   * @return One way in forms
   */
  getAllFormsByMunicipality(
    filter: OneWayInMyPageListFormsFilter,
    page?: number | null | undefined,
  ): Promise<OneWayInFormCollection> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/formsByMunicipality?';
    if (page !== undefined && page !== null) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllFormsByMunicipality(_response);
    });
  }

  protected processGetAllFormsByMunicipality(response: Response): Promise<OneWayInFormCollection> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFormCollection);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFormCollection>(null as any);
  }

  /**
   * Get an inquiry directly from EnVeiInn
   * @param formId The ID of the form
   * @return The grouped inquiry form
   */
  getInquiry(formId: string): Promise<GruppertSkjema> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/inquiry/{formId}';
    if (formId === undefined || formId === null) throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace('{formId}', encodeURIComponent('' + formId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInquiry(_response);
    });
  }

  protected processGetInquiry(response: Response): Promise<GruppertSkjema> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GruppertSkjema);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GruppertSkjema>(null as any);
  }

  getOpportunity(formId?: string | undefined): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn?';
    if (formId === null) throw new Error("The parameter 'formId' cannot be null.");
    else if (formId !== undefined) url_ += 'formId=' + encodeURIComponent('' + formId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOpportunity(_response);
    });
  }

  protected processGetOpportunity(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Get course and event enrollments
   * @param formId The ID of the form
   * @return Course and event enrollments
   */
  getEnrollments(formId: string): Promise<Feltgruppe> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/enrollments/{formId}';
    if (formId === undefined || formId === null) throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace('{formId}', encodeURIComponent('' + formId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEnrollments(_response);
    });
  }

  protected processGetEnrollments(response: Response): Promise<Feltgruppe> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Feltgruppe);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Feltgruppe>(null as any);
  }

  /**
   * Get customer roles for companies related to the form
   * @param formId The ID of the form
   * @return The customer roles as a field group
   */
  getCustomerRoles(formId: string): Promise<Feltgruppe> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/customerroles/{formId}';
    if (formId === undefined || formId === null) throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace('{formId}', encodeURIComponent('' + formId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomerRoles(_response);
    });
  }

  protected processGetCustomerRoles(response: Response): Promise<Feltgruppe> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Feltgruppe);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Feltgruppe>(null as any);
  }

  /**
   * Get previous grants and applications for a One Way In form
   * @param formId The ID of the form
   * @return Previous grants and applications as a field group
   */
  getApplications(formId: string): Promise<Feltgruppe> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/applications/{formId}';
    if (formId === undefined || formId === null) throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace('{formId}', encodeURIComponent('' + formId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetApplications(_response);
    });
  }

  protected processGetApplications(response: Response): Promise<Feltgruppe> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Feltgruppe);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Feltgruppe>(null as any);
  }

  /**
   * Get the One way in form details attachment
   * @param formId The ID of the form
   * @param attachmentId The ID of the attachment
   * @return Attachment file
   */
  getOpportunityFormAttachment(formId: string, attachmentId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/formdetails/{formId}/vedlegg/{attachmentId}';
    if (formId === undefined || formId === null) throw new Error("The parameter 'formId' must be defined.");
    url_ = url_.replace('{formId}', encodeURIComponent('' + formId));
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOpportunityFormAttachment(_response);
    });
  }

  protected processGetOpportunityFormAttachment(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get the One way in stored opportunity simple list
   * @return Collection of one way in list items
   */
  getOneWayInOpportunityList(): Promise<OneWayInOpportunitySimpleV2Dto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInOpportunityList(_response);
    });
  }

  protected processGetOneWayInOpportunityList(response: Response): Promise<OneWayInOpportunitySimpleV2Dto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunitySimpleV2Dto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunitySimpleV2Dto[]>(null as any);
  }

  /**
   * Create a new Opportunity
   * @return Opportunity
   */
  createOneWayInOpportunity(createDto: OneWayInOpportunityCreateDto): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateOneWayInOpportunity(_response);
    });
  }

  protected processCreateOneWayInOpportunity(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Update One Way In Opportunity Status
   * @return Opportunity
   */
  putWayInOpportunityStatus(updateDto: OneWayInOpportunityStatusCreateDto): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPutWayInOpportunityStatus(_response);
    });
  }

  protected processPutWayInOpportunityStatus(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Get specific One Way In opportunity
   * @param id ID of the opportunity
   * @return Opportunity
   */
  getOneWayInOpportunity(id: string): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInOpportunity(_response);
    });
  }

  protected processGetOneWayInOpportunity(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Add member to opportunity
   */
  addMember(organizationNumber: string, oneWayInId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{oneWayInId}/add-member/{organizationNumber}';
    if (organizationNumber === undefined || organizationNumber === null)
      throw new Error("The parameter 'organizationNumber' must be defined.");
    url_ = url_.replace('{organizationNumber}', encodeURIComponent('' + organizationNumber));
    if (oneWayInId === undefined || oneWayInId === null)
      throw new Error("The parameter 'oneWayInId' must be defined.");
    url_ = url_.replace('{oneWayInId}', encodeURIComponent('' + oneWayInId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddMember(_response);
    });
  }

  protected processAddMember(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Add member to opportunity
   * @param emailDto (optional)
   */
  addAdvisor(
    opportunityId: string,
    clusterUserId: string,
    emailDto?: AddAdvisorNotificationEmailDto | undefined,
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{opportunityId}/add-advisor/{clusterUserId}';
    if (opportunityId === undefined || opportunityId === null)
      throw new Error("The parameter 'opportunityId' must be defined.");
    url_ = url_.replace('{opportunityId}', encodeURIComponent('' + opportunityId));
    if (clusterUserId === undefined || clusterUserId === null)
      throw new Error("The parameter 'clusterUserId' must be defined.");
    url_ = url_.replace('{clusterUserId}', encodeURIComponent('' + clusterUserId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(emailDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddAdvisor(_response);
    });
  }

  protected processAddAdvisor(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  archiveOneWayInOpportunity(
    batchArchiveOpportunityDto: BatchArchiveOpportunityDto,
  ): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/archive-opportunity';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(batchArchiveOpportunityDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processArchiveOneWayInOpportunity(_response);
    });
  }

  protected processArchiveOneWayInOpportunity(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Update One Way In Opportunity Status
   * @param recommendation DTO for the necessary recommendation creation
   * @return Opportunity
   */
  recommendServices(recommendation: OneWayInRecommendation): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/recommend';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(recommendation);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRecommendServices(_response);
    });
  }

  protected processRecommendServices(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Share a one way opportunity with others
   * @param id ID of the opportunity
   * @param createDto DTO with relevant sharing data
   * @return Opportunity
   */
  shareOpportunity(id: string, createDto: CreateSharedStatusDto): Promise<OneWayInOpportunityDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{id}/share';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processShareOpportunity(_response);
    });
  }

  protected processShareOpportunity(response: Response): Promise<OneWayInOpportunityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityDto>(null as any);
  }

  /**
   * Full history of a One Way In opportunity
   * @param oneWayInId OneWayInID of the opportunity
   * @return Opportunity
   */
  getOneWayInOpportunityFullHistory(oneWayInId: string): Promise<OneWayInOpportunityStatusDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{oneWayInId}/history';
    if (oneWayInId === undefined || oneWayInId === null)
      throw new Error("The parameter 'oneWayInId' must be defined.");
    url_ = url_.replace('{oneWayInId}', encodeURIComponent('' + oneWayInId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInOpportunityFullHistory(_response);
    });
  }

  protected processGetOneWayInOpportunityFullHistory(
    response: Response,
  ): Promise<OneWayInOpportunityStatusDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInOpportunityStatusDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInOpportunityStatusDto[]>(null as any);
  }

  /**
   * Get the actors that have access to a One Way In opportunity
   * @param oneWayInId OneWayInID of the opportunity, i.e. 040881ee-da90-4298-93d9-eab6320db390|dfb05674-00f2-4cd3-b7d6-0ab296c36682
   * @return Collection of actors with access
   */
  getActorsWithAccessToOpportunity(oneWayInId: string): Promise<ActorWithAccessToOpportunityDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{oneWayInId}/actors-with-access';
    if (oneWayInId === undefined || oneWayInId === null)
      throw new Error("The parameter 'oneWayInId' must be defined.");
    url_ = url_.replace('{oneWayInId}', encodeURIComponent('' + oneWayInId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetActorsWithAccessToOpportunity(_response);
    });
  }

  protected processGetActorsWithAccessToOpportunity(
    response: Response,
  ): Promise<ActorWithAccessToOpportunityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ActorWithAccessToOpportunityDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ActorWithAccessToOpportunityDto[]>(null as any);
  }

  /**
   * Get the IN email response to the inquiry applicationy
   * @param id OneWayInID of the opportunity
   * @return Opportunity
   */
  getInquiryINResponse(id: string): Promise<OpportunityEmail> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{id}/response';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInquiryINResponse(_response);
    });
  }

  protected processGetInquiryINResponse(response: Response): Promise<OpportunityEmail> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEmail);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OpportunityEmail>(null as any);
  }

  /**
   * Get the actors that have referred the inquiry to the current actor, and the services they recommended
   * @param id OneWayInID of the opportunity
   * @return Recommendations
   */
  getOpportunityReferrals(id: string): Promise<OpportunityReferral[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{id}/recommendations';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOpportunityReferrals(_response);
    });
  }

  protected processGetOpportunityReferrals(response: Response): Promise<OpportunityReferral[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OpportunityReferral[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OpportunityReferral[]>(null as any);
  }

  getAllSharedOpportunityFormLinks(): Promise<SharedOpportunityFormLinkDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/sharedLink';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllSharedOpportunityFormLinks(_response);
    });
  }

  protected processGetAllSharedOpportunityFormLinks(
    response: Response,
  ): Promise<SharedOpportunityFormLinkDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SharedOpportunityFormLinkDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SharedOpportunityFormLinkDto[]>(null as any);
  }

  sendEmailToCustomer(dto: SendEmailToCustomerDto, b2cId?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/threads?';
    if (b2cId !== undefined && b2cId !== null) url_ += 'b2cId=' + encodeURIComponent('' + b2cId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendEmailToCustomer(_response);
    });
  }

  protected processSendEmailToCustomer(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 406) {
      return response.text().then((_responseText) => {
        let result406: any = null;
        result406 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result406);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getAllEmailThreadsForOpportunity(opportunityId: string): Promise<OpportunityEmailThreadListDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/{opportunityId}/threads';
    if (opportunityId === undefined || opportunityId === null)
      throw new Error("The parameter 'opportunityId' must be defined.");
    url_ = url_.replace('{opportunityId}', encodeURIComponent('' + opportunityId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllEmailThreadsForOpportunity(_response);
    });
  }

  protected processGetAllEmailThreadsForOpportunity(
    response: Response,
  ): Promise<OpportunityEmailThreadListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEmailThreadListDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OpportunityEmailThreadListDto[]>(null as any);
  }

  getEmailThreadDetails(threadId: number): Promise<OpportunityEmailThreadDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/opportunity/threads/{threadId}';
    if (threadId === undefined || threadId === null)
      throw new Error("The parameter 'threadId' must be defined.");
    url_ = url_.replace('{threadId}', encodeURIComponent('' + threadId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEmailThreadDetails(_response);
    });
  }

  protected processGetEmailThreadDetails(response: Response): Promise<OpportunityEmailThreadDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEmailThreadDto);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OpportunityEmailThreadDto>(null as any);
  }

  getPublicStatistics(): Promise<OneWayInPublicStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayIn/statistics';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPublicStatistics(_response);
    });
  }

  protected processGetPublicStatistics(response: Response): Promise<OneWayInPublicStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInPublicStatisticsDto);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInPublicStatisticsDto>(null as any);
  }
}

export interface IOneWayInFeedbackService {
  /**
   * Get one way in feedback list for actor
   * @return List of OneWayInFeedbackDto
   */
  getFeedbackList(): Promise<OneWayInFeedbackDto[]>;

  /**
   * Upsert one way in feedback
   * @return One way in feedback
   */
  upsertFeedback(upsertDto: OneWayInFeedbackUpsertDto): Promise<OneWayInFeedbackDto>;

  /**
   * Get one way in opportunity feedback
   * @return One way in opportunity feedback
   */
  getOneWayInFeedback(d365Id: string): Promise<OneWayInFeedbackDto>;

  /**
   * Gets all the feedbacks for a given one way in opportunity sorted in actor feedback and other feedback
   * @return OneWayInFeedbackCollectionDto
   */
  getAllFeedbacksForOpportunity(d365Id: string): Promise<OneWayInFeedbackCollectionDto>;
}

export class OneWayInFeedbackService implements IOneWayInFeedbackService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get one way in feedback list for actor
   * @return List of OneWayInFeedbackDto
   */
  getFeedbackList(): Promise<OneWayInFeedbackDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayInFeedback';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeedbackList(_response);
    });
  }

  protected processGetFeedbackList(response: Response): Promise<OneWayInFeedbackDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFeedbackDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFeedbackDto[]>(null as any);
  }

  /**
   * Upsert one way in feedback
   * @return One way in feedback
   */
  upsertFeedback(upsertDto: OneWayInFeedbackUpsertDto): Promise<OneWayInFeedbackDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayInFeedback';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(upsertDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertFeedback(_response);
    });
  }

  protected processUpsertFeedback(response: Response): Promise<OneWayInFeedbackDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFeedbackDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFeedbackDto>(null as any);
  }

  /**
   * Get one way in opportunity feedback
   * @return One way in opportunity feedback
   */
  getOneWayInFeedback(d365Id: string): Promise<OneWayInFeedbackDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayInFeedback/{d365Id}';
    if (d365Id === undefined || d365Id === null) throw new Error("The parameter 'd365Id' must be defined.");
    url_ = url_.replace('{d365Id}', encodeURIComponent('' + d365Id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInFeedback(_response);
    });
  }

  protected processGetOneWayInFeedback(response: Response): Promise<OneWayInFeedbackDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFeedbackDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFeedbackDto>(null as any);
  }

  /**
   * Gets all the feedbacks for a given one way in opportunity sorted in actor feedback and other feedback
   * @return OneWayInFeedbackCollectionDto
   */
  getAllFeedbacksForOpportunity(d365Id: string): Promise<OneWayInFeedbackCollectionDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayInFeedback/collection/{d365Id}';
    if (d365Id === undefined || d365Id === null) throw new Error("The parameter 'd365Id' must be defined.");
    url_ = url_.replace('{d365Id}', encodeURIComponent('' + d365Id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllFeedbacksForOpportunity(_response);
    });
  }

  protected processGetAllFeedbacksForOpportunity(response: Response): Promise<OneWayInFeedbackCollectionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFeedbackCollectionDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFeedbackCollectionDto>(null as any);
  }
}

export interface IOneWayInServicesService {
  /**
   * Get all internal One Way In services
   * @param searchCriteria Filtering the response list.
   * @return OneWayInServices
   */
  getOneWayInServices(searchCriteria: OneWayInServiceSearchCriteria): Promise<OneWayInServiceDto[]>;

  /**
   * One Way In Service Upsert
   * @param upsertDto The OneWayInServiceUpsertDto
   */
  upsert(upsertDto: OneWayInServiceUpsertDto): Promise<OneWayInServiceUpsertDto>;

  /**
   * Get a single One Way In service
   * @param id The id of the One Way In service
   * @return OneWayInService
   */
  getOneWayInService(id: string): Promise<OneWayInServiceDto>;

  /**
   * One Way In Service Delete
   */
  delete(id: string): Promise<void>;

  /**
   * Get the One Way In Service Providers
   * @return Collection of One Way In Services
   */
  getOneWayInServiceProviders(): Promise<OneWayInServiceProviderDto[]>;
}

export class OneWayInServicesService implements IOneWayInServicesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get all internal One Way In services
   * @param searchCriteria Filtering the response list.
   * @return OneWayInServices
   */
  getOneWayInServices(searchCriteria: OneWayInServiceSearchCriteria): Promise<OneWayInServiceDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayInServices';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(searchCriteria);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInServices(_response);
    });
  }

  protected processGetOneWayInServices(response: Response): Promise<OneWayInServiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInServiceDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInServiceDto[]>(null as any);
  }

  /**
   * One Way In Service Upsert
   * @param upsertDto The OneWayInServiceUpsertDto
   */
  upsert(upsertDto: OneWayInServiceUpsertDto): Promise<OneWayInServiceUpsertDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayInServices';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(upsertDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsert(_response);
    });
  }

  protected processUpsert(response: Response): Promise<OneWayInServiceUpsertDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInServiceUpsertDto);
        return result201;
      });
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInServiceUpsertDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInServiceUpsertDto>(null as any);
  }

  /**
   * Get a single One Way In service
   * @param id The id of the One Way In service
   * @return OneWayInService
   */
  getOneWayInService(id: string): Promise<OneWayInServiceDto> {
    let url_ = this.baseUrl + '/api/v2/OneWayInServices/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInService(_response);
    });
  }

  protected processGetOneWayInService(response: Response): Promise<OneWayInServiceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInServiceDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInServiceDto>(null as any);
  }

  /**
   * One Way In Service Delete
   */
  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OneWayInServices/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get the One Way In Service Providers
   * @return Collection of One Way In Services
   */
  getOneWayInServiceProviders(): Promise<OneWayInServiceProviderDto[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayInServices/serviceproviders';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInServiceProviders(_response);
    });
  }

  protected processGetOneWayInServiceProviders(response: Response): Promise<OneWayInServiceProviderDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInServiceProviderDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInServiceProviderDto[]>(null as any);
  }
}

export interface IOneWayInVMAService {
  /**
   * Get all One Way In VMAs
   * @return List of VMAs
   */
  getOneWayInVMAs(): Promise<OneWayInVMA[]>;

  /**
   * Get all one way in forms from a VMA (virkemiddelaktor)
   * @param page (optional) Page
   * @return One way in forms
   */
  getAllVMAForms(
    filter: OneWayInMyPageListFormsFilter,
    vmaIdOrName: string,
    page?: number | null | undefined,
  ): Promise<OneWayInFormCollection>;
}

export class OneWayInVMAService implements IOneWayInVMAService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get all One Way In VMAs
   * @return List of VMAs
   */
  getOneWayInVMAs(): Promise<OneWayInVMA[]> {
    let url_ = this.baseUrl + '/api/v2/OneWayInVMA';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOneWayInVMAs(_response);
    });
  }

  protected processGetOneWayInVMAs(response: Response): Promise<OneWayInVMA[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInVMA[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInVMA[]>(null as any);
  }

  /**
   * Get all one way in forms from a VMA (virkemiddelaktor)
   * @param page (optional) Page
   * @return One way in forms
   */
  getAllVMAForms(
    filter: OneWayInMyPageListFormsFilter,
    vmaIdOrName: string,
    page?: number | null | undefined,
  ): Promise<OneWayInFormCollection> {
    let url_ = this.baseUrl + '/api/v2/OneWayInVMA/{vmaIdOrName}/forms?';
    if (vmaIdOrName === undefined || vmaIdOrName === null)
      throw new Error("The parameter 'vmaIdOrName' must be defined.");
    url_ = url_.replace('{vmaIdOrName}', encodeURIComponent('' + vmaIdOrName));
    if (page !== undefined && page !== null) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllVMAForms(_response);
    });
  }

  protected processGetAllVMAForms(response: Response): Promise<OneWayInFormCollection> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OneWayInFormCollection);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OneWayInFormCollection>(null as any);
  }
}

export interface IOperationApplicationsService {
  /**
   * Retrieves statistics for the operation application.
   * @return OperationApplicationStatisticsDto
   */
  getOperationApplicationStatisticsV2(
    operationApplicationId: string,
  ): Promise<OperationApplicationStatisticsDto>;

  /**
   * Retrieves the latest operation application for clusterId
   * @return OperationApplicationDto
   */
  getActiveOperationApplicationForCluster(clusterId: string): Promise<OperationApplicationDto>;

  /**
   * Retrieves the operation application
   * @return OperationApplicationDto
   */
  getOperationApplication(operationApplicationId: string): Promise<OperationApplicationDto>;

  /**
   * Retrieves all operation applications for Cluster
   * @return A list OperationApplicationDto
   */
  getOperationApplicationList(clusterId: string): Promise<OperationApplicationDto[]>;
}

export class OperationApplicationsService implements IOperationApplicationsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Retrieves statistics for the operation application.
   * @return OperationApplicationStatisticsDto
   */
  getOperationApplicationStatisticsV2(
    operationApplicationId: string,
  ): Promise<OperationApplicationStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/OperationApplications/{operationApplicationId}/statistics';
    if (operationApplicationId === undefined || operationApplicationId === null)
      throw new Error("The parameter 'operationApplicationId' must be defined.");
    url_ = url_.replace('{operationApplicationId}', encodeURIComponent('' + operationApplicationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationApplicationStatisticsV2(_response);
    });
  }

  protected processGetOperationApplicationStatisticsV2(
    response: Response,
  ): Promise<OperationApplicationStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationApplicationStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationApplicationStatisticsDto>(null as any);
  }

  /**
   * Retrieves the latest operation application for clusterId
   * @return OperationApplicationDto
   */
  getActiveOperationApplicationForCluster(clusterId: string): Promise<OperationApplicationDto> {
    let url_ = this.baseUrl + '/api/v2/clusters/{clusterId}/active-operation-application';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetActiveOperationApplicationForCluster(_response);
    });
  }

  protected processGetActiveOperationApplicationForCluster(
    response: Response,
  ): Promise<OperationApplicationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationApplicationDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationApplicationDto>(null as any);
  }

  /**
   * Retrieves the operation application
   * @return OperationApplicationDto
   */
  getOperationApplication(operationApplicationId: string): Promise<OperationApplicationDto> {
    let url_ = this.baseUrl + '/api/v2/OperationApplications/{operationApplicationId}';
    if (operationApplicationId === undefined || operationApplicationId === null)
      throw new Error("The parameter 'operationApplicationId' must be defined.");
    url_ = url_.replace('{operationApplicationId}', encodeURIComponent('' + operationApplicationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationApplication(_response);
    });
  }

  protected processGetOperationApplication(response: Response): Promise<OperationApplicationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationApplicationDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationApplicationDto>(null as any);
  }

  /**
   * Retrieves all operation applications for Cluster
   * @return A list OperationApplicationDto
   */
  getOperationApplicationList(clusterId: string): Promise<OperationApplicationDto[]> {
    let url_ = this.baseUrl + '/api/v2/clusters/{clusterId}/operation-application';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationApplicationList(_response);
    });
  }

  protected processGetOperationApplicationList(response: Response): Promise<OperationApplicationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationApplicationDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationApplicationDto[]>(null as any);
  }
}

export interface IOperationProjectsService {
  getOperationProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<OperationProjectListItemDto[]>;

  getOperationProject(projectId: string): Promise<OperationProjectDto>;

  changeOperationProjectType(projectId: string, projectTypeId: string): Promise<OperationProjectDto>;

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void>;

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto>;

  finalizeOperationProject(projectId: string, endReason: ProjectEndReasonCreateDto): Promise<void>;
}

export class OperationProjectsService implements IOperationProjectsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getOperationProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<OperationProjectListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{clusterId}/list?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (projectPhaseId !== undefined && projectPhaseId !== null)
      url_ += 'ProjectPhaseId=' + encodeURIComponent('' + projectPhaseId) + '&';
    if (mainGoalId !== undefined && mainGoalId !== null)
      url_ += 'MainGoalId=' + encodeURIComponent('' + mainGoalId) + '&';
    if (focusAreaId !== undefined && focusAreaId !== null)
      url_ += 'FocusAreaId=' + encodeURIComponent('' + focusAreaId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationProjects(_response);
    });
  }

  protected processGetOperationProjects(response: Response): Promise<OperationProjectListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationProjectListItemDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationProjectListItemDto[]>(null as any);
  }

  getOperationProject(projectId: string): Promise<OperationProjectDto> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetOperationProject(_response);
    });
  }

  protected processGetOperationProject(response: Response): Promise<OperationProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationProjectDto>(null as any);
  }

  changeOperationProjectType(projectId: string, projectTypeId: string): Promise<OperationProjectDto> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{projectId}/project-type';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(projectTypeId);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeOperationProjectType(_response);
    });
  }

  protected processChangeOperationProjectType(response: Response): Promise<OperationProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationProjectDto>(null as any);
  }

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{projectId}/project-members';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterMemberIds);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetProjectMembers(_response);
    });
  }

  protected processSetProjectMembers(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{projectId}/statistics';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectStatistics(_response);
    });
  }

  protected processGetProjectStatistics(response: Response): Promise<ProjectStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectStatisticsDto>(null as any);
  }

  finalizeOperationProject(projectId: string, endReason: ProjectEndReasonCreateDto): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/OperationProjects/{projectId}/finalize';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(endReason);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processFinalizeOperationProject(_response);
    });
  }

  protected processFinalizeOperationProject(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IPortalProjectsService {
  getProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<PortalProjectListItemDto[]>;

  getProject(projectId: string): Promise<PortalProjectDto>;

  putProject(projectId: string, project: PortalProjectUpdateDto): Promise<PortalProjectDto>;

  deleteProject(projectId: string): Promise<void>;

  postProject(project: PortalProjectCreateDto): Promise<PortalProjectDto>;

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void>;

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto>;
}

export class PortalProjectsService implements IPortalProjectsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjects(
    clusterId: string,
    projectPhaseId?: string | null | undefined,
    mainGoalId?: string | null | undefined,
    focusAreaId?: string | null | undefined,
  ): Promise<PortalProjectListItemDto[]> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{clusterId}/list?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (projectPhaseId !== undefined && projectPhaseId !== null)
      url_ += 'ProjectPhaseId=' + encodeURIComponent('' + projectPhaseId) + '&';
    if (mainGoalId !== undefined && mainGoalId !== null)
      url_ += 'MainGoalId=' + encodeURIComponent('' + mainGoalId) + '&';
    if (focusAreaId !== undefined && focusAreaId !== null)
      url_ += 'FocusAreaId=' + encodeURIComponent('' + focusAreaId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjects(_response);
    });
  }

  protected processGetProjects(response: Response): Promise<PortalProjectListItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PortalProjectListItemDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PortalProjectListItemDto[]>(null as any);
  }

  getProject(projectId: string): Promise<PortalProjectDto> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProject(_response);
    });
  }

  protected processGetProject(response: Response): Promise<PortalProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PortalProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PortalProjectDto>(null as any);
  }

  putProject(projectId: string, project: PortalProjectUpdateDto): Promise<PortalProjectDto> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(project);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPutProject(_response);
    });
  }

  protected processPutProject(response: Response): Promise<PortalProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PortalProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PortalProjectDto>(null as any);
  }

  deleteProject(projectId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteProject(_response);
    });
  }

  protected processDeleteProject(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  postProject(project: PortalProjectCreateDto): Promise<PortalProjectDto> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(project);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPostProject(_response);
    });
  }

  protected processPostProject(response: Response): Promise<PortalProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PortalProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PortalProjectDto>(null as any);
  }

  setProjectMembers(projectId: string, clusterMemberIds: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{projectId}/project-members';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clusterMemberIds);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetProjectMembers(_response);
    });
  }

  protected processSetProjectMembers(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getProjectStatistics(projectId: string): Promise<ProjectStatisticsDto> {
    let url_ = this.baseUrl + '/api/v2/PortalProjects/{projectId}/statistics';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectStatistics(_response);
    });
  }

  protected processGetProjectStatistics(response: Response): Promise<ProjectStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectStatisticsDto>(null as any);
  }
}

export interface IPortalStatisticsService {
  aggregatedAnnualReport(year?: number | undefined): Promise<AggregatedAnnualReportDto>;
}

export class PortalStatisticsService implements IPortalStatisticsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  aggregatedAnnualReport(year?: number | undefined): Promise<AggregatedAnnualReportDto> {
    let url_ = this.baseUrl + '/api/v2/PortalStatistics/AggregatedAnnualReport?';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAggregatedAnnualReport(_response);
    });
  }

  protected processAggregatedAnnualReport(response: Response): Promise<AggregatedAnnualReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as AggregatedAnnualReportDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AggregatedAnnualReportDto>(null as any);
  }
}

export interface IPortfolioIndustriesService {
  /**
   * List out all portfolio industries.
   */
  getPortfolioIndustries(): Promise<PortfolioIndustryDto[]>;
}

export class PortfolioIndustriesService implements IPortfolioIndustriesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * List out all portfolio industries.
   */
  getPortfolioIndustries(): Promise<PortfolioIndustryDto[]> {
    let url_ = this.baseUrl + '/api/v2/PortfolioIndustries';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPortfolioIndustries(_response);
    });
  }

  protected processGetPortfolioIndustries(response: Response): Promise<PortfolioIndustryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PortfolioIndustryDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PortfolioIndustryDto[]>(null as any);
  }
}

export interface IProjectCustomCategoriesService {
  getProjectCustomCategories(clusterId: string): Promise<CustomProjectCategoryDto[]>;

  getProjectCustomCategory(clusterId: string, categoryId: string): Promise<CustomProjectCategoryDto>;

  updateProjectCustomCategory(
    clusterId: string,
    categoryId: string,
    updateDto: CustomProjectCategoryUpdateDto,
  ): Promise<CustomProjectCategoryDto>;

  deleteProjectCustomCategory(clusterId: string, categoryId: string): Promise<void>;

  createProjectCustomCategory(
    clusterId: string,
    createDto: CustomProjectCategoryCreateDto,
  ): Promise<CustomProjectCategoryDto>;
}

export class ProjectCustomCategoriesService implements IProjectCustomCategoriesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjectCustomCategories(clusterId: string): Promise<CustomProjectCategoryDto[]> {
    let url_ = this.baseUrl + '/api/v2/ProjectCustomCategories/list/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectCustomCategories(_response);
    });
  }

  protected processGetProjectCustomCategories(response: Response): Promise<CustomProjectCategoryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomProjectCategoryDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomProjectCategoryDto[]>(null as any);
  }

  getProjectCustomCategory(clusterId: string, categoryId: string): Promise<CustomProjectCategoryDto> {
    let url_ = this.baseUrl + '/api/v2/ProjectCustomCategories/{clusterId}/{categoryId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (categoryId === undefined || categoryId === null)
      throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectCustomCategory(_response);
    });
  }

  protected processGetProjectCustomCategory(response: Response): Promise<CustomProjectCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomProjectCategoryDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomProjectCategoryDto>(null as any);
  }

  updateProjectCustomCategory(
    clusterId: string,
    categoryId: string,
    updateDto: CustomProjectCategoryUpdateDto,
  ): Promise<CustomProjectCategoryDto> {
    let url_ = this.baseUrl + '/api/v2/ProjectCustomCategories/{clusterId}/{categoryId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (categoryId === undefined || categoryId === null)
      throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDto);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateProjectCustomCategory(_response);
    });
  }

  protected processUpdateProjectCustomCategory(response: Response): Promise<CustomProjectCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomProjectCategoryDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomProjectCategoryDto>(null as any);
  }

  deleteProjectCustomCategory(clusterId: string, categoryId: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ProjectCustomCategories/{clusterId}/{categoryId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (categoryId === undefined || categoryId === null)
      throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteProjectCustomCategory(_response);
    });
  }

  protected processDeleteProjectCustomCategory(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  createProjectCustomCategory(
    clusterId: string,
    createDto: CustomProjectCategoryCreateDto,
  ): Promise<CustomProjectCategoryDto> {
    let url_ = this.baseUrl + '/api/v2/ProjectCustomCategories/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateProjectCustomCategory(_response);
    });
  }

  protected processCreateProjectCustomCategory(response: Response): Promise<CustomProjectCategoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomProjectCategoryDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result409);
      });
    } else if (status === 423) {
      return response.text().then((_responseText) => {
        let result423: any = null;
        result423 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result423);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomProjectCategoryDto>(null as any);
  }
}

export interface IProjectExpensesService {
  getExpensesForProject(projectId: string): Promise<ProjectExpenseDto[]>;

  updateProjectExpensesForProject(
    projectId: string,
    projectExpenses: ProjectExpenseUpdateDto[],
  ): Promise<OperationResultOfProjectExpenseDto[]>;
}

export class ProjectExpensesService implements IProjectExpensesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getExpensesForProject(projectId: string): Promise<ProjectExpenseDto[]> {
    let url_ = this.baseUrl + '/api/v2/projects/{projectId}/project-expenses';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetExpensesForProject(_response);
    });
  }

  protected processGetExpensesForProject(response: Response): Promise<ProjectExpenseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectExpenseDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectExpenseDto[]>(null as any);
  }

  updateProjectExpensesForProject(
    projectId: string,
    projectExpenses: ProjectExpenseUpdateDto[],
  ): Promise<OperationResultOfProjectExpenseDto[]> {
    let url_ = this.baseUrl + '/api/v2/projects/{projectId}/project-expenses';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(projectExpenses);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateProjectExpensesForProject(_response);
    });
  }

  protected processUpdateProjectExpensesForProject(
    response: Response,
  ): Promise<OperationResultOfProjectExpenseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null;
        result202 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfProjectExpenseDto[]);
        return result202;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfProjectExpenseDto[]>(null as any);
  }
}

export interface IProjectFinancesService {
  getProjectFinanceListForProject(projectId: string): Promise<ProjectFinanceDto[]>;

  updateFinancesForProject(
    projectId: string,
    projectFinance: ProjectFinanceListUpdateDto,
  ): Promise<OperationResultOfProjectFinanceDto[]>;
}

export class ProjectFinancesService implements IProjectFinancesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjectFinanceListForProject(projectId: string): Promise<ProjectFinanceDto[]> {
    let url_ = this.baseUrl + '/api/v2/projects/{projectId}/project-finances';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectFinanceListForProject(_response);
    });
  }

  protected processGetProjectFinanceListForProject(response: Response): Promise<ProjectFinanceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectFinanceDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectFinanceDto[]>(null as any);
  }

  updateFinancesForProject(
    projectId: string,
    projectFinance: ProjectFinanceListUpdateDto,
  ): Promise<OperationResultOfProjectFinanceDto[]> {
    let url_ = this.baseUrl + '/api/v2/projects/{projectId}/project-finances';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(projectFinance);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFinancesForProject(_response);
    });
  }

  protected processUpdateFinancesForProject(
    response: Response,
  ): Promise<OperationResultOfProjectFinanceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null;
        result202 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as OperationResultOfProjectFinanceDto[]);
        return result202;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultOfProjectFinanceDto[]>(null as any);
  }
}

export interface IProjectMembersService {
  getProjectMemberList(projectId: string): Promise<ProjectMemberDto[]>;
}

export class ProjectMembersService implements IProjectMembersService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjectMemberList(projectId: string): Promise<ProjectMemberDto[]> {
    let url_ = this.baseUrl + '/api/v2/projects/{projectId}/project-members';
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectMemberList(_response);
    });
  }

  protected processGetProjectMemberList(response: Response): Promise<ProjectMemberDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectMemberDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectMemberDto[]>(null as any);
  }
}

export interface IProjectsService {
  getProjectPropertyTypes(clusterId: string): Promise<ProjectPropertyTypes>;
}

export class ProjectsService implements IProjectsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getProjectPropertyTypes(clusterId: string): Promise<ProjectPropertyTypes> {
    let url_ = this.baseUrl + '/api/v2/Projects/info/propertytypes/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProjectPropertyTypes(_response);
    });
  }

  protected processGetProjectPropertyTypes(response: Response): Promise<ProjectPropertyTypes> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyTypes);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectPropertyTypes>(null as any);
  }
}

export interface IReleaseNotesService {
  getList(): Promise<ReleaseNoteDto[]>;

  like(releaseNoteId: string, like: boolean): Promise<void>;
}

export class ReleaseNotesService implements IReleaseNotesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getList(): Promise<ReleaseNoteDto[]> {
    let url_ = this.baseUrl + '/api/v2/ReleaseNotes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetList(_response);
    });
  }

  protected processGetList(response: Response): Promise<ReleaseNoteDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ReleaseNoteDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReleaseNoteDto[]>(null as any);
  }

  like(releaseNoteId: string, like: boolean): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ReleaseNotes/like/{releaseNoteId}';
    if (releaseNoteId === undefined || releaseNoteId === null)
      throw new Error("The parameter 'releaseNoteId' must be defined.");
    url_ = url_.replace('{releaseNoteId}', encodeURIComponent('' + releaseNoteId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(like);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processLike(_response);
    });
  }

  protected processLike(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails2);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IRolesService {
  getRoles(): Promise<RoleDto[]>;
}

export class RolesService implements IRolesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getRoles(): Promise<RoleDto[]> {
    let url_ = this.baseUrl + '/api/v2/Roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetRoles(_response);
    });
  }

  protected processGetRoles(response: Response): Promise<RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[]);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<RoleDto[]>(null as any);
  }
}

export interface ISelfDeclarationService {
  /**
   * Get list of self-declaration objects
   * @param year The year to get data for
   * @return List of self-declaration
   */
  getList(year: number): Promise<ExtendedSelfDeclarationDto[]>;

  /**
   * Upsert a Dto
   */
  upsert(dto: SelfDeclarationUpdateDto): Promise<SelfDeclarationDto[]>;
}

export class SelfDeclarationService implements ISelfDeclarationService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get list of self-declaration objects
   * @param year The year to get data for
   * @return List of self-declaration
   */
  getList(year: number): Promise<ExtendedSelfDeclarationDto[]> {
    let url_ = this.baseUrl + '/api/v2/SelfDeclaration/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetList(_response);
    });
  }

  protected processGetList(response: Response): Promise<ExtendedSelfDeclarationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ExtendedSelfDeclarationDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ExtendedSelfDeclarationDto[]>(null as any);
  }

  /**
   * Upsert a Dto
   */
  upsert(dto: SelfDeclarationUpdateDto): Promise<SelfDeclarationDto[]> {
    let url_ = this.baseUrl + '/api/v2/SelfDeclaration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsert(_response);
    });
  }

  protected processUpsert(response: Response): Promise<SelfDeclarationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SelfDeclarationDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SelfDeclarationDto[]>(null as any);
  }
}

export interface IServiceTemplatesService {
  /**
   * Get all service templates
   * @return List of ServiceTemplateDtos
   */
  getServiceTemplates(): Promise<ServiceTemplateDto[]>;

  /**
   * Get service template by id
   * @param serviceTemplateId The id of the service template
   * @return ServiceTemplateDto
   */
  getServiceTemplateById(serviceTemplateId: string): Promise<ServiceTemplateDto>;
}

export class ServiceTemplatesService implements IServiceTemplatesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get all service templates
   * @return List of ServiceTemplateDtos
   */
  getServiceTemplates(): Promise<ServiceTemplateDto[]> {
    let url_ = this.baseUrl + '/api/v2/ServiceTemplates';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetServiceTemplates(_response);
    });
  }

  protected processGetServiceTemplates(response: Response): Promise<ServiceTemplateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ServiceTemplateDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ServiceTemplateDto[]>(null as any);
  }

  /**
   * Get service template by id
   * @param serviceTemplateId The id of the service template
   * @return ServiceTemplateDto
   */
  getServiceTemplateById(serviceTemplateId: string): Promise<ServiceTemplateDto> {
    let url_ = this.baseUrl + '/api/v2/ServiceTemplates/{serviceTemplateId}';
    if (serviceTemplateId === undefined || serviceTemplateId === null)
      throw new Error("The parameter 'serviceTemplateId' must be defined.");
    url_ = url_.replace('{serviceTemplateId}', encodeURIComponent('' + serviceTemplateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetServiceTemplateById(_response);
    });
  }

  protected processGetServiceTemplateById(response: Response): Promise<ServiceTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ServiceTemplateDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ServiceTemplateDto>(null as any);
  }
}

export interface ISivaGoalAccomplishmentService {
  /**
   * Get siva goal accomplishment
   * @return Siva goal accomplishment
   */
  getGoalAccomplishment(goalAccomplishmentId: string): Promise<GoalAccomplishmentDto>;

  /**
   * Upsert siva goal accomplishment
   * @return Siva goal accomplishment
   */
  upsertGoalAccomplishment(upsertDto: GoalAccomplishmentUpsertDto): Promise<GoalAccomplishmentUpsertDto>;

  /**
   * Get extended siva goal accomplishment
   * @return Extended Siva goal accomplishment
   */
  getGoalAccomplishmentWithTargetNumbers(
    goalAccomplishmentId: string,
  ): Promise<GoalAccomplishmentExtendedDto>;

  /**
   * Set siva goal accomplishment
   */
  setGoalAccomplishment(goalDto: GoalAccomplishmentReportDto[]): Promise<GoalAccomplishmentReportDto>;

  /**
   * Update all siva goal accomplishments
   */
  updateAllAccomplishments(sivaClusterDetailId: string): Promise<FileResponse>;

  getGoalAccomplishmentOverviewReport(
    clusterStatusId: string,
    reportingYear?: number | null | undefined,
  ): Promise<FileResponse>;
}

export class SivaGoalAccomplishmentService implements ISivaGoalAccomplishmentService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get siva goal accomplishment
   * @return Siva goal accomplishment
   */
  getGoalAccomplishment(goalAccomplishmentId: string): Promise<GoalAccomplishmentDto> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment/{goalAccomplishmentId}';
    if (goalAccomplishmentId === undefined || goalAccomplishmentId === null)
      throw new Error("The parameter 'goalAccomplishmentId' must be defined.");
    url_ = url_.replace('{goalAccomplishmentId}', encodeURIComponent('' + goalAccomplishmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetGoalAccomplishment(_response);
    });
  }

  protected processGetGoalAccomplishment(response: Response): Promise<GoalAccomplishmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalAccomplishmentDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalAccomplishmentDto>(null as any);
  }

  /**
   * Upsert siva goal accomplishment
   * @return Siva goal accomplishment
   */
  upsertGoalAccomplishment(upsertDto: GoalAccomplishmentUpsertDto): Promise<GoalAccomplishmentUpsertDto> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(upsertDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertGoalAccomplishment(_response);
    });
  }

  protected processUpsertGoalAccomplishment(response: Response): Promise<GoalAccomplishmentUpsertDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalAccomplishmentUpsertDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalAccomplishmentUpsertDto>(null as any);
  }

  /**
   * Get extended siva goal accomplishment
   * @return Extended Siva goal accomplishment
   */
  getGoalAccomplishmentWithTargetNumbers(
    goalAccomplishmentId: string,
  ): Promise<GoalAccomplishmentExtendedDto> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment/extended/{goalAccomplishmentId}';
    if (goalAccomplishmentId === undefined || goalAccomplishmentId === null)
      throw new Error("The parameter 'goalAccomplishmentId' must be defined.");
    url_ = url_.replace('{goalAccomplishmentId}', encodeURIComponent('' + goalAccomplishmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetGoalAccomplishmentWithTargetNumbers(_response);
    });
  }

  protected processGetGoalAccomplishmentWithTargetNumbers(
    response: Response,
  ): Promise<GoalAccomplishmentExtendedDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalAccomplishmentExtendedDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalAccomplishmentExtendedDto>(null as any);
  }

  /**
   * Set siva goal accomplishment
   */
  setGoalAccomplishment(goalDto: GoalAccomplishmentReportDto[]): Promise<GoalAccomplishmentReportDto> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment/set';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(goalDto);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetGoalAccomplishment(_response);
    });
  }

  protected processSetGoalAccomplishment(response: Response): Promise<GoalAccomplishmentReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalAccomplishmentReportDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalAccomplishmentReportDto>(null as any);
  }

  /**
   * Update all siva goal accomplishments
   */
  updateAllAccomplishments(sivaClusterDetailId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment/update-all/{sivaClusterDetailId}';
    if (sivaClusterDetailId === undefined || sivaClusterDetailId === null)
      throw new Error("The parameter 'sivaClusterDetailId' must be defined.");
    url_ = url_.replace('{sivaClusterDetailId}', encodeURIComponent('' + sivaClusterDetailId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateAllAccomplishments(_response);
    });
  }

  protected processUpdateAllAccomplishments(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getGoalAccomplishmentOverviewReport(
    clusterStatusId: string,
    reportingYear?: number | null | undefined,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/SivaGoalAccomplishment/overviewReport/{clusterStatusId}?';
    if (clusterStatusId === undefined || clusterStatusId === null)
      throw new Error("The parameter 'clusterStatusId' must be defined.");
    url_ = url_.replace('{clusterStatusId}', encodeURIComponent('' + clusterStatusId));
    if (reportingYear !== undefined && reportingYear !== null)
      url_ += 'reportingYear=' + encodeURIComponent('' + reportingYear) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetGoalAccomplishmentOverviewReport(_response);
    });
  }

  protected processGetGoalAccomplishmentOverviewReport(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export interface ISivaManagementService {
  getSivaGoalsDetailsList(year: number): Promise<SivaGoalsDetailsDto[]>;

  getSivaGoalsDetails(year: number, clusterId: string): Promise<SivaGoalsDetailsDto>;

  /**
   * Get siva cluster details, create if not exists
   * @return Siva cluster details
   */
  getDetails(year: number, clusterId: string): Promise<SivaClusterDetailsDto>;

  reviewDetails(goalAccomplishmentId: string, record: GoalReviewDto): Promise<GoalAccomplishmentDto>;

  reviewSivaClusterDetails(
    sivaClusterDetailsId: string,
    goalsStatus: SivaGoalsStatus,
  ): Promise<SivaGoalsDetailsDto>;

  getSivaBudgetDetailsList(year: number): Promise<SivaBudgetDetailsDto[]>;

  budgetDownload(attachmentId: string): Promise<FileResponse>;

  approveBudget(sivaClusterDetailsId: string): Promise<SivaBudgetDetailsDto>;

  rejectBudget(sivaClusterDetailsId: string): Promise<SivaBudgetDetailsDto>;

  getAggregatedReporting(year: number): Promise<EsaReportingAggregatedDto[]>;
}

export class SivaManagementService implements ISivaManagementService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getSivaGoalsDetailsList(year: number): Promise<SivaGoalsDetailsDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/goals/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaGoalsDetailsList(_response);
    });
  }

  protected processGetSivaGoalsDetailsList(response: Response): Promise<SivaGoalsDetailsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaGoalsDetailsDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaGoalsDetailsDto[]>(null as any);
  }

  getSivaGoalsDetails(year: number, clusterId: string): Promise<SivaGoalsDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/goals/{year}/cluster/{clusterId}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaGoalsDetails(_response);
    });
  }

  protected processGetSivaGoalsDetails(response: Response): Promise<SivaGoalsDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaGoalsDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaGoalsDetailsDto>(null as any);
  }

  /**
   * Get siva cluster details, create if not exists
   * @return Siva cluster details
   */
  getDetails(year: number, clusterId: string): Promise<SivaClusterDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/goals/{year}/siva-cluster-details/{clusterId}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDetails(_response);
    });
  }

  protected processGetDetails(response: Response): Promise<SivaClusterDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaClusterDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaClusterDetailsDto>(null as any);
  }

  reviewDetails(goalAccomplishmentId: string, record: GoalReviewDto): Promise<GoalAccomplishmentDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/goals/review/{goalAccomplishmentId}';
    if (goalAccomplishmentId === undefined || goalAccomplishmentId === null)
      throw new Error("The parameter 'goalAccomplishmentId' must be defined.");
    url_ = url_.replace('{goalAccomplishmentId}', encodeURIComponent('' + goalAccomplishmentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processReviewDetails(_response);
    });
  }

  protected processReviewDetails(response: Response): Promise<GoalAccomplishmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalAccomplishmentDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalAccomplishmentDto>(null as any);
  }

  reviewSivaClusterDetails(
    sivaClusterDetailsId: string,
    goalsStatus: SivaGoalsStatus,
  ): Promise<SivaGoalsDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/siva-details/review/{sivaClusterDetailsId}';
    if (sivaClusterDetailsId === undefined || sivaClusterDetailsId === null)
      throw new Error("The parameter 'sivaClusterDetailsId' must be defined.");
    url_ = url_.replace('{sivaClusterDetailsId}', encodeURIComponent('' + sivaClusterDetailsId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(goalsStatus);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processReviewSivaClusterDetails(_response);
    });
  }

  protected processReviewSivaClusterDetails(response: Response): Promise<SivaGoalsDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaGoalsDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaGoalsDetailsDto>(null as any);
  }

  getSivaBudgetDetailsList(year: number): Promise<SivaBudgetDetailsDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/budget/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSivaBudgetDetailsList(_response);
    });
  }

  protected processGetSivaBudgetDetailsList(response: Response): Promise<SivaBudgetDetailsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaBudgetDetailsDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaBudgetDetailsDto[]>(null as any);
  }

  budgetDownload(attachmentId: string): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/budget/download/{attachmentId}';
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace('{attachmentId}', encodeURIComponent('' + attachmentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBudgetDownload(_response);
    });
  }

  protected processBudgetDownload(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  approveBudget(sivaClusterDetailsId: string): Promise<SivaBudgetDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/budget/{sivaClusterDetailsId}/approve';
    if (sivaClusterDetailsId === undefined || sivaClusterDetailsId === null)
      throw new Error("The parameter 'sivaClusterDetailsId' must be defined.");
    url_ = url_.replace('{sivaClusterDetailsId}', encodeURIComponent('' + sivaClusterDetailsId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApproveBudget(_response);
    });
  }

  protected processApproveBudget(response: Response): Promise<SivaBudgetDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaBudgetDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaBudgetDetailsDto>(null as any);
  }

  rejectBudget(sivaClusterDetailsId: string): Promise<SivaBudgetDetailsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/budget/{sivaClusterDetailsId}/reject';
    if (sivaClusterDetailsId === undefined || sivaClusterDetailsId === null)
      throw new Error("The parameter 'sivaClusterDetailsId' must be defined.");
    url_ = url_.replace('{sivaClusterDetailsId}', encodeURIComponent('' + sivaClusterDetailsId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRejectBudget(_response);
    });
  }

  protected processRejectBudget(response: Response): Promise<SivaBudgetDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaBudgetDetailsDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaBudgetDetailsDto>(null as any);
  }

  getAggregatedReporting(year: number): Promise<EsaReportingAggregatedDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaManagement/admin/aggregatedReporting/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAggregatedReporting(_response);
    });
  }

  protected processGetAggregatedReporting(response: Response): Promise<EsaReportingAggregatedDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EsaReportingAggregatedDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EsaReportingAggregatedDto[]>(null as any);
  }
}

export interface ISivaReportingService {
  /**
     * List any Esa reporting for a SivaContract specified by numericalId.
                If no SivaContract is specified, all Esa reporting for the current Cluster is listed.
     * @param year The year for which to list Esa reporting.
     * @param numericalId (optional) Optional id for a SivaContract.
     * @return Esa reporting
     */
  getEsa(year: number, numericalId?: number | null | undefined): Promise<SivaEsaReportingDto[]>;

  upsertEsa(data: SivaEsaReportingDto[]): Promise<SivaEsaReportingDto[]>;

  deleteEsa(ids: string[]): Promise<FileResponse>;

  /**
   * Get innovation funds for a specific cluster and year.
   */
  getInnovationFunds(year: number, clusterId: string): Promise<SivaInnovationFundsDto>;

  upsertInnovationFunds(
    year: number,
    data: SivaInnovationFundsDto,
    clusterId: string,
  ): Promise<SivaInnovationFundsDto>;

  listInnovationFunds(year: number): Promise<SivaInnovationFundsOverviewDto[]>;

  getAccumulatedEsaUsage(year: number): Promise<EsaReportingAggregatedDto[]>;
}

export class SivaReportingService implements ISivaReportingService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
     * List any Esa reporting for a SivaContract specified by numericalId.
                If no SivaContract is specified, all Esa reporting for the current Cluster is listed.
     * @param year The year for which to list Esa reporting.
     * @param numericalId (optional) Optional id for a SivaContract.
     * @return Esa reporting
     */
  getEsa(year: number, numericalId?: number | null | undefined): Promise<SivaEsaReportingDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/esa/{year}?';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (numericalId !== undefined && numericalId !== null)
      url_ += 'numericalId=' + encodeURIComponent('' + numericalId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetEsa(_response);
    });
  }

  protected processGetEsa(response: Response): Promise<SivaEsaReportingDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaEsaReportingDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaEsaReportingDto[]>(null as any);
  }

  upsertEsa(data: SivaEsaReportingDto[]): Promise<SivaEsaReportingDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/Esa';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertEsa(_response);
    });
  }

  protected processUpsertEsa(response: Response): Promise<SivaEsaReportingDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaEsaReportingDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaEsaReportingDto[]>(null as any);
  }

  deleteEsa(ids: string[]): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/Esa';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(ids);

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteEsa(_response);
    });
  }

  protected processDeleteEsa(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Get innovation funds for a specific cluster and year.
   */
  getInnovationFunds(year: number, clusterId: string): Promise<SivaInnovationFundsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/InnovationFunds/{year}/{clusterId}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInnovationFunds(_response);
    });
  }

  protected processGetInnovationFunds(response: Response): Promise<SivaInnovationFundsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaInnovationFundsDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaInnovationFundsDto>(null as any);
  }

  upsertInnovationFunds(
    year: number,
    data: SivaInnovationFundsDto,
    clusterId: string,
  ): Promise<SivaInnovationFundsDto> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/InnovationFunds/{year}/{clusterId}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpsertInnovationFunds(_response);
    });
  }

  protected processUpsertInnovationFunds(response: Response): Promise<SivaInnovationFundsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaInnovationFundsDto);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaInnovationFundsDto>(null as any);
  }

  listInnovationFunds(year: number): Promise<SivaInnovationFundsOverviewDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/InnovationFunds/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processListInnovationFunds(_response);
    });
  }

  protected processListInnovationFunds(response: Response): Promise<SivaInnovationFundsOverviewDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SivaInnovationFundsOverviewDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SivaInnovationFundsOverviewDto[]>(null as any);
  }

  getAccumulatedEsaUsage(year: number): Promise<EsaReportingAggregatedDto[]> {
    let url_ = this.baseUrl + '/api/v2/SivaReporting/Esa/accumulated/{year}';
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAccumulatedEsaUsage(_response);
    });
  }

  protected processGetAccumulatedEsaUsage(response: Response): Promise<EsaReportingAggregatedDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EsaReportingAggregatedDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EsaReportingAggregatedDto[]>(null as any);
  }
}

export interface IStatusProgramService {
  getStatusProgramList(): Promise<StatusProgramDto[]>;

  getClustersForStatusProgram(statusProgramId: string): Promise<ClusterDto[]>;
}

export class StatusProgramService implements IStatusProgramService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getStatusProgramList(): Promise<StatusProgramDto[]> {
    let url_ = this.baseUrl + '/api/v2/StatusProgram';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStatusProgramList(_response);
    });
  }

  protected processGetStatusProgramList(response: Response): Promise<StatusProgramDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as StatusProgramDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StatusProgramDto[]>(null as any);
  }

  getClustersForStatusProgram(statusProgramId: string): Promise<ClusterDto[]> {
    let url_ = this.baseUrl + '/api/v2/StatusProgram/{statusProgramId}/clusters';
    if (statusProgramId === undefined || statusProgramId === null)
      throw new Error("The parameter 'statusProgramId' must be defined.");
    url_ = url_.replace('{statusProgramId}', encodeURIComponent('' + statusProgramId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClustersForStatusProgram(_response);
    });
  }

  protected processGetClustersForStatusProgram(response: Response): Promise<ClusterDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto[]);
        return result200;
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClusterDto[]>(null as any);
  }
}

export interface ITargetNumberService {
  /**
   * Get target numbers
   * @param numericId (optional)
   * @param year (optional)
   * @return Siva target numbers
   */
  getList(numericId?: number | undefined, year?: number | undefined): Promise<TargetNumberDto[]>;

  /**
   * Update target numbers
   */
  update(values: TargetNumberDto[]): Promise<void>;

  /**
   * Get target numbers for a specific company
   * @param sivaContractNumericId (optional)
   * @param year (optional)
   * @return Siva target numbers for a specific company
   */
  getGoalCategoriesWithTargetNumbersBySivaContract(
    sivaContractNumericId?: number | undefined,
    year?: number | undefined,
  ): Promise<GoalCategoryWithTargetNumbersDto[]>;
}

export class TargetNumberService implements ITargetNumberService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Get target numbers
   * @param numericId (optional)
   * @param year (optional)
   * @return Siva target numbers
   */
  getList(numericId?: number | undefined, year?: number | undefined): Promise<TargetNumberDto[]> {
    let url_ = this.baseUrl + '/api/v2/TargetNumber/getList?';
    if (numericId === null) throw new Error("The parameter 'numericId' cannot be null.");
    else if (numericId !== undefined) url_ += 'numericId=' + encodeURIComponent('' + numericId) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetList(_response);
    });
  }

  protected processGetList(response: Response): Promise<TargetNumberDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TargetNumberDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TargetNumberDto[]>(null as any);
  }

  /**
   * Update target numbers
   */
  update(values: TargetNumberDto[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/TargetNumber/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(values);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get target numbers for a specific company
   * @param sivaContractNumericId (optional)
   * @param year (optional)
   * @return Siva target numbers for a specific company
   */
  getGoalCategoriesWithTargetNumbersBySivaContract(
    sivaContractNumericId?: number | undefined,
    year?: number | undefined,
  ): Promise<GoalCategoryWithTargetNumbersDto[]> {
    let url_ = this.baseUrl + '/api/v2/TargetNumber/getGoalCategories?';
    if (sivaContractNumericId === null)
      throw new Error("The parameter 'sivaContractNumericId' cannot be null.");
    else if (sivaContractNumericId !== undefined)
      url_ += 'sivaContractNumericId=' + encodeURIComponent('' + sivaContractNumericId) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetGoalCategoriesWithTargetNumbersBySivaContract(_response);
    });
  }

  protected processGetGoalCategoriesWithTargetNumbersBySivaContract(
    response: Response,
  ): Promise<GoalCategoryWithTargetNumbersDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GoalCategoryWithTargetNumbersDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GoalCategoryWithTargetNumbersDto[]>(null as any);
  }
}

export interface ITimeEntryService {
  getTimeEntries(
    clusterId: string,
    clusterContactId?: string | null | undefined,
    eventId?: string | null | undefined,
    projectId?: string | null | undefined,
    status?: TimeEntryStatus | null | undefined,
    clusterMemberId?: string | null | undefined,
    operationApplicationId?: string | null | undefined,
    clusterMemberCategoryId?: string | null | undefined,
  ): Promise<TimeEntryDto[]>;

  getTimeEntry(timeEntryId: string): Promise<TimeEntryDto>;

  createTimeEntry(
    timeEntry: TimeEntryUpsertDto,
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto>;

  createTimeEntries(
    timeEntries: TimeEntryUpsertDto[],
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto[]>;

  deleteTimeEntry(timeEntries: string[]): Promise<void>;
}

export class TimeEntryService implements ITimeEntryService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getTimeEntries(
    clusterId: string,
    clusterContactId?: string | null | undefined,
    eventId?: string | null | undefined,
    projectId?: string | null | undefined,
    status?: TimeEntryStatus | null | undefined,
    clusterMemberId?: string | null | undefined,
    operationApplicationId?: string | null | undefined,
    clusterMemberCategoryId?: string | null | undefined,
  ): Promise<TimeEntryDto[]> {
    let url_ = this.baseUrl + '/api/v2/TimeEntry/{clusterId}/list?';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    if (clusterContactId !== undefined && clusterContactId !== null)
      url_ += 'clusterContactId=' + encodeURIComponent('' + clusterContactId) + '&';
    if (eventId !== undefined && eventId !== null)
      url_ += 'eventId=' + encodeURIComponent('' + eventId) + '&';
    if (projectId !== undefined && projectId !== null)
      url_ += 'projectId=' + encodeURIComponent('' + projectId) + '&';
    if (status !== undefined && status !== null) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    if (clusterMemberId !== undefined && clusterMemberId !== null)
      url_ += 'clusterMemberId=' + encodeURIComponent('' + clusterMemberId) + '&';
    if (operationApplicationId !== undefined && operationApplicationId !== null)
      url_ += 'operationApplicationId=' + encodeURIComponent('' + operationApplicationId) + '&';
    if (clusterMemberCategoryId !== undefined && clusterMemberCategoryId !== null)
      url_ += 'clusterMemberCategoryId=' + encodeURIComponent('' + clusterMemberCategoryId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTimeEntries(_response);
    });
  }

  protected processGetTimeEntries(response: Response): Promise<TimeEntryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeEntryDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeEntryDto[]>(null as any);
  }

  getTimeEntry(timeEntryId: string): Promise<TimeEntryDto> {
    let url_ = this.baseUrl + '/api/v2/TimeEntry/{timeEntryId}';
    if (timeEntryId === undefined || timeEntryId === null)
      throw new Error("The parameter 'timeEntryId' must be defined.");
    url_ = url_.replace('{timeEntryId}', encodeURIComponent('' + timeEntryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTimeEntry(_response);
    });
  }

  protected processGetTimeEntry(response: Response): Promise<TimeEntryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeEntryDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeEntryDto>(null as any);
  }

  createTimeEntry(
    timeEntry: TimeEntryUpsertDto,
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto> {
    let url_ = this.baseUrl + '/api/v2/TimeEntry';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(timeEntry);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateTimeEntry(_response);
    });
  }

  protected processCreateTimeEntry(
    response: Response,
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto>(null as any);
  }

  createTimeEntries(
    timeEntries: TimeEntryUpsertDto[],
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto[]> {
    let url_ = this.baseUrl + '/api/v2/TimeEntry/list';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(timeEntries);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateTimeEntries(_response);
    });
  }

  protected processCreateTimeEntries(
    response: Response,
  ): Promise<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto[]>(null as any);
  }

  deleteTimeEntry(timeEntries: string[]): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/TimeEntry/delete';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(timeEntries);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTimeEntry(_response);
    });
  }

  protected processDeleteTimeEntry(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface ITimeRatesService {
  getSingle(timeRateId: string): Promise<TimeRateDto>;

  update(timeRateId: string, record: TimeRateUpdateDto): Promise<TimeRateDto>;

  delete(timeRateId: string): Promise<TimeRateDto>;

  getDefault(clusterId: string): Promise<TimeRateDto>;

  getAll(clusterId: string): Promise<TimeRateDto[]>;

  create(record: TimeRateCreateDto): Promise<TimeRateDto>;
}

export class TimeRatesService implements ITimeRatesService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getSingle(timeRateId: string): Promise<TimeRateDto> {
    let url_ = this.baseUrl + '/api/v2/TimeRates/{timeRateId}';
    if (timeRateId === undefined || timeRateId === null)
      throw new Error("The parameter 'timeRateId' must be defined.");
    url_ = url_.replace('{timeRateId}', encodeURIComponent('' + timeRateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSingle(_response);
    });
  }

  protected processGetSingle(response: Response): Promise<TimeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto>(null as any);
  }

  update(timeRateId: string, record: TimeRateUpdateDto): Promise<TimeRateDto> {
    let url_ = this.baseUrl + '/api/v2/TimeRates/{timeRateId}';
    if (timeRateId === undefined || timeRateId === null)
      throw new Error("The parameter 'timeRateId' must be defined.");
    url_ = url_.replace('{timeRateId}', encodeURIComponent('' + timeRateId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<TimeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto>(null as any);
  }

  delete(timeRateId: string): Promise<TimeRateDto> {
    let url_ = this.baseUrl + '/api/v2/TimeRates/{timeRateId}';
    if (timeRateId === undefined || timeRateId === null)
      throw new Error("The parameter 'timeRateId' must be defined.");
    url_ = url_.replace('{timeRateId}', encodeURIComponent('' + timeRateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<TimeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto);
        return result204;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto>(null as any);
  }

  getDefault(clusterId: string): Promise<TimeRateDto> {
    let url_ = this.baseUrl + '/api/v2/TimeRates/default/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDefault(_response);
    });
  }

  protected processGetDefault(response: Response): Promise<TimeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto>(null as any);
  }

  getAll(clusterId: string): Promise<TimeRateDto[]> {
    let url_ = this.baseUrl + '/api/v2/TimeRates/cluster/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAll(_response);
    });
  }

  protected processGetAll(response: Response): Promise<TimeRateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto[]>(null as any);
  }

  create(record: TimeRateCreateDto): Promise<TimeRateDto> {
    let url_ = this.baseUrl + '/api/v2/TimeRates';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<TimeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeRateDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimeRateDto>(null as any);
  }
}

export interface IUsersService {
  createUser(record: UserCreateDto): Promise<UserDto>;

  getUserByB2CId(): Promise<UserDto>;

  getUser(userId: string): Promise<UserDto>;

  updateUser(userId: string, record: UserUpdateDto): Promise<UserDto>;

  deleteUser(userId: string): Promise<UserDto>;

  getUserRolePermissionsV2(clusterId: string): Promise<PermissionDtoV2>;

  consentPortalTerms(): Promise<void>;

  downloadSwaggerFile(): Promise<void>;
}

export class UsersService implements IUsersService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  createUser(record: UserCreateDto): Promise<UserDto> {
    let url_ = this.baseUrl + '/api/v2/Users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateUser(_response);
    });
  }

  protected processCreateUser(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  getUserByB2CId(): Promise<UserDto> {
    let url_ = this.baseUrl + '/api/v2/Users/b2c';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserByB2CId(_response);
    });
  }

  protected processGetUserByB2CId(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  getUser(userId: string): Promise<UserDto> {
    let url_ = this.baseUrl + '/api/v2/Users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUser(_response);
    });
  }

  protected processGetUser(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  updateUser(userId: string, record: UserUpdateDto): Promise<UserDto> {
    let url_ = this.baseUrl + '/api/v2/Users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateUser(_response);
    });
  }

  protected processUpdateUser(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  deleteUser(userId: string): Promise<UserDto> {
    let url_ = this.baseUrl + '/api/v2/Users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteUser(_response);
    });
  }

  protected processDeleteUser(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  getUserRolePermissionsV2(clusterId: string): Promise<PermissionDtoV2> {
    let url_ = this.baseUrl + '/api/v2/Users/role-permissions/v2/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRolePermissionsV2(_response);
    });
  }

  protected processGetUserRolePermissionsV2(response: Response): Promise<PermissionDtoV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PermissionDtoV2);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PermissionDtoV2>(null as any);
  }

  consentPortalTerms(): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Users/consent-terms';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'PUT',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processConsentPortalTerms(_response);
    });
  }

  protected processConsentPortalTerms(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result401);
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        result403 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result403);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  downloadSwaggerFile(): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Users/swagger';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDownloadSwaggerFile(_response);
    });
  }

  protected processDownloadSwaggerFile(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IWorkGroupsService {
  getSingle(workGroupId: string): Promise<WorkGroupDto>;

  update(workGroupId: string, record: WorkGroupUpdateDto): Promise<WorkGroupDto>;

  delete(workGroupId: string): Promise<WorkGroupDto>;

  getAllFromCluster(clusterId: string): Promise<WorkGroupDto[]>;

  create(record: WorkGroupCreateDto): Promise<WorkGroupDto>;
}

export class WorkGroupsService implements IWorkGroupsService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? '';
  }

  getSingle(workGroupId: string): Promise<WorkGroupDto> {
    let url_ = this.baseUrl + '/api/v2/WorkGroups/{workGroupId}';
    if (workGroupId === undefined || workGroupId === null)
      throw new Error("The parameter 'workGroupId' must be defined.");
    url_ = url_.replace('{workGroupId}', encodeURIComponent('' + workGroupId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSingle(_response);
    });
  }

  protected processGetSingle(response: Response): Promise<WorkGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as WorkGroupDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<WorkGroupDto>(null as any);
  }

  update(workGroupId: string, record: WorkGroupUpdateDto): Promise<WorkGroupDto> {
    let url_ = this.baseUrl + '/api/v2/WorkGroups/{workGroupId}';
    if (workGroupId === undefined || workGroupId === null)
      throw new Error("The parameter 'workGroupId' must be defined.");
    url_ = url_.replace('{workGroupId}', encodeURIComponent('' + workGroupId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<WorkGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as WorkGroupDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<WorkGroupDto>(null as any);
  }

  delete(workGroupId: string): Promise<WorkGroupDto> {
    let url_ = this.baseUrl + '/api/v2/WorkGroups/{workGroupId}';
    if (workGroupId === undefined || workGroupId === null)
      throw new Error("The parameter 'workGroupId' must be defined.");
    url_ = url_.replace('{workGroupId}', encodeURIComponent('' + workGroupId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<WorkGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as WorkGroupDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<WorkGroupDto>(null as any);
  }

  getAllFromCluster(clusterId: string): Promise<WorkGroupDto[]> {
    let url_ = this.baseUrl + '/api/v2/WorkGroups/cluster/{clusterId}';
    if (clusterId === undefined || clusterId === null)
      throw new Error("The parameter 'clusterId' must be defined.");
    url_ = url_.replace('{clusterId}', encodeURIComponent('' + clusterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllFromCluster(_response);
    });
  }

  protected processGetAllFromCluster(response: Response): Promise<WorkGroupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as WorkGroupDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<WorkGroupDto[]>(null as any);
  }

  create(record: WorkGroupCreateDto): Promise<WorkGroupDto> {
    let url_ = this.baseUrl + '/api/v2/WorkGroups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(record);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<WorkGroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as WorkGroupDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('A server side error occurred.', status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<WorkGroupDto>(null as any);
  }
}

export interface SivaClusterDetailsDto {
  id: string;
  clusterId: string;
  goalsStatus: SivaGoalsStatus;
  goalAccomplishments: GoalAccomplishmentExtendedDto[];
  year: number;
  totalGoalAccomplishment: number;
  reportingDone: boolean;
  reportingYearOpen: boolean;
}

export enum SivaGoalsStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Approved = 'Approved',
  ChangeRequested = 'ChangeRequested',
  Created = 'Created',
}

export interface GoalAccomplishmentDto {
  id: string;
  sivaClusterDetailsId: string;
  goalTemplateId: string;
  value: number;
  expectedValue: number;
  sivaComment: string | undefined;
  clusterComment: string | undefined;
  isApproved: boolean;
  goalDetail: GoalDetailDto;
  goalCategory: GoalCategoryDto;
}

export interface GoalAccomplishmentExtendedDto extends GoalAccomplishmentDto {
  targetNumbers: TargetNumberDto[] | undefined;
  targetNumberValueDtoPropertyKey: PropertyKey;
}

export interface TargetNumberDto {
  /** NumericalId for the SivaContract */
  sivaContractId: number;
  /** The contract name is ignored in upsert. */
  contractName: string | undefined;
  year: number | undefined;
  valueDto: TargetNumberValueDto | undefined;
  goalTemplateId: string;
  currentContractPhase: SivaPhase;
}

export interface TargetNumberValueDto {
  /** Egenkapital */
  equity: number | undefined;
  womenInLeadingRole: boolean | undefined;
  businessModelDigitalization: boolean | undefined;
  businessModelSustainability: boolean | undefined;
  businessModelExport: Export | undefined;
  internationalMarket: InternationalMarket | undefined;
  advisedAccessToOtherTools: boolean | undefined;
  euEnvironmentalGoals: EuEnvironmentalGoalsValueDto | undefined;
  srl: SustainabilityReadinessLevel | undefined;
  esaSummary: EsaSummary | undefined;
  admissionDate: Date | undefined;
  /** Har NH/INK koblet bedriften opp mot internasjonale aktører i løpet av året? */
  internationalCooperation: boolean | undefined;
}

export enum Export {
  Ja = 'Ja',
  Nei = 'Nei',
  Potensiale = 'Potensiale',
  Underleverandor = 'Underleverandor',
}

export enum InternationalMarket {
  Ja = 'Ja',
  Nei = 'Nei',
  Potensiale = 'Potensiale',
}

export interface EuEnvironmentalGoalsValueDto {
  goalSatisfactions: { [key in keyof typeof EuEnvironmentalGoals]?: EuEnvironmentalGoalsEffect } | undefined;
  ingen: boolean;
}

export enum EuEnvironmentalGoals {
  EU1 = 'EU1',
  EU2 = 'EU2',
  EU3 = 'EU3',
  EU4 = 'EU4',
  EU5 = 'EU5',
  EU6 = 'EU6',
}

export enum EuEnvironmentalGoalsEffect {
  Positive = 'Positive',
  Negative = 'Negative',
}

export enum SustainabilityReadinessLevel {
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
  S5 = 'S5',
  S6 = 'S6',
  S7 = 'S7',
  S8 = 'S8',
  S9 = 'S9',
}

export interface EsaSummary {
  marketValue: number;
  invoicedDeductible: number;
  innovationSupport: number;
}

export enum SivaPhase {
  Idea = 'Idea',
  PreIncubation = 'PreIncubation',
  Incubated = 'Incubated',
  Fi = 'Fi',
  ScaleUp = 'ScaleUp',
  Alumni = 'Alumni',
  Targeted = 'Targeted',
}

export enum PropertyKey {
  Equity = 'Equity',
  WomenInLeadingRole = 'WomenInLeadingRole',
  BusinessModelDigitalization = 'BusinessModelDigitalization',
  BusinessModelExport = 'BusinessModelExport',
  InternationalMarket = 'InternationalMarket',
  EuEnvironmentalGoals = 'EuEnvironmentalGoals',
  Srl = 'Srl',
  EsaSummary = 'EsaSummary',
  AdmissionDate = 'AdmissionDate',
  BusinessModelSustainability = 'BusinessModelSustainability',
  AdvisedAccessToOtherTools = 'AdvisedAccessToOtherTools',
  InternationalCooperation = 'InternationalCooperation',
}

export interface GoalDetailDto {
  id: string;
  description: string | undefined;
  code: string | undefined;
  name: string | undefined;
  /** Denotes if a goal is set on the operator level or if it is based on contracts. */
  isOperatorLevel: boolean | undefined;
  requiresTargetNumber: boolean | undefined;
  /** A place to store the column header texts used on the Goal Reporting pages. */
  columnHeaderText: string | undefined;
  clusterStatusId: string;
  isPercentage: boolean;
  basedOnTargetNumberInput: boolean;
}

export interface GoalCategoryDto {
  id: string;
  description: string | undefined;
  code: string | undefined;
  name: string | undefined;
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
  additionalProperties: { [key: string]: any } | undefined;

  [key: string]: any;
}

export interface SivaBudgetAttachmentDto {
  id: string;
  size: number;
  contentType: string;
  name: string;
  year: number;
  type: SivaBudgetAttachmentType;
  isLatestVersion: boolean;
  isApproved: boolean;
  version: number;
}

export enum SivaBudgetAttachmentType {
  Budget = 'Budget',
  AuditorConfirmation = 'AuditorConfirmation',
}

export interface SivaContractOverviewDto {
  id: string;
  numericId: number;
  name: string;
  companyName: string | undefined;
  advisorFirstName: string | undefined;
  advisorLastName: string | undefined;
  phase: SivaPhase | undefined;
  fromDate: Date;
  admissionDate: Date | undefined;
  toDate: Date | undefined;
  lastReportDate: Date | undefined;
  organizationNumber: string | undefined;
  municipality: string | undefined;
  hasOnlyBeenIdeaOrAlumni: boolean | undefined;
  selfDeclarationDelivered: boolean;
  latestSelfDeclaration: SelfDeclarationDto | undefined;
  esaReportingDone: boolean;
  goalAccomplishmentDelivered: boolean;
  contactEmail: string | undefined;
  externalIndustry: string | undefined;
}

export interface SelfDeclarationDto {
  selfDeclarationDelivered: boolean;
  selfClassification: SelfClassification[] | undefined;
  financialYear: number;
  organizationNumber: string | undefined;
  companyName: string | undefined;
  sivaContractId: string | undefined;
  deliveredDate: Date;
}

export enum SelfClassification {
  Independent = 'Independent',
  Associated = 'Associated',
  Partner = 'Partner',
}

export interface SivaContractsDetailDto {
  requestedContract: SivaContractDetailDto;
  company: SivaCompanyDetailDto | undefined;
}

export interface SivaContractDetailDto {
  id: string;
  numericId: number;
  name: string;
  ideaSource: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  advisorName: string | undefined;
  advisorId: string | undefined;
  externalIndustry: string | undefined;
  notes: string;
  phases: SivaContractPhaseDto[];
  clusterMemberId: string | undefined;
  fromDate: Date | undefined;
  toDate: Date | undefined;
  admissionDate: Date | undefined;
  startupFormDate: Date | undefined;
  inProgressFormDate: Date | undefined;
  exitFormDate: Date | undefined;
  /** Municipality code.  */
  municipality: string | undefined;
  selfDeclarations: SelfDeclarationDto[] | undefined;
}

export interface SivaContractPhaseDto {
  id: string;
  sivaPhase: SivaPhase;
  fromDate: Date;
  toDate: Date | undefined;
}

export interface SivaCompanyDetailDto {
  contracts: SivaContractDetailDto[];
  name: string | undefined;
  organizationNumber: string;
  establishedDate: Date | undefined;
  nace: string | undefined;
  assetsTotal: number | undefined;
  numberOfEmployees: number | undefined;
  isActive: boolean;
  createdOn: Date;
  billingAddress: AddressDto | undefined;
  companyTypeDescription: string | undefined;
  clusterContact: SivaClusterContactDto | undefined;
}

export interface AddressDto {
  country: string | undefined;
  street: string | undefined;
  city: string | undefined;
  county: string | undefined;
  zipCode: string | undefined;
  municipality: string | undefined;
  municipalityNo: string | undefined;
}

export interface SivaClusterContactDto {
  isClusterMemberMainContact: boolean;
  firstName: string;
  lastName: string;
  emailAddress: string;
}

export interface ProblemDetails2 {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;

  [key: string]: any;
}

export interface SivaContractCreateDto {
  fromDate: Date;
  sivaPhase: SivaPhase;
  name: string;
  ideaSource: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  advisorId: string;
  notes: string;
  externalIndustry: string | undefined;
  organizationNumber: string | undefined;
  municipality: string | undefined;
  oneWayInOpportunityId: string | undefined;
  hasFemaleFounderChairMemberOrCeo: boolean;
}

export interface SivaContractUpdateDto {
  numericId: number;
  name: string;
  ideaSource: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  advisorId: string;
  notes: string;
  externalIndustry: string | undefined;
  organizationNumber: string | undefined;
  hasFemaleFounderChairMemberOrCeo: boolean | undefined;
  newPhase: SivaContractNewPhaseDto | undefined;
  municipality: string | undefined;
}

export interface SivaContractNewPhaseDto {
  newPhase: SivaPhase;
  fromDate: Date | undefined;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export interface OperationResultOfSivaContractBatchUpdatePhaseDto {
  data: SivaContractBatchUpdatePhaseDto | undefined;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

export interface SivaContractBatchUpdatePhaseDto {
  newPhase: SivaPhase;
  fromDate: Date;
  sivaContract: SivaContractOverviewDto;
}

export enum HttpStatusCode {
  Continue = 'Continue',
  SwitchingProtocols = 'SwitchingProtocols',
  Processing = 'Processing',
  EarlyHints = 'EarlyHints',
  OK = 'OK',
  Created = 'Created',
  Accepted = 'Accepted',
  NonAuthoritativeInformation = 'NonAuthoritativeInformation',
  NoContent = 'NoContent',
  ResetContent = 'ResetContent',
  PartialContent = 'PartialContent',
  MultiStatus = 'MultiStatus',
  AlreadyReported = 'AlreadyReported',
  IMUsed = 'IMUsed',
  MultipleChoices = 'MultipleChoices',
  Ambiguous = 'MultipleChoices',
  MovedPermanently = 'MovedPermanently',
  Moved = 'MovedPermanently',
  Found = 'Found',
  Redirect = 'Found',
  SeeOther = 'SeeOther',
  RedirectMethod = 'SeeOther',
  NotModified = 'NotModified',
  UseProxy = 'UseProxy',
  Unused = 'Unused',
  TemporaryRedirect = 'TemporaryRedirect',
  RedirectKeepVerb = 'TemporaryRedirect',
  PermanentRedirect = 'PermanentRedirect',
  BadRequest = 'BadRequest',
  Unauthorized = 'Unauthorized',
  PaymentRequired = 'PaymentRequired',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  MethodNotAllowed = 'MethodNotAllowed',
  NotAcceptable = 'NotAcceptable',
  ProxyAuthenticationRequired = 'ProxyAuthenticationRequired',
  RequestTimeout = 'RequestTimeout',
  Conflict = 'Conflict',
  Gone = 'Gone',
  LengthRequired = 'LengthRequired',
  PreconditionFailed = 'PreconditionFailed',
  RequestEntityTooLarge = 'RequestEntityTooLarge',
  RequestUriTooLong = 'RequestUriTooLong',
  UnsupportedMediaType = 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
  ExpectationFailed = 'ExpectationFailed',
  MisdirectedRequest = 'MisdirectedRequest',
  UnprocessableEntity = 'UnprocessableEntity',
  UnprocessableContent = 'UnprocessableEntity',
  Locked = 'Locked',
  FailedDependency = 'FailedDependency',
  UpgradeRequired = 'UpgradeRequired',
  PreconditionRequired = 'PreconditionRequired',
  TooManyRequests = 'TooManyRequests',
  RequestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons = 'UnavailableForLegalReasons',
  InternalServerError = 'InternalServerError',
  NotImplemented = 'NotImplemented',
  BadGateway = 'BadGateway',
  ServiceUnavailable = 'ServiceUnavailable',
  GatewayTimeout = 'GatewayTimeout',
  HttpVersionNotSupported = 'HttpVersionNotSupported',
  VariantAlsoNegotiates = 'VariantAlsoNegotiates',
  InsufficientStorage = 'InsufficientStorage',
  LoopDetected = 'LoopDetected',
  NotExtended = 'NotExtended',
  NetworkAuthenticationRequired = 'NetworkAuthenticationRequired',
}

export interface SetOpenReportingYearsDto {
  clusterId: string[];
  year: number;
  open: boolean;
}

export interface SivaPhaseDto {
  name: string;
  sivaPhase: SivaPhase;
}

export interface ClusterContactDto {
  id: string;
  clusterId: string;
  clusterMemberId: string | undefined;
  clusterMember: ClusterMemberDto | undefined;
  status: ClusterContactStatus;
  deactivatedDate: Date | undefined;
  isClusterMemberMainContact: boolean;
  firstName: string | undefined;
  lastName: string | undefined;
  mobilePhone: string | undefined;
  gender: Gender;
  description: string | undefined;
  emailAddress: string;
  timeRate: TimeRateDto;
  timeRateId: string;
  jobTitle: string | undefined;
  interestAreas: InterestAreaDto[];
}

export interface ClusterMemberDto {
  id: string;
  memberSince: Date | undefined;
  name: string | undefined;
  mailingAddress: AddressDto | undefined;
  billingAddress: AddressDto | undefined;
  description: string | undefined;
  establishedDate: Date | undefined;
  international: boolean | undefined;
  isActive: boolean;
  deactivatedDate: Date | undefined;
  organizationNumber: string | undefined;
  orderNumber: string | undefined;
  clusterId: string;
  mainContactId: string | undefined;
  clusterMemberTypeId: string | undefined;
  clusterMemberType: ClusterMemberTypeDto | undefined;
  clusterMemberCategoryId: string | undefined;
  clusterMemberCategory: ClusterMemberCategoryDto | undefined;
  clusterMemberFee: ClusterMemberFeeDto | undefined;
  interestAreas: InterestAreaDto[];
  details: ClusterMemberDetailsDto | undefined;
}

export interface ClusterMemberTypeDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ClusterMemberCategoryDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ClusterMemberFeeDto {
  id: string;
  name: string | undefined;
  amount: number | undefined;
  clusterId: string;
}

export interface InterestAreaDto {
  id: string;
  name: string;
  description: string | undefined;
  clusterId: string;
  createdOn: Date;
  createdBy: string;
}

export interface ClusterMemberDetailsDto {
  numberOfEmployees: number | undefined;
  numberOfEmployeesLastYear: number | undefined;
  isFetchedFromBrReg: boolean | undefined;
  nace: string | undefined;
  companyTypeCode: string | undefined;
  companyTypeDescription: string | undefined;
  industry: string | undefined;
  bankrupt: boolean | undefined;
  liquidation: boolean | undefined;
  forcedLiquidation: boolean | undefined;
  registryEnhetsRegisteretDate: Date | undefined;
  registryMvaRegisteret: boolean | undefined;
  registryForetaksRegisteret: boolean | undefined;
  registryStiftelsesRegisteret: boolean | undefined;
  registryFrivillighetsRegisteret: boolean | undefined;
  femaleFounder: IsFemale | undefined;
  femaleCEO: IsFemale | undefined;
  femaleChairman: IsFemale | undefined;
  grossTurnover: number | undefined;
  staffCosts: number | undefined;
  resultBeforeAllocations: number | undefined;
  assetsTotal: number | undefined;
}

export enum IsFemale {
  Yes = 'Yes',
  No = 'No',
  Other = 'Other',
}

export enum ClusterContactStatus {
  Active = 'Active',
  InActive = 'InActive',
  PendingApproval = 'PendingApproval',
}

export enum Gender {
  Unspecified = 'Unspecified',
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}

export interface TimeRateDto {
  name: string | undefined;
  id: string;
  hourRate: number;
  clusterId: string;
  isClusterDefault: boolean;
}

export interface ODataResponseOfClusterContactDto {
  value: ClusterContactDto[];
  pagination: ODataPagination | undefined;
}

export interface ODataPagination {
  page: number;
  total: number;
  pageCount: number;
  totalPages: number;
}

export interface OperationResultOfClusterContactDto {
  data: ClusterContactDto | undefined;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

export interface ClusterContactCreateDto {
  clusterId: string;
  clusterMemberId: string | undefined;
  status: ClusterContactStatus;
  isClusterMemberMainContact: boolean;
  firstName: string | undefined;
  lastName: string | undefined;
  mobilePhone: string | undefined;
  gender: Gender;
  description: string | undefined;
  emailAddress: string;
  timeRateId: string | undefined;
  interestAreaIds: string[];
  jobTitle: string | undefined;
}

export interface OperationResultOfGuid {
  data: string;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

export interface ClusterContactUpdateDto {
  clusterId: string;
  clusterMemberId: string | undefined;
  status: ClusterContactStatus;
  deactivatedDate: Date | undefined;
  isClusterMemberMainContact: boolean;
  firstName: string | undefined;
  lastName: string | undefined;
  mobilePhone: string | undefined;
  gender: Gender;
  description: string | undefined;
  emailAddress: string;
  timeRateId: string | undefined;
  interestAreaIds: string[];
  jobTitle: string | undefined;
}

export interface ClusterMemberCreateDto {
  memberSince: Date | undefined;
  name: string | undefined;
  mailingAddress: AddressDto | undefined;
  billingAddress: AddressDto | undefined;
  description: string | undefined;
  establishedDate: Date | undefined;
  international: boolean | undefined;
  organizationNumber: string | undefined;
  orderNumber: string | undefined;
  clusterId: string;
  clusterMemberTypeId: string | undefined;
  clusterMemberCategoryId: string | undefined;
  clusterMemberFeeId: string | undefined;
  interestAreaIds: string[] | undefined;
  details: ClusterMemberDetailsDto | undefined;
}

export interface ClusterMemberUpdateDto {
  memberSince: Date | undefined;
  name: string | undefined;
  mailingAddress: AddressDto | undefined;
  billingAddress: AddressDto | undefined;
  description: string | undefined;
  establishedDate: Date | undefined;
  international: boolean | undefined;
  isActive: boolean;
  deactivatedDate: Date | undefined;
  organizationNumber: string | undefined;
  orderNumber: string | undefined;
  clusterId: string;
  clusterMemberTypeId: string | undefined;
  clusterMemberCategoryId: string | undefined;
  clusterMemberFeeId: string | undefined;
  interestAreaIds: string[];
  details: ClusterMemberDetailsDto | undefined;
}

export interface ClusterDto {
  id: string;
  name: string | undefined;
  emailAddress: string | undefined;
  telephone: string | undefined;
  websiteUrl: string | undefined;
  organizationNumber: string | undefined;
  address: AddressDto | undefined;
  industryCode: string | undefined;
  clusterPurpose: string | undefined;
  clusterVision: string | undefined;
  inCrmAccountId: string | undefined;
  dateOfFoundation: Date | undefined;
  createdById: string | undefined;
  createdOn: Date | undefined;
  modifiedById: string | undefined;
  modifiedOn: Date | undefined;
  clusterStatus: ClusterStatusDto | undefined;
  clusterStatusId: string | undefined;
  mainContact: ClusterUserDto | undefined;
  owner: ClusterOwnerDto | undefined;
  portfolioIndustries: PortfolioIndustryDto[];
  oneWayInCounties: string[];
  oneWayInMunicipalities: string[];
  oneWayInVmaNames: string[];
  isMunicipalityFirstLineService: boolean | undefined;
  administersProgramId: string | undefined;
  bsoContactEmail: string | undefined;
}

export interface ClusterStatusDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
  operationsApplicationFrame: number | undefined;
  developmentApplicationFrame: number | undefined;
  totalApplicationFrame: number | undefined;
  modules: ModuleDto[];
  statusProgramIds: string[];
}

export interface ModuleDto {
  id: string;
  code: string | undefined;
  description: string | undefined;
}

export interface ClusterUserDto {
  id: string;
  clusterId: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  phone: string | undefined;
  responsibilities: string | undefined;
  organization: string | undefined;
  userId: string | undefined;
  role: RoleDto | undefined;
  b2CId: string | undefined;
  invitationStatus: InvitationStatus | undefined;
  invitationCode: string | undefined;
  opportunityEmailInterval: EmailInterval;
  createdOn: Date;
}

export interface RoleDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
  roleCategory: RoleCategory;
  moduleAccesses: RoleModuleAccessDto[] | undefined;
}

export enum RoleCategory {
  Regular = 'Regular',
  Board = 'Board',
  Management = 'Management',
  External = 'External',
}

export interface RoleModuleAccessDto {
  moduleId: string;
  operation: Operation;
}

/** Holds the different permissions a role can have on a module */
export enum Operation {
  None = 'None',
  Read = 'Read',
  Write = 'Write',
}

export enum InvitationStatus {
  Created = 'Created',
  Sent = 'Sent',
  Accepted = 'Accepted',
}

export enum EmailInterval {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Never = 'Never',
}

export interface ClusterOwnerDto {
  name: string;
  organizationNumber: string;
  crmId: string;
  ownerFrom: Date;
  ownerTo: Date | undefined;
}

export interface PortfolioIndustryDto {
  id: string;
  name: string;
  description: string;
}

export interface ClusterUpdateDto {
  emailAddress: string | undefined;
  websiteUrl: string | undefined;
  address: AddressDto | undefined;
  industryCode: string | undefined;
  clusterPurpose: string | undefined;
  clusterVision: string | undefined;
  inCrmAccountId: string | undefined;
  dateOfFoundation: Date | undefined;
  mainContactId: string | undefined;
  oneWayInCounties: string[] | undefined;
  oneWayInMunicipalities: string[] | undefined;
  oneWayInVmaNames: string[] | undefined;
  portfolioIndustryIds: string[];
}

export interface ClusterMemberFeeCreateDto {
  name: string | undefined;
  amount: number | undefined;
  clusterId: string;
}

export interface ClusterMemberFeeUpdateDto {
  name: string;
  amount: number;
  clusterId: string;
}

export interface ClusterStatisticsDto {
  timeEntries: TimeEntryStatisticsDto[] | undefined;
  memberTypes: CountById[] | undefined;
  projectTypes: CountById[] | undefined;
  memberCategories: CountById[] | undefined;
  membersByState: StateMembers[] | undefined;
}

export interface TimeEntryStatisticsDto {
  year: number;
  timeEntriesByMonth: TimeEntriesInMonth[];
}

export interface TimeEntriesInMonth {
  month: number;
  value: number;
}

export interface CountById {
  id: string;
  label: string;
  value: number;
}

export interface StateMembers {
  county: string;
  members: Member[];
}

export interface Member {
  id: string;
  name: string;
}

export interface ClusterListDto {
  clusterId: string;
  oneWayInMunicipalities: string[] | undefined;
  oneWayInVmaNames: string[] | undefined;
  county: string | undefined;
  name: string;
  clusterStatusCode: string | undefined;
}

export interface ClusterSearchCriteria {
  oneWayInId: string | undefined;
  hasOneWayInServices: boolean | undefined;
  hasOneWayInVmaNames: boolean | undefined;
  statusProgramEnum: StatusProgramEnum | undefined;
}

export enum StatusProgramEnum {
  Siva = 'Siva',
  OneWayIn = 'OneWayIn',
  NIC = 'NIC',
}

export interface ClusterUserCreateDto {
  clusterId: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  phone: string | undefined;
  responsibilities: string | undefined;
  organization: string | undefined;
  roleId: string | undefined;
  opportunityEmailInterval: EmailInterval | undefined;
}

export interface ClusterUserUpdateDto {
  emailAddress: string;
  firstName: string;
  lastName: string;
  phone: string | undefined;
  responsibilities: string | undefined;
  organization: string | undefined;
  roleId: string | undefined;
  opportunityEmailInterval: EmailInterval | undefined;
}

export interface ClusterUsersInviteDto {
  activationBaseUrl: string;
  clusterUserIds: string[];
}

export interface NaceCode {
  code: string | undefined;
  descriptionNorwegian: string | undefined;
  descriptionEnglish: string | undefined;
  categories: NaceCategory[] | undefined;
}

export interface NaceCategory {
  code: string | undefined;
  parentCode: string | undefined;
  level: string | undefined;
  descriptionNorwegian: string | undefined;
  descriptionEnglish: string | undefined;
}

/** Postnummer / Poststed med metadata */
export interface ZipDto {
  /** Postnummer
   */
  zipCode: string;
  /** Poststed
   */
  cityName: string;
  /** Kommunenummer
   */
  municipalityCode: string;
  /** Kommunenavn
   */
  municipalityName: string;
  /** Fylkenummer
   */
  countyCode: string;
  /** Fylkenavn
   */
  countyName: string;
}

/** Class for holding information about an customer fetched from external apis. */
export interface CustomerInfoDto {
  /** Calculated, anonymised id for the customer.
   */
  id: string;
  /** Id used in the public register where the customer is fetched from.
   */
  publicId: string;
  /** What kind of id is registered.
   */
  identityType: IdentityType;
  /** If the customer should be considered active or not. */
  state: State;
  /** Name of the customer.
   */
  name: string | undefined;
  /** What kind of organization the customer can be categorized under.
   */
  organizationType: OrganizationType | undefined;
  /** Postal address.
   */
  postalAddress: Address | undefined;
  /** Visitor address.
   */
  visitorAddress: Address | undefined;
  /** Which sector the customer is in.
   */
  sector: Sector | undefined;
  /** First Nace category.
   */
  nace1: NaceCode | undefined;
  /** Second Nace category.
   */
  nace2: NaceCode | undefined;
  /** Third Nace category.
   */
  nace3: NaceCode | undefined;
  /** Forth Nace category.
   */
  nace4: NaceCode | undefined;
  /** Roles persons have within the customer account.
   */
  roles: CompanyRole[] | undefined;
  /** Contact information for the customer.
   */
  contactInformation: ContactInformation | undefined;
  /** Contact person for the customer.
   */
  contactPerson: ContactPerson | undefined;
  /** Capital the customer has tied to its accounts according public records.
   */
  capital: CapitalInformation | undefined;
  /** Legal information about the customer.
   */
  legal: Legal | undefined;
  /** Information about employees the customer has.
   */
  employeeInformation: EmployeeInformation | undefined;
  /** Status information from brreg register for companies.
   */
  status: BrregStatus | undefined;
  /** Information about the customer marital status. */
  maritalStatus: MaritalStatus;
}

/** Enum for what kind of identity is given. */
export enum IdentityType {
  Company = 'Company',
  Person = 'Person',
}

/** Shows if customer should be considered active or not. */
export enum State {
  Active = 'Active',
  Inactive = 'Inactive',
}

/** Class for holding organization type. */
export interface OrganizationType {
  /** The type short name.
   */
  type: string | undefined;
  /** Long description for the organization type.
   */
  typeDescription: string | undefined;
}

/** Class for holding an address. */
export interface Address {
  /** Street address line 1.
   */
  addressLine1: string | undefined;
  /** Address line 2.
   */
  addressLine2: string | undefined;
  /** Address line 3.
   */
  addressLine3: string | undefined;
  /** Zip code for the street address.
   */
  zipCode: string | undefined;
  /** City for the zip code.
   */
  city: string | undefined;
  /** Municipality full name the address is in.
   */
  municipality: string | undefined;
  /** Code/Id for the municipality.
   */
  municipalityCode: string | undefined;
  /** Code/Id for the county the address is in.
   */
  countyCode: string | undefined;
  /** Code/Id for the country the address is in.
   */
  countryCode: string | undefined;
  /** Country full name the address is in.
   */
  country: string | undefined;
}

/** Class for holding sector information. */
export interface Sector {
  /** Sector code/id
   */
  code: string | undefined;
  /** Long description for the sector in norwegian.
   */
  norwegianDescription: string | undefined;
}

/** Class for holding roles within a customer. */
export interface CompanyRole {
  /** Calculated, anonymised id for the person/company.
   */
  id: string | undefined;
  /** Id used in public records.
   */
  publicId: string | undefined;
  /** Type of id for public records.
   */
  identityType: IdentityType;
  /** Name of the role holder.
   */
  name: string | undefined;
  /** Address to the role holder.
   */
  address: Address | undefined;
  /** Description for role relationship.
   */
  description: string | undefined;
  /** Long description of the role within the customer.
   */
  roleDescription: string | undefined;
  /** Short name of the type of role.
   */
  roleType: string | undefined;
  /** Responsible stake with this role.
   */
  responsibleStake: string | undefined;
  /** Accountant code.
   */
  accountantCode: number | undefined;
  /** Category for the accountant.
   */
  accountantCategory: number | undefined;
  /** Description of the accountant.
   */
  accountantDescription: string | undefined;
}

/** Class that holds general contact information. */
export interface ContactInformation {
  /** Preferred contact phone number.
   */
  phoneNumber: string | undefined;
  /** Preferred contact mobile number.
   */
  mobileNumber: string | undefined;
  /** Preferred contact email address.
   */
  email: string | undefined;
  /** Website for customer.
   */
  website: string | undefined;
}

/** Class for holding information about a contact person. */
export interface ContactPerson {
  /** Calculated, anonymised id for the contact person.
   */
  id: string | undefined;
  /** First name of the person.
   */
  firstName: string | undefined;
  /** Last name of the person.
   */
  lastName: string | undefined;
  /** Fullname of the person. FirstName + MiddleName + LastName
   */
  fullName: string | undefined;
  /** Title the person has in accompanying customer.
   */
  title: string | undefined;
}

/** Class for holding capital information. */
export interface CapitalInformation {
  /** Which currency the capital is given in.
   */
  currency: string | undefined;
  /** Amount of capital.
   */
  capital: number;
  /** Which kind of capital is registered.
   */
  capitalType: string | undefined;
  /** Proceed conditions for the capital.
   */
  proceedsConditions: string | undefined;
}

/** Legal details for a customer. */
export interface Legal {
  /** Information about procuration for the customer.
   */
  procurationInformation: string | undefined;
  /** Information about signatures for the customer.
   */
  signatureInformation: string | undefined;
}

/** Class for holding information about employees. */
export interface EmployeeInformation {
  /** Whether the customer has employees or not.
   */
  hasEmployees: boolean;
  /** Total number of employees. If this number is zero and HasEmployees is true, the number of employees is in the range 1-4.
   */
  numberOfEmployees: number;
  /** When the last employees information was registered.
   */
  registeredOn: Date | undefined;
}

/** Statuses registered in brreg public record. */
export interface BrregStatus {
  /** If the company is registered in `Foretaksregisteret`.
   */
  registeredInForetaksregisteret: boolean;
  /** If the company is registered in `Frivillighetsregisteret`.
   */
  registeredInFrivillighetsregisteret: boolean;
  /** If the company is registered in `Mva-registeret`.
   */
  registeredInMvaregisteret: boolean;
  /** If the company is registered in `Stiftelsesregisteret`.
   */
  registeredInStiftelsesregisteret: boolean;
  /** If the company is registered in `NAV AA-registeret`.
   */
  registeredInNavaaregisteret: boolean;
  /** List of status messages.
   */
  statusDescriptions: string[] | undefined;
  /** If the company has been deleted.
   */
  companyDeleted: boolean;
  /** When the company was registered.
   */
  registeredOn: Date;
  /** When the company was incorporated.
   */
  dateOfIncorporation: Date | undefined;
  /** The date a company was deleted. */
  deletedOn: Date | undefined;
}

/** The MaritalStatus indicates the customer current marital status. */
export enum MaritalStatus {
  Unknown = 'Unknown',
  Unmarried = 'Unmarried',
  Married = 'Married',
  SurvivingSpouse = 'SurvivingSpouse',
  DivorcedSpouse = 'DivorcedSpouse',
  SeperatedSpouse = 'SeperatedSpouse',
  RegisteredPartner = 'RegisteredPartner',
  SeperatedPartner = 'SeperatedPartner',
  DivorcedPartner = 'DivorcedPartner',
  SurvivingPartner = 'SurvivingPartner',
}

export interface AccountingData {
  organizationNumber: string | undefined;
  fiscalYear: number;
  groupAccounting: string | undefined;
  salesIncome: number | undefined;
  otherOperationalIncome: number | undefined;
  costOfGoodsSold: number | undefined;
  changeInInventoryOfGoodsDuringManufacturingAndManufacturedGoods: number | undefined;
  salaryExpenses: number | undefined;
  depreciationOfFixedAssetsAndIntangibleAssets: number | undefined;
  writeDownOfFixedAssetsAndIntangibleAssets: number | undefined;
  otherOperationalExpenses: number | undefined;
  operationalResults: number | undefined;
  incomeFromInvestmentsInSubsidiary: number | undefined;
  incomeFromInvestmentsInOtherCompanyInSameGroup: number | undefined;
  incomeFromInvestmentsInAffiliatedCompany: number | undefined;
  interestIncomeFromCompanyInSameGroup: number | undefined;
  otherInterestIncome: number | undefined;
  otherFinancialIncome: number | undefined;
  changeInValueOfMarketBasedFinancialCurrentAssets: number | undefined;
  writeDownOfOtherFinancialCurrentAssets: number | undefined;
  writeDownOfFinancialFixedAssets: number | undefined;
  interestExpenseToCompaniesInTheSameGroup: number | undefined;
  otherInterestCosts: number | undefined;
  otherFinancialCosts: number | undefined;
  ordinaryProfitBeforeTax: number | undefined;
  taxOnOrdinaryProfit: number | undefined;
  ordinaryProfit: number | undefined;
  extraordinaryIncome: number | undefined;
  extraordinaryExpense: number | undefined;
  taxOnExtraordinaryProfit: number | undefined;
  annualResult: number | undefined;
  fixedAssets: number | undefined;
  intangibleAssets: number | undefined;
  researchAndDevelopment: number | undefined;
  concessionsPatentsLicensesTrademarksAndSimilarRights: number | undefined;
  deferredTaxBenefit: number | undefined;
  goodwill: number | undefined;
  tangibleFixedAssets: number | undefined;
  plotsBuildingsAndOtherPermanentProperty: number | undefined;
  machineryAndFacilities: number | undefined;
  shipsRiggsAirplanesAndSimilar: number | undefined;
  accessoriesInventoryToolsOfficeEquipmentAndSimilar: number | undefined;
  financialFixedAssets: number | undefined;
  investmentsInSubsidiary: number | undefined;
  investmentsInOtherCompanyInSameGroup: number | undefined;
  loanToCompanyInSameGroup: number | undefined;
  investmentsInAffiliatedCompany: number | undefined;
  loanToAffiliatedCompanyAndJointVenture: number | undefined;
  investmentsInStocksAndSecurities: number | undefined;
  bondsAndOtherReceivables: number | undefined;
  currentAssets: number | undefined;
  goods: number | undefined;
  receivables: number | undefined;
  customerReceivables: number | undefined;
  otherReceivables: number | undefined;
  groupReceivables: number | undefined;
  investments: number | undefined;
  stocksAndSharesInCompanyInSameGroup: number | undefined;
  marketBasedShares: number | undefined;
  marketBasedBonds: number | undefined;
  otherMarketBasedFinancialInstrument: number | undefined;
  otherFinancialInstrument: number | undefined;
  bankDepositsCashAndSimilar: number | undefined;
  equity: number | undefined;
  contributedEquity: number | undefined;
  companyEquity: number | undefined;
  capitalSurplus: number | undefined;
  retainedEarnings: number | undefined;
  ownedSharesFund: number | undefined;
  otherEquity: number | undefined;
  debt: number | undefined;
  provisionForObligations: number | undefined;
  pensionObligations: number | undefined;
  deferredTax: number | undefined;
  otherProvisionsForObligations: number | undefined;
  otherLongTermDebt: number | undefined;
  convertibleLoan1: number | undefined;
  bondLoan: number | undefined;
  debtToCreditInstitutionsL: number | undefined;
  additionalLongTermDebt: number | undefined;
  shortTermDebt: number | undefined;
  convertibleLoan2: number | undefined;
  commercialPaper: number | undefined;
  debtToCreditInstitutionsS: number | undefined;
  accountsPayable: number | undefined;
  payableTax: number | undefined;
  unpaidGovernmentFees: number | undefined;
  dividend: number | undefined;
  otherShortTermDebt: number | undefined;
  debtAndEquity: number | undefined;
  minorityInterest: number | undefined;
}

export interface InterestAreaCreateDto {
  clusterId: string;
  name: string;
  description: string | undefined;
}

export interface InterestAreaUpdateDto {
  clusterId: string;
  name: string | undefined;
  description: string | undefined;
}

export interface ProjectActivityDto {
  id: string;
  name: string;
  description: string | undefined;
  startDate: Date;
  endDate: Date;
  projectId: string;
  events: EventDto[];
}

export interface EventDto {
  id: string;
  projectActivityId: string;
  clusterId: string;
  name: string;
  description: string | undefined;
  location: string | undefined;
  duration: number;
  isPublic: boolean;
  startDate: Date;
  endDate: Date | undefined;
  expenseTypes: ExpenseTypeDto[];
}

export interface ExpenseTypeDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ProjectActivityCreateDto {
  name: string;
  description: string | undefined;
  startDate: Date;
  endDate: Date;
  projectId: string;
}

export interface Attachment {
  contentType: string | undefined;
  uploadName: string | undefined;
  name: string | undefined;
  uploadTime: Date | undefined;
  length: number | undefined;
  type: AttachmentType | undefined;
  tag: string | undefined;
  hidden: boolean | undefined;
}

export enum AttachmentType {
  Customer = 'Customer',
  System = 'System',
  Application = 'Application',
  Internal = 'Internal',
  External = 'External',
}

export interface ReportBase {
  id: string | undefined;
  title: string | undefined;
  submitProgress: number | undefined;
  status: FormStatus | undefined;
  metadata: ReportMetadata | undefined;
  attachments: Attachment[] | undefined;
  reportType: string;
}

export interface OperationInterimReportDto extends ReportBase {
  reportType: string;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  clusterVision: string | undefined;
  clusterPurpose: string | undefined;
  mainFocus: string | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  applicationProjects: StringListItem[] | undefined;
  focusAreaAndGoalChangeComment: string | undefined;
  projectsProgress: ProjectProgress[] | undefined;
  projectProgressComment: string | undefined;
  otherProjectsComment: string | undefined;
  incompleteProjectComment: string | undefined;
  projectResultAndEffects: ProjectResultAndEffect[] | undefined;
  goalsComment: string | undefined;
  expenseTypes: ExpenseType[] | undefined;
  financingSources: FinancingSource[] | undefined;
  deviationDescription: string | undefined;
}

export interface StringListItem {
  id: string;
  name: string;
}

export interface ProjectProgress {
  id: string;
  projectName: string | undefined;
  description: string | undefined;
  completionPrognosis: boolean | undefined;
}

export interface ProjectResultAndEffect {
  id: string;
  projectName: string;
  expectation: string;
}

export interface ExpenseType {
  id: string;
  name: string;
  code: string;
  applicantOrganisationAmount: number;
  participantOrganisationAmount: number;
  applicantOrganisationAmountCorrected: number;
  participantOrganisationAmountCorrected: number;
}

export interface FinancingSource {
  id: string;
  name: string;
  code: string;
  amount: number;
}

export enum FormStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Returned = 'Returned',
  AdmRefusal = 'AdmRefusal',
  UnderConsideration = 'UnderConsideration',
  PendingDecision = 'PendingDecision',
  Decided = 'Decided',
  Completed = 'Completed',
  UnallocatedMunicipality = 'UnallocatedMunicipality',
  UnderConsiderationMunicipality = 'UnderConsiderationMunicipality',
  ReturnedByMunicipality = 'ReturnedByMunicipality',
  Approved = 'Approved',
  Refusal = 'Refusal',
  Withdrawn = 'Withdrawn',
  Unallocated = 'Unallocated',
  MissingInformation = 'MissingInformation',
}

export interface ReportMetadata {
  createdBy: string | undefined;
  createdOn: Date | undefined;
  language: Language;
  submittedOn: Date | undefined;
  submittedBy: string | undefined;
  modifiedBy: string | undefined;
  modifiedOn: Date | undefined;
}

export enum Language {
  En_GB = 'en_GB',
  Nb_NO = 'nb_NO',
  Nn_NO = 'nn_NO',
}

export interface ReportListItemBase {
  id: string;
  title: string;
  createdOn: Date;
  modifiedOn: Date;
  status: FormStatus | undefined;
  reportType: string;
  submitProgress: number;
  attachments: Attachment[];
}

export interface OperationInterimListItemDto extends ReportListItemBase {
  reportType: string;
  caseNumber: string;
}

export enum DocumentTypes {
  Pdf = 'pdf',
  Docx = 'docx',
}

export enum SupportedLocales {
  Nb = 'nb',
  Nn = 'nn',
  En = 'en',
}

export interface OperationInterimGeneralDto {
  clusterName: string;
  clusterManager: string;
  caseNumber: string;
  startDate: Date;
  clusterVision: string;
  clusterPurpose: string;
  mainFocus: string;
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  applicationProjects: StringListItem[];
  projectResultAndEffects: ProjectResultAndEffect[];
  projectsProgress: ProjectProgress[];
}

export interface OperationInterimFinancialDto {
  expenseTypes: ExpenseType[];
  financingSources: FinancingSource[];
}

export interface OperationFinalReportDto extends ReportBase {
  reportType: string;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  aboutClusterFromApplication: string | undefined;
  aboutResourceBaseFromApplication: string | undefined;
  resourceBaseCompositionComment: string | undefined;
  clusterVision: string | undefined;
  clusterPurpose: string | undefined;
  mainFocus: string | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  applicationProjects: DescriptionListItem[] | undefined;
  projectResultAndEffects: ProjectResultAndEffect[] | undefined;
  projectGoalsComment: string | undefined;
  projectsCompletedAccordingToPlanComment: string | undefined;
  projectsWereCompleted: boolean | undefined;
  focusAreaAndGoalChangeComment: string | undefined;
  expenseTypes: ExpenseType[] | undefined;
  projectsFinances: ProjectFinances[] | undefined;
  deviationDescription: string | undefined;
  financingSources: FinancingSource[] | undefined;
  roadAhead: string | undefined;
  roadAheadComment: string | undefined;
}

export interface DescriptionListItem {
  id: string;
  name: string;
  description: string | undefined;
}

export interface ProjectFinances {
  id: string;
  projectName: string | undefined;
  expenseTypes: ExpenseType[] | undefined;
}

export interface OperationFinalListItemDto extends ReportListItemBase {
  reportType: string;
  caseNumber: string;
}

export interface OperationFinalGeneralDto {
  clusterName: string;
  clusterManager: string;
  caseNumber: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  aboutClusterFromApplication: string;
  aboutResourceBaseFromApplication: string;
  roadAhead: string;
  clusterVision: string;
  clusterPurpose: string;
  mainFocus: string;
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  applicationProjects: DescriptionListItem[];
  projectResultAndEffects: ProjectResultAndEffect[];
}

export interface OperationFinalFinancialDto {
  expenseTypes: ExpenseType[];
  projectsFinances: ProjectFinances[];
  deviationDescription: string;
  financingSources: FinancingSource[];
}

export interface BasisInterimReportGeneralDto {
  clusterName: string;
  clusterManager: string;
  caseNumber: string;
  clusterVision: string;
  clusterPurpose: string;
  startDate: Date;
  endDate: Date;
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  applicationProjects: StringListItem[];
  projectsProgress: ProjectProgress[];
}

export interface BasisInterimReportDto extends ReportBase {
  reportType: string;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  clusterVision: string | undefined;
  clusterPurpose: string | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  applicationProjects: StringListItem[] | undefined;
  focusAreaAndGoalChangeComment: string | undefined;
  goalsComment: string | undefined;
  projectsProgress: ProjectProgress[] | undefined;
  projectProgressComment: string | undefined;
  incompleteProjectComment: string | undefined;
}

export interface BasisInterimListItemDto extends ReportListItemBase {
  reportType: string;
  caseNumber: string;
}

export interface BasisFinalReportCreationDto {
  clusterName: string;
  clusterManager: string;
  reportedYear: number;
  caseNumber: string;
  clusterVision: string;
  clusterPurpose: string;
  startDate: Date;
  endDate: Date;
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  aboutClusterFromApplication: string;
  aboutResourceBaseFromApplication: string;
  projects: DescriptionListItem[];
}

export interface BasisFinalReportDto extends ReportBase {
  reportType: string;
  aboutClusterFromApplication: string | undefined;
  aboutResourceBaseFromApplication: string | undefined;
  resourceBaseCompositionComment: string | undefined;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  reportedYear: number;
  startDate: Date | undefined;
  endDate: Date | undefined;
  clusterVision: string | undefined;
  clusterPurpose: string | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  focusAreaAndGoalChangeComment: string | undefined;
  goalsComment: string | undefined;
  projects: DescriptionListItem[] | undefined;
  developmentProjectsCompleted: boolean | undefined;
  developmentProjectsCompletedComment: string | undefined;
}

export interface BasisFinalListItemDto extends ReportListItemBase {
  reportType: string;
  reportedYear: number;
  caseNumber: string;
}

export interface DevProjectInterimGeneralDto {
  clusterName: string;
  projectName: string;
  projectId: string;
  clusterManager: string;
  startDate: Date;
  endDate: Date;
  caseNumber: string;
  goalDescription: string;
  projectActivities: DescriptionListItem[];
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  justification: string;
}

export interface DevProjectInterimFinancialDto {
  financingSources: FinancingSource[];
  projectCostsPerExpenseType: ExpenseTypeV2[];
}

export interface ExpenseTypeV2 {
  id: string;
  name: string;
  code: string;
  applicantOrganisationAmount: number;
  participantOrganisationAmount: number;
}

export interface DevProjectInterimReportDto extends ReportBase {
  reportType: string;
  clusterName: string | undefined;
  projectName: string | undefined;
  projectId: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  justification: string | undefined;
  focusAreaAndGoalChangeComment: string | undefined;
  goalDescription: string | undefined;
  goalsComment: string | undefined;
  projectActivities: DescriptionListItem[] | undefined;
  activityPlanIsFollowed: boolean | undefined;
  activityPlanComment: string | undefined;
  financingSources: FinancingSource[] | undefined;
  projectCostsPerExpenseType: ExpenseTypeV2[] | undefined;
  deviationDescription: string | undefined;
}

export interface DevProjectInterimListItemDto extends ReportListItemBase {
  reportType: string;
  projectId: string;
}

export interface DevProjectFinalGeneralDto {
  clusterName: string;
  projectName: string;
  projectId: string | undefined;
  clusterManager: string;
  caseNumber: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  projectMembers: StringListItem[];
  mainGoals: StringListItem[];
  focusAreas: StringListItem[];
  justification: string;
  goalDescription: string;
  projectSocialEnvironmentalEffects: StringListItem[];
  environmentalGoalContribution: RadioButtonOption[];
  clusterGoalHelpedByProject: RadioButtonOption[];
  projectActivities: DescriptionListItem[];
}

export interface RadioButtonOption {
  id: string;
  name: string | undefined;
  code: string | undefined;
  selected: boolean;
}

export interface DevProjectFinalReportDto extends ReportBase {
  reportType: string;
  clusterName: string | undefined;
  projectName: string | undefined;
  projectId: string | undefined;
  clusterManager: string | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  projectMembers: StringListItem[] | undefined;
  mainGoals: StringListItem[] | undefined;
  focusAreas: StringListItem[] | undefined;
  justification: string | undefined;
  projectChangesComment: string | undefined;
  goalDescription: string | undefined;
  projectSocialEnvironmentalEffects: StringListItem[] | undefined;
  environmentalGoalContribution: RadioButtonOption[] | undefined;
  environmentalGoalReached: boolean | undefined;
  clusterGoalHelpedByProject: RadioButtonOption[] | undefined;
  goalsComment: string | undefined;
  projectActivities: DescriptionListItem[] | undefined;
  activityExecutionComment: string | undefined;
  projectCostsPerExpenseType: ExpenseTypeV2[] | undefined;
  financingSources: FinancingSource[] | undefined;
  deviationDescription: string | undefined;
}

export interface DevProjectFinalListItemDto extends ReportListItemBase {
  reportType: string;
  projectId: string;
}

export interface AnnualReportCreationDto {
  title: string | undefined;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  reportedYear: number;
  caseNumber: string | undefined;
  clusterVision: string | undefined;
  clusterPurpose: string | undefined;
  startDate: Date;
  endDate: Date;
  resourceBaseDetails: ResourceBaseDetails | undefined;
  projectsDetails: ProjectsAndEngagementDetails | undefined;
  successStorySocialEnvironmentalEffect: RadioButtonOption[] | undefined;
}

export interface ResourceBaseDetails {
  boardMembers: number | undefined;
  companyRepBoardMembers: number | undefined;
  womenOnBoard: number | undefined;
  onClusterManagementPayroll: number | undefined;
  clusterManagmentManYears: number | undefined;
  womenInClusterManagement: number | undefined;
  totalMembers: number | undefined;
  totalClusterAssosiatedMembers: number | undefined;
  totalMembersByType: ObjectCount[] | undefined;
}

export interface ObjectCount {
  id: string;
  name: string;
  localeCode: string;
  count: number;
}

export interface ProjectsAndEngagementDetails {
  totalEvents: number | undefined;
  uniqueEventParticipants: number | undefined;
  totalProjectFouFinances: number | undefined;
  totalEuFinances: number | undefined;
  newInternationalEvents: number | undefined;
  applicationProjectsDetails: ApplicationProjectsDetails | undefined;
  portalProjectsDetails: PortalProjectsDetails | undefined;
}

export interface ProjectsDetails {
  internationalCollaborations: number | undefined;
  internationalFouCollaborations: number | undefined;
  newClusterCollaborations: number | undefined;
  internationalClusterCollaborations: number | undefined;
}

export interface ApplicationProjectsDetails extends ProjectsDetails {
  trainingProjects: number | undefined;
  educationalOperationsProjects: number | undefined;
  conferenceParticipationProjects: number | undefined;
  internationalMarketsKnowledgeProjects: number | undefined;
  internationalMarketPositionsDevelopmentProjects: number | undefined;
  innovationCooperationProjects: number | undefined;
  feasibilityStudyProjects: number | undefined;
  investmentsProjects: number | undefined;
}

export interface PortalProjectsDetails extends ProjectsDetails {
  internationalizationProjects: number | undefined;
  competenceDevelopmentProjects: number | undefined;
  innovationCollaborationProjects: number | undefined;
  customProjects: number | undefined;
  newEstablishmentsSupportedByCluster: number | undefined;
  newJobsCreated: number | undefined;
}

export interface AnnualReportDto extends ReportBase {
  reportType: string;
  resourceBaseDetails: ResourceBaseDetails | undefined;
  clusterName: string | undefined;
  clusterManager: string | undefined;
  reportedYear: number | undefined;
  caseNumber: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  internationalEventsComment: string | undefined;
  projectsDetails: ProjectsAndEngagementDetails | undefined;
  successStorySocietalChallenges: string | undefined;
  successStorySocialEnvironmentalEffect: RadioButtonOption[] | undefined;
  successStoryClusterEffect: string | undefined;
}

export interface AnnualListItemDto extends ReportListItemBase {
  reportType: string;
  reportedYear: number;
  caseNumber: string;
}

export interface UserContextDto {
  userId: string;
  clusterUserId: string | undefined;
  displayName: string;
  chosenClusterId: string | undefined;
  authDomain: string;
  dateOfBirth: string;
}

export interface ApplicationStatisticsDto {
  selfEffortTotal: number;
  selfEffortApplicationSum: number;
}

export interface ClusterInvoiceDto {
  id: string | undefined;
  invoiceDate: Date;
  invoiceNumber: string;
  marketValue: number;
  deductible: number;
  description: string;
  clusterMemberOrgNo: string | undefined;
  clusterMemberName: string | undefined;
  clusterMemberId: string;
}

export interface ClusterInvoiceCreateDto {
  id: string | undefined;
  invoiceDate: Date;
  invoiceNumber: string;
  marketValue: number;
  deductible: number;
  description: string;
  clusterMemberOrgNo: string | undefined;
  clusterMemberName: string | undefined;
  clusterMemberId: string | undefined;
}

export enum ImageSize {
  Thumbnail = 'thumbnail',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export interface ClusterMemberAttachmentDto {
  id: string;
  clusterMemberId: string;
  name: string;
  size: number;
  contentType: string;
}

export interface ClusterMemberEconomyDto {
  id: string;
  invoiceNumber: string | undefined;
  marketValue: number | undefined;
  invoicedDeductible: number | undefined;
  clusterMemberId: string;
}

export interface ClusterMemberEconomyCreateDto {
  invoiceNumber: string | undefined;
  marketValue: number | undefined;
  invoicedDeductible: number | undefined;
  clusterMemberId: string;
}

export interface ClusterMemberEconomyUpdateDto {
  invoiceNumber: string | undefined;
  marketValue: number | undefined;
  invoicedDeductible: number | undefined;
}

export interface EnvironmentInformation {
  /** Name of the environment (dev, test, prod) */
  name: string;
  /** Instrumentation key for Application Insights. Will be set to null or empty when Name == "local". 
Otherwise it will be environment-specific */
  appInsightsInstrumentationKey: string;
}

export interface EnrichedCourseDto {
  clusterCourseId: string;
  externalId: string;
  name: string;
  timeDuration: string;
  description: string;
  bannerImageUrl: string;
  courseImageUrl: string;
  courseUrl: string;
  clusterId: string;
  excludeFromFrontPage: boolean;
}

export interface CourseRecommendationDto {
  clusterContact: ClusterContactDto;
  courseId: string;
  createdOn: Date;
}

export interface CourseRecommendationCreateDto {
  clusterContactId: string;
  subject: string;
  clusterName: string;
  name: string;
  imageSrc: string;
  imageAlt: string;
  courseName: string;
  courseDescription: string;
  coursePrice: string;
  courseDuration: string;
  courseLocation: string;
  courseLink: string;
}

export interface ProjectListItemDto {
  id: string;
  name: string;
  description: string | undefined;
  projectPhase: ProjectPhaseDto | undefined;
  projectEndReason: ProjectEndReasonDto | undefined;
  startDate: Date;
  endDate: Date;
}

export interface DevelopmentProjectListItemDto extends ProjectListItemDto {
  projectType: ProjectTypeDto;
}

export interface ProjectTypeDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ProjectPhaseDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ProjectEndReasonDto {
  id: string;
  projectEndCategory: ProjectEndCategoryDto;
  projectEndSubCategory: ProjectEndSubCategoryDto | undefined;
  satisfactionRate: number | undefined;
  description: string | undefined;
  projectId: string;
}

export interface ProjectEndCategoryDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ProjectEndSubCategoryDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ProjectsDto {
  id: string;
  clusterId: string;
  name: string;
  description: string | undefined;
  startDate: Date;
  endDate: Date;
  projectPhase: ProjectPhaseDto | undefined;
  projectMainGoal: ProjectMainGoalDto | undefined;
  projectFocusAreas: ProjectFocusAreaDto[];
  projectSocialEnvironmentalEffects: ProjectSocialEnvironmentalEffectDto[];
  projectEndReason: ProjectEndReasonDto | undefined;
  numberOfParticipants: number;
  isTerminated: boolean;
}

export interface DevelopmentProjectDto extends ProjectsDto {
  projectType: ProjectTypeDto;
  caseNumber: string | undefined;
  justification: string | undefined;
  futureValue: string | undefined;
  goalDescription: string | undefined;
  trainingDescription: string | undefined;
  educationalOfferingsDescription: string | undefined;
  feasibilityStudyInnovationLevel: string | undefined;
}

export interface ProjectMainGoalDto {
  id: string;
  name: string;
  mainGoalDescription: string | undefined;
  mainGoalId: string;
  projectId: string;
}

export interface ProjectFocusAreaDto {
  id: string;
  name: string;
  focusAreaDescription: string | undefined;
  focusAreaId: string;
  focusArea: FocusAreaDto;
  projectId: string;
}

export interface FocusAreaDto {
  id: string;
  name: string;
  description: string | undefined;
  clusterId: string;
  isActive: boolean;
  createdOn: Date;
  createdBy: string;
}

export interface ProjectSocialEnvironmentalEffectDto {
  id: string;
  additionalComments: string | undefined;
  socialEnvironmentalEffectId: string;
  projectId: string;
}

export interface ProjectStatisticsDto {
  timeEntryHoursTotal: number;
  timeEntryCostTotal: number;
  uniqueParticipants: number;
  numberOfEvents: number;
  numberOfParticipants: number;
}

export interface ProjectEndReasonCreateDto {
  description: string | undefined;
  projectEndCategoryId: string;
  projectEndSubCategoryId: string | undefined;
  satisfactionRate: number | undefined;
}

export interface EeaArticleDto {
  id: string;
  name: string;
  article: string;
  policyTitle: string;
}

export interface EventDtoV2 {
  id: string;
  projectId: string;
  clusterId: string;
  name: string;
  description: string | undefined;
  location: string | undefined;
  duration: number;
  isPublic: boolean;
  startDate: Date;
  endDate: Date | undefined;
  category: EventCategory;
  expenseTypes: ExpenseTypeDto[];
}

export enum EventCategory {
  Event = 'Event',
  Meeting = 'Meeting',
  Phonecall = 'Phonecall',
  Email = 'Email',
}

export interface EventCreateDtoV2 {
  projectId: string;
  name: string;
  duration: number;
  description: string | undefined;
  location: string | undefined;
  isPublic: boolean;
  category: EventCategory;
  startDate: Date;
  endDate: Date | undefined;
  expenseTypeIds: string[] | undefined;
}

export interface EventUpdateDtoV2 {
  projectId: string;
  name: string;
  duration: number;
  description: string | undefined;
  location: string | undefined;
  isPublic: boolean;
  category: EventCategory | undefined;
  startDate: Date;
  endDate: Date | undefined;
  expenseTypeIds: string[] | undefined;
}

export interface EventDetailsDto {
  eventId: string;
  timeEntryHours: number;
  inKindTotal: number;
  participants: number;
}

export interface EventSimpleDto {
  id: string;
  name: string;
  duration: number;
  category: EventCategory;
  startDate: Date;
  endDate: Date | undefined;
}

export interface PublicEventSimpleRegistrationDto {
  emailAddress: string;
  hours: number;
  hoursDescription: string;
}

export interface PublicEventRegistrationDto {
  emailAddress: string;
  hours: number;
  hoursDescription: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyPostalCode: string | undefined;
  companyCity: string | undefined;
  companyOrganizationNumber: string | undefined;
}

export interface FinancingSourceDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface FocusAreaCreateDto {
  clusterId: string;
  name: string;
  description: string | undefined;
}

export interface FocusAreaUpdateDto {
  clusterId: string;
  name: string | undefined;
  description: string | undefined;
  isActive: boolean | undefined;
}

export interface MainGoalDto {
  id: string;
  name: string;
  isActive: boolean | undefined;
  description: string | undefined;
  clusterId: string;
  createdOn: Date;
  createdBy: string;
}

export interface MainGoalCreateDto {
  clusterId: string;
  name: string;
  description: string | undefined;
}

export interface MainGoalUpdateDto {
  clusterId: string;
  name: string | undefined;
  description: string | undefined;
  isActive: boolean | undefined;
}

export interface ServiceHealthMessageDto {
  id: string;
  publicMessage: string;
  loggedInMessage: string;
  showMaintenancePage: boolean;
  isActive: boolean;
}

export interface OnboardingPacketDto {
  id: string;
  name: string | undefined;
  description: string | undefined;
  code: string;
  order: number;
  completed: boolean;
}

export interface OneWayInFormCollection {
  forms: Skjemainfo[];
  pages: number;
  totalFormNumber: number;
}

export interface Skjemainfo {
  id: string | undefined;
  tittel: string | undefined;
  orgNr: string | undefined;
  kundenavn: string | undefined;
  innsendernavn: string | undefined;
  skjemaType: string | undefined;
  prosjektKommune: string | undefined;
  insendtDato: Date | undefined;
  henvisningsPartnere: Henvisningspartner[] | undefined;
}

export interface Henvisningspartner {
  id: string;
  navn: string | undefined;
}

export interface OneWayInOpportunitySimpleV2Dto {
  clusterId: string | undefined;
  id: string;
  title: string;
  /** External Id coming from SL.WebApplication */
  oneWayInId: string;
  isClosed: boolean;
  municipality: string | undefined;
  customerName: string | undefined;
  organizationName: string | undefined;
  organizationNumber: string | undefined;
  submittedOn: Date | undefined;
  lastChangedOn: Date | undefined;
  status: OneWayInOpportunityStatusDto | undefined;
  cooperationClusters: string[];
  sendFollowUpReminderOn: Date | undefined;
  clusterMemberId: string | undefined;
  assignedTo: string | undefined;
  opportunityType: OpportunityType | undefined;
  numericId: number;
  deliveredServices: SimpleServiceDto[] | undefined;
}

export interface OneWayInOpportunityStatusDto {
  id: string;
  /** Internal Opportunity Id */
  oneWayInOpportunityId: string | undefined;
  referenceClusterId: string | undefined;
  clusterId: string | undefined;
  clusterName: string | undefined;
  description: string | undefined;
  status: OneWayInStatus;
  closedReason: OneWayInClosedReason | undefined;
  createdOn: Date;
  referenceClusterName: string | undefined;
  recommendationEmail: RecommendationEmailDto | undefined;
  shareOpportunityActorEmail: ShareOpportunityEmailDto | undefined;
  shareOpportunityCustomerEmail: ShareOpportunityEmailDto | undefined;
  registeredServices: OneWayInServiceDto[];
  recommendedServices: OneWayInServiceDto[];
  deliveredServices: OneWayInServiceDto[];
  clusterUserId: string | undefined;
  clusterContactId: string | undefined;
  handlersName: string | undefined;
  admittedToProgram: boolean | undefined;
  sivaPhase: SivaPhase | undefined;
  deliveredOn: Date | undefined;
}

export enum OneWayInStatus {
  Active = 'Active',
  Opened = 'Opened',
  Forwarded = 'Forwarded',
  Closed = 'Closed',
  ReOpened = 'ReOpened',
  Received = 'Received',
  Shared = 'Shared',
  New = 'New',
  FollowUpLater = 'FollowUpLater',
  AutoArchived = 'AutoArchived',
  EmailSentToCustomer = 'EmailSentToCustomer',
  EmailReceivedFromCustomer = 'EmailReceivedFromCustomer',
  ReferredLater = 'ReferredLater',
}

export enum OneWayInClosedReason {
  SentInError = 'SentInError',
  Other = 'Other',
}

export interface RecommendationEmailDto {
  recipientName: string;
  recipientEmail: string;
  senderName: string;
  senderOrganisation: string;
  emailContent: string | undefined;
}

export interface ShareOpportunityEmailDto {
  recipients: string[];
  emailContent: string;
}

export interface OneWayInServiceDto {
  clusterId: string | undefined;
  id: string;
  name: string | undefined;
  validFrom: Date | undefined;
  validTo: Date | undefined;
  description: string | undefined;
  customerDescription: string | undefined;
  servicePurpose: string | undefined;
  keywords: string[];
  companyAge: CompanyAgeCriteria | undefined;
  innovationLevel: InnovationLevelCriteria | undefined;
  categoryCode: ServiceCategoryCode | undefined;
  companySize: CompanySizeCriteria[];
  businessId: string | undefined;
  businessName: string | undefined;
  internalUrl: string | undefined;
  contactName: string | undefined;
  contactEmail: string | undefined;
  contactPhone: string | undefined;
  districtPolicyArea: boolean | undefined;
  counties: string[];
  municipalities: string[];
  externalLinks: OwiExternalLinkDto[];
  deliveryTypes: DeliveryType[];
  deliveryDescription: string | undefined;
  hasDeadline: boolean | undefined;
  applicationDeadline: Date | undefined;
  hasUserFee: boolean | undefined;
  userFeeComments: string | undefined;
  customerSegment: CustomerSegmentTargetGroup[];
  customerSegmentComments: string | undefined;
  usesEeaArticles: boolean | undefined;
  selectedEeaArticles: EeaArticleDto[];
  eeaComments: string | undefined;
  isDeleted: boolean | undefined;
  isActive: boolean;
  isDraft: boolean;
  sponsors: Sponsor[];
  createdInPortal: boolean | undefined;
  state: PublicationState;
}

export enum CompanyAgeCriteria {
  UnderThreeYears = 'UnderThreeYears',
  UnderFiveYears = 'UnderFiveYears',
  RelevantForAllAges = 'RelevantForAllAges',
  Unknown = 'Unknown',
  OverFiveYears = 'OverFiveYears',
}

export enum InnovationLevelCriteria {
  InternationalLevel = 'InternationalLevel',
  NationalLevel = 'NationalLevel',
  RegionalLevel = 'RegionalLevel',
  CompanyLevel = 'CompanyLevel',
  NotRelevant = 'NotRelevant',
  Unknown = 'Unknown',
}

export enum ServiceCategoryCode {
  Naeringshageprogram = 'Naeringshageprogram',
  Inkubasjonsprogram = 'Inkubasjonsprogram',
  Preinkubasjonsprogram = 'Preinkubasjonsprogram',
  Naeringsfagligvurdering = 'Naeringsfagligvurdering',
  Kompetansemegling = 'Kompetansemegling',
  Norskkatapult = 'Norskkatapult',
  Forstelinjetjeneste = 'Forstelinjetjeneste',
  Unknown = 'Unknown',
}

export enum CompanySizeCriteria {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  OtherCategoriesMayApply = 'OtherCategoriesMayApply',
  Unknown = 'Unknown',
}

export interface OwiExternalLinkDto {
  text: string | undefined;
  url: string | undefined;
}

export enum DeliveryType {
  Connecting = 'Connecting',
  Egenkapital = 'Egenkapital',
  Fellesarrangementer = 'Fellesarrangementer',
  Foredrag = 'Foredrag',
  Garantier = 'Garantier',
  Kurs = 'Kurs',
  Lavrisikolaan = 'Lavrisikolaan',
  Orientering = 'Orientering',
  Prosjektarbeid = 'Prosjektarbeid',
  Publikasjon = 'Publikasjon',
  Raadgivning = 'Raadgivning',
  Risikolaan = 'Risikolaan',
  Selvbetjening = 'Selvbetjening',
  Tilskudd = 'Tilskudd',
  Unknown = 'Unknown',
}

export enum CustomerSegmentTargetGroup {
  OnlyForPublicEntities = 'OnlyForPublicEntities',
  MustOwnAgriculturalProperty = 'MustOwnAgriculturalProperty',
  RequiresParticipationInACluster = 'RequiresParticipationInACluster',
  OnlyForTourismIndustry = 'OnlyForTourismIndustry',
  Unknown = 'Unknown',
}

export enum Sponsor {
  NFD = 'NFD',
  KDD = 'KDD',
  KLD = 'KLD',
  Counties = 'Counties',
  KUD = 'KUD',
  KD = 'KD',
  LMD = 'LMD',
  Norad = 'Norad',
  OED = 'OED',
  SD = 'SD',
  UD = 'UD',
  FIN = 'FIN',
  DFD = 'DFD',
  Unknown = 'Unknown',
}

export enum PublicationState {
  Active = 'Active',
  Draft = 'Draft',
  Deleted = 'Deleted',
}

/** This enum is analogous to a subset of OpportunityType from SL.ApplicationMaster, which is also analogous to a OpportunityType declaration in SL.WebApplication. EnVeiInnPubClient filters out only these two OpportunityTypes. */
export enum OpportunityType {
  Opportunity = 'Opportunity',
  GreenPlatform = 'GreenPlatform',
}

export interface SimpleServiceDto {
  id: string | undefined;
  name: string | undefined;
}

export interface OneWayInMyPageListFormsFilter {
  oldToNew: boolean | undefined;
  fromDate: Date | undefined;
  toDate: Date | undefined;
  counties: string[];
  municipalities: string[];
  ignoreReferralParty: boolean;
  referralPartyNameOrId: string | undefined;
  top: number;
}

export interface GruppertSkjema {
  id: string | undefined;
  tittel: string | undefined;
  grupper: Feltgruppe[] | undefined;
  organisasjon: Organisasjon | undefined;
  kontakt: Kontakt | undefined;
  prosjektkommune: string | undefined;
  harLandbrukseiendom: boolean | undefined;
  innsendtDato: string | undefined;
  kilde: string | undefined;
}

export interface Feltgruppe {
  navn: string | undefined;
  felter: FeltFormatert[] | undefined;
  kategori: FeltGruppeKategori;
}

export interface FeltFormatert {
  navn: string | undefined;
  type: string | undefined;
  verdi: string | undefined;
  valg: Valg[] | undefined;
  felter: FeltFormatert[] | undefined;
  bredde: string | undefined;
  medieType: string | undefined;
  bitLengde: string | undefined;
}

export interface Valg {
  navn: string | undefined;
  verdi: string | undefined;
}

export enum FeltGruppeKategori {
  Skjemadata = 'Skjemadata',
  Bevilgninger = 'Bevilgninger',
  Kompetanse = 'Kompetanse',
  Regnskap = 'Regnskap',
}

export interface Organisasjon {
  navn: string | undefined;
  organisasjonstype: string | undefined;
  orgNr: string | undefined;
  erPerson: boolean;
  roller: Rolle[] | undefined;
  etableringsDato: string | undefined;
  bedriftsAlder: string | undefined;
  kommune: string | undefined;
  fylke: string | undefined;
  antallAnsatte: number | undefined;
  harAnsatte: boolean | undefined;
  erIDistriktpolitiskVirkeområde: boolean | undefined;
}

export interface Rolle {
  navn: string | undefined;
  rolleBeskrivelse: string | undefined;
}

export interface Kontakt {
  navn: string | undefined;
  fornavn: string | undefined;
  etternavn: string | undefined;
  epost: string | undefined;
  telefon: string | undefined;
}

export interface OneWayInOpportunityDto {
  clusterId: string;
  id: string;
  title: string;
  /** External Id coming from SL.WebApplication */
  oneWayInId: string;
  isClosed: boolean;
  municipality: string | undefined;
  customerName: string | undefined;
  organizationName: string | undefined;
  organizationNumber: string | undefined;
  submittedOn: Date | undefined;
  lastChangedOn: Date | undefined;
  originalRecipients: string[] | undefined;
  status: OneWayInOpportunityStatusDto;
  history: OneWayInOpportunityStatusDto[];
  sendFollowUpReminderOn: Date | undefined;
  clusterMemberId: string | undefined;
  assignedTo: string | undefined;
  opportunityType: OpportunityType | undefined;
  numericId: number | undefined;
}

export interface OneWayInOpportunityCreateDto {
  clusterId: string;
  oneWayInId: string;
  title: string;
  municipality: string;
  customerName: string | undefined;
  organizationName: string | undefined;
  organizationNumber: string | undefined;
  submittedOn: Date | undefined;
}

export interface AddAdvisorNotificationEmailDto {
  handlersName: string;
}

export interface OneWayInOpportunityStatusCreateDto {
  /** Internal ID */
  oneWayInOpportunityId: string;
  referenceClusterId: string | undefined;
  description: string | undefined;
  status: OneWayInStatus;
  closedReason: OneWayInClosedReason | undefined;
  registeredServices: string[];
  recommendedServices: string[];
  clusterUserId: string | undefined;
  clusterContactId: string | undefined;
  handlersName: string | undefined;
  sendFollowUpReminderOn: Date | undefined;
  admittedToProgram: boolean | undefined;
  sivaPhase: SivaPhase | undefined;
  deliveredOn: Date | undefined;
}

export interface BatchArchiveOpportunityDto extends OneWayInOpportunityStatusCreateDto {
  oneWayInId: string;
  municipality: string;
  title: string;
  customerName: string;
  submittedOn: Date | undefined;
  organizationName: string | undefined;
  organizationNumber: string | undefined;
}

export interface OneWayInRecommendation {
  opportunityStatusCreate: OneWayInOpportunityStatusCreateDto;
  serviceRecommendation: ServiceRecommendationDtoV2;
  sharedStatusCreate: CreateSharedStatusDto | undefined;
}

export interface ServiceRecommendationDtoV2 {
  recipientEmail: string;
  recipientName: string;
  comment: string;
  senderName: string;
  senderOrganisation: string;
  sendToCustomer: boolean;
  sendToActor: boolean;
}

export interface CreateSharedStatusDto {
  receivingClusterIds: string[];
  sendToActor: boolean;
  sendToCustomer: boolean;
  customerReceivingEmailAddresses: string[];
  actorEmail: OpportunityShareEmail;
  customerEmail: OpportunityShareEmail;
  customerName: string | undefined;
  handlersName: string | undefined;
  description: string | undefined;
}

export interface OpportunityShareEmail {
  message: string;
}

export interface ActorWithAccessToOpportunityDto {
  clusterId: string;
  clusterName: string;
  status: OneWayInStatus;
}

export interface OpportunityEmail {
  body: string;
  createdOn: Date | undefined;
  recipient: EmailContact;
  sender: EmailContact;
  subject: string;
  isAutomaticReply: boolean;
}

export interface EmailContact {
  emailAddress: string;
  name: string;
}

export interface OpportunityReferral {
  referrerName: string;
  recommendedServices: Tjeneste[];
  forwardedFromMunicipalityCode: string | undefined;
}

export interface Tjeneste {
  id: string;
  navn: string | undefined;
}

export interface SharedOpportunityFormLinkDto {
  link: string;
  returnToActor: boolean;
}

export interface SendEmailToCustomerDto {
  threadId: number | undefined;
  opportunityId: string | undefined;
  recipientEmail: string;
  bodyText: string;
}

export interface OpportunityEmailThreadListDto {
  recipientEmail: string;
  title: string;
  createdOn: Date;
  numericId: number;
  originalMessage: string;
}

export interface OpportunityEmailThreadDto {
  numericId: number;
  recipientEmail: string;
  title: string;
  emails: OpportunityEmailDto[];
}

export interface OpportunityEmailDto {
  sender: OpportunityEmailSender;
  bodyText: string;
}

export enum OpportunityEmailSender {
  Cluster = 'Cluster',
  Recipient = 'Recipient',
}

export interface OneWayInPublicStatisticsDto {
  numDeliveredServices: number;
  numForwarded: number;
  numReceivedCorrect: number;
  numOpportunities: number;
  serviceDeliveryMap: { [key: string]: ServiceRecommendationCount };
  statusMap: { [key in keyof typeof OneWayInStatus]?: number };
}

export interface ServiceRecommendationCount {
  recommended: number;
  delivered: number;
  serviceName: string;
}

export interface OneWayInFeedbackDto {
  id: string;
  clusterId: string;
  clusterName: string | undefined;
  oneWayInOpportunityD365Id: string;
  wasCorrectlyReferred: boolean;
  comment: string | undefined;
  suggestedActors: string[] | undefined;
  title: string | undefined;
  municipality: string | undefined;
  county: string | undefined;
  isAutomatic: boolean;
}

export interface OneWayInFeedbackCollectionDto {
  actorFeedback: OneWayInFeedbackDto | undefined;
  otherFeedbacks: OneWayInFeedbackDto[];
}

export interface OneWayInFeedbackUpsertDto {
  id: string | undefined;
  clusterId: string;
  oneWayInOpportunityD365Id: string;
  wasCorrectlyReferred: boolean;
  comment: string | undefined;
  suggestedActors: string[] | undefined;
  title: string | undefined;
  municipality: string | undefined;
  county: string | undefined;
  isAutomatic: boolean | undefined;
}

export interface OneWayInServiceSearchCriteria {
  clusterId: string | undefined;
}

export interface OneWayInServiceProviderDto {
  id: string;
  name: string | undefined;
  clusterStatusName: string | undefined;
  clusterStatusCode: string | undefined;
  emailAddress: string | undefined;
  county: string | undefined;
  municipalities: string[];
  vmaNames: string[];
  deliveryTypes: DeliveryType[];
  portfolioIndustries: PortfolioIndustryDto[] | undefined;
}

export interface OneWayInServiceUpsertDto {
  clusterId: string | undefined;
  id: string | undefined;
  description: string | undefined;
  customerDescription: string | undefined;
  name: string | undefined;
  businessId: string | undefined;
  businessName: string | undefined;
  internalUrl: string | undefined;
  contactName: string | undefined;
  contactEmail: string | undefined;
  contactPhone: string | undefined;
  servicePurpose: string | undefined;
  applicationDeadline: Date | undefined;
  validFrom: Date | undefined;
  validTo: Date | undefined;
  districtPolicyArea: boolean | undefined;
  companyAge: CompanyAgeCriteria | undefined;
  innovationLevel: InnovationLevelCriteria | undefined;
  categoryCode: ServiceCategoryCode | undefined;
  keywords: string[];
  municipalities: string[];
  counties: string[];
  externalLinks: OwiExternalLinkDto[];
  companySize: CompanySizeCriteria[];
  sponsors: Sponsor[];
  deliveryTypes: DeliveryType[];
  deliveryDescription: string | undefined;
  hasUserFee: boolean | undefined;
  userFeeComments: string | undefined;
  selectedEeaArticles: ServiceEeaArticleUpsertDto[];
  eeaComments: string | undefined;
  customerSegment: CustomerSegmentTargetGroup[];
  customerSegmentComments: string | undefined;
  state: PublicationState | undefined;
}

export interface ServiceEeaArticleUpsertDto {
  eeaArticleId: string;
}

export interface OneWayInVMA {
  id: string;
  tittel: string;
  isBusinessSupportOrganization: boolean;
}

export interface OperationApplicationStatisticsDto {
  selfEffortTotal: number;
  selfEffortApplicationSum: number;
  selfEffortHoursCount: number;
  defaultClusterTimeRate: number;
  eventsCount: number;
  activitiesWithEventsCount: number;
  contactsWithApprovedSelfEffortCount: number;
}

export interface OperationApplicationDto {
  id: string;
  clusterId: string;
  caseNumber: string | undefined;
  activityResultsDescription: string | undefined;
  operationalYear: number;
  status: OperationApplicationStatus;
  focusNextYear: string | undefined;
  sumCostPerType: ProjectExpenseCostTotal[] | undefined;
  projects: OperationProjectDto[];
  mainGoals: OperationApplicationMainGoalDto[];
  focusAreas: OperationApplicationFocusAreaDto[];
  socialEnvironmentalEffects: OperationApplicationSocialEnvironmentalEffectDto[];
  finances: OperationApplicationFinanceDto[];
}

export enum OperationApplicationStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Completed = 'Completed',
}

export interface ProjectExpenseCostTotal {
  title: string;
  sumApplicant: number;
  sumParticipant: number;
}

export interface OperationProjectDto extends ProjectsDto {
  projectType: ProjectTypeDto;
  goalDescription: string | undefined;
  operationApplicationId: string;
}

export interface OperationApplicationMainGoalDto {
  id: string;
  operationApplicationId: string;
  mainGoalId: string;
  description: string;
}

export interface OperationApplicationFocusAreaDto {
  id: string;
  operationApplicationId: string;
  focusAreaId: string;
  description: string;
}

export interface OperationApplicationSocialEnvironmentalEffectDto {
  id: string;
  operationApplicationId: string;
  socialEnvironmentalEffectId: string;
  additionalComments: string | undefined;
}

export interface OperationApplicationFinanceDto {
  id: string;
  operationApplicationId: string;
  financingSourceId: string | undefined;
  customName: string | undefined;
  amount: number;
}

export interface OperationProjectListItemDto extends ProjectListItemDto {
  projectType: ProjectTypeDto;
  operationApplicationId: string;
}

export interface PortalProjectListItemDto extends ProjectListItemDto {
  projectCategory: ProjectCategoryDto | undefined;
  customProjectCategory: CustomProjectCategoryDto | undefined;
}

export interface ProjectCategoryDto {
  id: string;
  name: string;
  code: string | undefined;
  description: string | undefined;
  isCustom: boolean;
  readMore: string | undefined;
  order: number | undefined;
  projectTypes: ProjectTypeDto[] | undefined;
}

export interface CustomProjectCategoryDto {
  id: string;
  name: string;
}

export interface PortalProjectDto extends ProjectsDto {
  projectCategory: ProjectCategoryDto | undefined;
}

export interface ProjectsCreateDto {
  /** Optionally specify id when creating a new project */
  id: string | undefined;
  name: string;
  description: string;
  clusterId: string;
  projectPhaseId: string | undefined;
  mainGoalId: string | undefined;
  focusAreaIds: string[];
  socialEnvironmentEffectIds: string[];
  startDate: Date;
  endDate: Date;
}

export interface PortalProjectCreateDto extends ProjectsCreateDto {
  projectCategoryId: string | undefined;
  goalDescription: string | undefined;
}

export interface ProjectsUpdateDto {
  name: string;
  description: string;
  projectPhaseId: string | undefined;
  mainGoalId: string | undefined;
  focusAreaIds: string[];
  socialEnvironmentEffectIds: string[];
  startDate: Date;
  endDate: Date;
  projectEndReason: ProjectEndReasonCreateDto | undefined;
}

export interface PortalProjectUpdateDto extends ProjectsUpdateDto {
  projectCategoryId: string | undefined;
  customProjectCategoryId: string | undefined;
}

export interface AggregatedAnnualReportDto {
  totalClusters: number;
  totalReports: number;
  clustersWithoutReport: { [key: string]: string };
  resourceBaseDetails: ResourceBaseDetails2;
  year: number;
  projectsDetails: ProjectsAndEngagementDetails2;
}

export interface ResourceBaseDetails2 {
  boardMembers: number;
  companyRepBoardMembers: number;
  womenOnBoard: number;
  onClusterManagementPayroll: number;
  clusterManagmentManYears: number;
  womenInClusterManagement: number;
  totalMembers: number;
  totalClusterAssosiatedMembers: number;
  totalMembersByType: ObjectCount[];
}

export interface ProjectsAndEngagementDetails2 {
  totalEvents: number;
  uniqueEventParticipants: number;
  totalProjectFouFinances: number;
  totalEuFinances: number;
  newInternationalEvents: number;
  applicationProjectsDetails: ApplicationProjectsDetails2;
  portalProjectsDetails: PortalProjectsDetails2;
}

export interface ProjectsDetails2 {
  internationalCollaborations: number;
  internationalFouCollaborations: number;
  newClusterCollaborations: number;
  internationalClusterCollaborations: number;
}

export interface ApplicationProjectsDetails2 extends ProjectsDetails2 {
  trainingProjects: number;
  educationalOperationsProjects: number;
  conferenceParticipationProjects: number;
  internationalMarketsKnowledgeProjects: number;
  internationalMarketPositionsDevelopmentProjects: number;
  innovationCooperationProjects: number;
  feasibilityStudyProjects: number;
  investmentsProjects: number;
}

export interface PortalProjectsDetails2 extends ProjectsDetails2 {
  internationalizationProjects: number;
  competenceDevelopmentProjects: number;
  innovationCollaborationProjects: number;
  customProjects: number;
  newEstablishmentsSupportedByCluster: number;
  newJobsCreated: number;
}

export interface CustomProjectCategoryCreateDto {
  name: string;
}

export interface CustomProjectCategoryUpdateDto {
  name: string;
}

export interface ProjectExpenseDto {
  id: string;
  expenseTypeId: string | undefined;
  expenseType: ExpenseTypeDto | undefined;
  projectId: string;
  title: string | undefined;
  applicantOrganisationAmount: number;
  participantOrganisationAmount: number;
  isActive: boolean;
}

export interface OperationResultOfProjectExpenseDto {
  data: ProjectExpenseDto | undefined;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

export interface ProjectExpenseUpdateDto {
  id: string;
  expenseTypeId: string | undefined;
  projectId: string;
  title: string | undefined;
  applicantOrganisationAmount: number;
  participantOrganisationAmount: number;
  isActive: boolean;
}

export interface ProjectFinanceDto {
  id: string;
  projectId: string;
  financingSourceId: string | undefined;
  financingSource: FinancingSourceDto | undefined;
  customName: string | undefined;
  amount: number;
  isActive: boolean;
}

export interface OperationResultOfProjectFinanceDto {
  data: ProjectFinanceDto | undefined;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

/** Dto for either updating financing source or creating new custom source. */
export interface ProjectFinanceListUpdateDto {
  finances: ProjectFinanceWithoutActive[];
}

export interface ProjectFinanceWithoutActive {
  id: string | undefined;
  financingSourceId: string | undefined;
  customName: string | undefined;
  amount: number;
}

export interface ProjectMemberDto {
  id: string;
  projectId: string;
  clusterMemberId: string;
  clusterMember: ClusterMemberDto;
}

export interface ProjectPropertyBaseTypes {
  phases: ProjectPhaseDto[];
  types: ProjectTypeDto[];
  categories: ProjectCategoryDto[];
  socialEnvironmentalEffects: SocialEnvironmentalEffectDto[];
  endCategories: ProjectEndCategoryDto[];
  endSubCategories: ProjectEndSubCategoryDto[];
}

export interface ProjectPropertyTypes extends ProjectPropertyBaseTypes {
  customCategories: CustomProjectCategoryDto[];
}

export interface SocialEnvironmentalEffectDto {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
}

export interface ReleaseNoteDto {
  id: string;
  title: string;
  body: string;
  validFrom: Date;
  entries: ReleaseNoteEntryDto[] | undefined;
  createdOn: Date;
  modifiedOn: Date | undefined;
  likes: number;
  userHasLikedThisReleaseNote: boolean;
}

export interface ReleaseNoteEntryDto {
  id: string;
  title: string;
  body: string;
}

export interface ExtendedSelfDeclarationDto extends SelfDeclarationDto {
  numericId: number;
  phase: SivaPhase | undefined;
}

export interface SelfDeclarationUpdateDto {
  selfDeclarationDelivered: boolean;
  selfClassification: SelfClassification[] | undefined;
  financialYear: number;
  organizationNumber: string | undefined;
  sivaContractId: string | undefined;
  deliveredDate: Date | undefined;
}

export interface ServiceTemplateDto {
  id: string;
  name: string;
  description: string | undefined;
  customerDescription: string | undefined;
  servicePurpose: string | undefined;
  companyAge: CompanyAgeCriteria | undefined;
  innovationLevel: InnovationLevelCriteria | undefined;
  companySizes: CompanySizeCriteria[] | undefined;
  keywords: string[] | undefined;
  externalLinks: OwiExternalLinkDto[] | undefined;
  districtPolicyArea: boolean | undefined;
  deliveryTypes: DeliveryType[] | undefined;
  deliveryDescription: string | undefined;
  sponsors: Sponsor[] | undefined;
  selectedEeaArticles: string[] | undefined;
  eeaComments: string | undefined;
}

export interface GoalAccomplishmentUpsertDto {
  id: string | undefined;
  goalTemplateId: string;
  sivaClusterDetailsId: string;
  expectedValue: number;
  sivaComment: string | undefined;
  clusterComment: string | undefined;
  isApproved: boolean;
}

export interface GoalAccomplishmentReportDto {
  id: string;
  value: number;
}

export interface SivaGoalsDetailsDto {
  id: string;
  clusterId: string;
  clusterName: string;
  clusterStatusId: string;
  clusterStatusName: string;
  goalsStatus: SivaGoalsStatus;
  updatedAt: Date;
  goalAccomplishments: GoalAccomplishmentDto[];
  year: number;
}

export interface GoalReviewDto {
  sivaComment: string | undefined;
  isApproved: boolean;
}

export interface SivaBudgetDetailsDto {
  id: string;
  clusterId: string;
  clusterName: string;
  clusterStatusId: string;
  clusterStatusName: string;
  budgetStatus: SivaBudgetStatus | undefined;
  sivaBudgetAttachments: SivaBudgetAttachmentDto[];
  year: number | undefined;
}

export enum SivaBudgetStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  ChangeRequested = 'ChangeRequested',
}

export interface EsaReportingAggregatedDto {
  clusterName: string;
  clusterId: string;
  statusProgramHint: string;
  spentArt28: number;
  spentArt28PreInc: number;
  reportingCompleted: boolean;
  reportingYearOpen: boolean;
}

export interface SivaEsaReportingDto {
  date: Date;
  id: string | undefined;
  invoiceNumber: string | undefined;
  marketValue: number;
  invoicedDeductible: number;
  sivaPhase: SivaPhase;
  sivaContractNumericalId: number;
  /** Name of the company associated with this invoice. This property will be ignored during upsert. */
  sivaContractName: string | undefined;
}

export interface SivaInnovationFundsDto {
  /** Transferred, unused article 28 funds from last year ear-marked for pre incubation. */
  preIncTransferred: number | undefined;
  /** Ordinary article 28 funds ear-marked for pre incubation. */
  preIncOrdinary: number | undefined;
  /** Top financing funds article 28 ear-marked for pre incubation. */
  preIncTop: number | undefined;
  /** Other article 28 funds ear-marked for pre incubation. */
  preIncOther: number | undefined;
  /** Transferred, unused article 28 funds from last year for all other phases. */
  transferred: number;
  /** Ordinary article 28 funds. */
  ordinary: number;
  /** Top financing funds article 28. */
  top: number;
  /** Other article 28 funds. */
  other: number;
  ordinaryOperationAndAdministration: number | undefined;
  topOperationAndAdministration: number | undefined;
  otherOperationAndAdministration: number | undefined;
}

export interface SivaInnovationFundsOverviewDto {
  clusterId: string;
  clusterName: string;
  typeOfCompany: string;
  sumPreIncubation: number | undefined;
  sumOtherPhases: number | undefined;
  totalSum: number | undefined;
}

export interface StatusProgramDto {
  id: string;
  name: string;
  description: string | undefined;
  clusterManagerId: string | undefined;
  clusterStatuses: ClusterStatusListItem[];
}

export interface ClusterStatusListItem {
  id: string;
  name: string | undefined;
  code: string | undefined;
  description: string | undefined;
  operationsApplicationFrame: number | undefined;
  developmentApplicationFrame: number | undefined;
  totalApplicationFrame: number | undefined;
}

export interface GoalCategoryWithTargetNumbersDto {
  goalCategory: GoalCategoryDto;
  targetNumbers: TargetNumberValueExtendedDto[];
}

export interface TargetNumberValueExtendedDto {
  targetNumberValueDto: TargetNumberValueDto | undefined;
  goalDetailDto: GoalDetailDto;
  goalTemplateId: string;
  propertyKey: PropertyKey;
}

export interface TimeEntryDto {
  id: string;
  clusterContactId: string | undefined;
  eventId: string;
  projectId: string;
  projectName: string;
  clusterContactName: string;
  clusterMemberName: string | undefined;
  clusterContactEmailAddress: string;
  eventName: string;
  clusterMemberId: string | undefined;
  clusterMemberCategoryId: string | undefined;
  description: string | undefined;
  hours: number;
  hourRate: number;
  source: TimeEntrySource;
  status: TimeEntryStatus;
  createdOn: Date;
  reportedDate: Date;
  eventStartDate: Date;
  clusterContactStatus: ClusterContactStatus | undefined;
  workGroupName: string | undefined;
  workGroupId: string | undefined;
}

export enum TimeEntrySource {
  Import = 'Import',
  Link = 'Link',
  Manual = 'Manual',
}

export enum TimeEntryStatus {
  Counting = 'Counting',
  NonCounting = 'NonCounting',
  PendingApproval = 'PendingApproval',
}

export interface OperationResultV2OfTimeEntryDtoAndTimeEntryUpsertDto {
  id: string | undefined;
  data: TimeEntryDto | undefined;
  request: TimeEntryUpsertDto | undefined;
  status: HttpStatusCode;
  message: string;
  traceId: string | undefined;
}

export interface TimeEntryUpsertDto {
  id: string | undefined;
  clusterContactId: string | undefined;
  eventId: string;
  reportedDate: Date | undefined;
  description: string | undefined;
  hours: number;
  hourRate: number;
  status: TimeEntryStatus;
  source: TimeEntrySource;
  workGroupId: string | undefined;
}

export interface TimeRateUpdateDto {
  name: string | undefined;
  hourRate: number;
}

export interface TimeRateCreateDto {
  name: string | undefined;
  hourRate: number;
  clusterId: string;
}

export interface UserDto {
  id: string;
  hashedB2CId: string;
  isGlobalAdmin: boolean;
  /** The date when the user last logged in to the portal.
Will be ignored on create */
  lastLoginDate: Date | undefined;
  /** The date when the user was logged in to the portal before LastLoginDate.
Will be ignored on create */
  previousLoginDate: Date | undefined;
  portalTermsConsentDate: Date;
  clusterUsers: ClusterUserDto[];
  role: RoleDto | undefined;
}

export interface UserCreateDto {
  b2CId: string;
  roleId: string | undefined;
}

export interface UserUpdateDto {
  portalTermsConsentDate: Date | undefined;
  roleId: string | undefined;
}

export interface PermissionDtoV2 {
  permissions: { [key: string]: Operation };
}

export interface WorkGroupDto {
  id: string;
  name: string;
  description: string | undefined;
  clusterId: string;
  responsibleContactId: string | undefined;
  isActive: boolean;
  clusterContacts: ClusterContactDto[];
}

export interface WorkGroupUpdateDto {
  name: string;
  description: string | undefined;
  clusterId: string;
  responsibleContactId: string | undefined;
  isActive: boolean;
  clusterContactIds: string[];
}

export interface WorkGroupCreateDto {
  name: string;
  description: string | undefined;
  clusterId: string;
  responsibleContactId: string | undefined;
  isActive: boolean;
  clusterContactIds: string[];
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
